import {VueController} from '@/service/support/vuex-controller';
import vaultService from '@/service/vault-service';
import JSZip from "jszip";
import FileSaver from "file-saver";
import * as awsVars from '../config/aws-exports';
import moment from "moment";
import uuid from 'uuid';
import toMaterialStyle from 'material-color-hash';
import {EventBus} from "@/service/support/event-bus";
import Auth from "@aws-amplify/auth";
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import "vue-pdf-app/dist/icons/main.css";
import WebViewer from '../components/WebViewer.vue'
import VTextFieldAsync from "../components/VTextFieldAsync";
import WorkflowTimeline from "../components/WorkflowTimeline.vue";
import { VueEditor } from "vue2-editor";
import variables from '../assets/scss/_variables.scss';
import VideoChat from "../components/VideoChat.vue";
import webrtcService from "@/service/webrtc-service";
import SendForSignature from '../components/SendForSignature.vue';
import PdfSignatureStatus from '../components/PdfSignatureStatus.vue';
import ShieldSpinner from '../components/ShieldSpinner.vue';
// Import the UMD dist directly: the docx-preview package.json only declares
// an "exports" map, which webpack 4 does not understand.
import { renderAsync as renderDocxAsync } from "docx-preview/dist/docx-preview.js";
import * as XLSX from "xlsx";

let awsmobile = awsVars.default(process.env);
const ALLOWED_FILETYPES = ['png', 'jpg', 'jpeg', 'bmp', 'tiff', 'pdf', 'gif', 'docx', 'pptx', 'xlsx'];

export default VueController("Portal", {
	components: {
		WebViewer,
		videoPlayer,
		VTextFieldAsync,
		VueEditor,
		WorkflowTimeline,
		VideoChat,
		SendForSignature,
		PdfSignatureStatus,
		ShieldSpinner
	},
	data() {
		return {
			variables,
			publicPath : process.env.BASE_URL,
			// Taxi file push (summary/TAXI_FILE_PUSH_SPEC.md): ledger rows for this portal, keyed by file_id
			taxiDeliveries: [],
			taxiDeliveriesByFile: {},
			taxiLinkVerifying: false,
			taxiResending: {},
			tab: null,
			value: 1,
			viewMode: 0,
			filesSortBy: "name",
			filesSortDesc: false,
			taskViewMode: 0,
			taskDueDateMenu: false,
			numRecentLoaded: 50,
			taskDueDateEditMenu: false,
			originalVaultName: "",
			recentActivityViewMode: 0,
			showPermissionDetails: false,
			pdfViewerFormDirty: false,
			vaultTokenLoaded: false,
			initialFileFromUrlProcessed: false,
			autojoinCallProcessed: false,
			startCallProcessed: false,
			lastTaskIdFromUpload: null,
			showingDeleted: false,
			invitationLoading: false,
			vaultNameEditing: false,
			showRecentPanel: false,
			userVaultPermissions: {
				view_files: false,
				upload_files: false,
				rename_files: false,
				delete_files: false,
				manage_perms: false,
				create_vault: false,
				access_vault: false
			},
			selectedNotificationEmails: [],
			defaultNotificationEmailMessage: `<p>The following files have been recently uploaded to the Portal "{{portalName}}".</p><p>{{selectedFiles}}</p>Please visit your portal to download these files here: <a href="{{portalUrl}}">{{portalUrl}}</a><p>`,
			defaultTaskNotificationEmailMessage: `<p>Please complete the following tasks for Portal "{{portalName}}".</p><p>{{openTasks}}</p>Please visit your portal to review and complete these tasks here: <a href="{{portalUrl}}">{{portalUrl}}</a><p>`,
			newNotificationEmailMessage: "",
			editedEmailMessage: "",
			composeNotificationTab: 0,
			composerEmail: [
				['bold', 'italic', 'underline', 'strike'],        // toggled buttons
				[{ 'header': 1 }],               // custom button values
				[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
				[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
				[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
				[{ 'align': [] }],
				['link'],
				['clean']                                         // remove formatting button
			],
			memberVaultPerms: [],
			notificationSearch: "",
			auditFilterSelection: ['Invite Guest','Portal Terms Accepted','Download','Upload','Copy','Move','Rename','Delete', 'PDF Form Filled', 'PDF Signed', 'File Comment'],
			// Kept in data (not inline in the template) so the chip group doesn't re-render on every change
			auditFilterOptions: [
				{text: 'Open Portal', icon: 'mdi-login-variant'},
				{text: 'Invite Guest', icon: 'mdi-account-plus-outline'},
				{text: 'Portal Terms Accepted', icon: 'mdi-file-check-outline'},
				{text: 'Download', icon: 'mdi-download-outline'},
				{text: 'Upload', icon: 'mdi-upload-outline'},
				{text: 'Copy', icon: 'mdi-content-copy'},
				{text: 'Move', icon: 'mdi-folder-move-outline'},
				{text: 'Rename', icon: 'mdi-rename-box'},
				{text: 'Delete', icon: 'mdi-delete-outline'},
				{text: 'PDF Form Filled', icon: 'mdi-form-select'},
				{text: 'PDF Signed', icon: 'mdi-draw'},
				{text: 'File Comment', icon: 'mdi-comment-text-outline'},
				{text: 'Reminder', icon: 'mdi-bell-outline'},
				{text: 'Email', icon: 'mdi-email-outline'}
			],
			auditSearch: "",
			newFolderName: "",
			tokenRefreshTimer: null,
			recentActivitySelected: {},
			fileRefreshTimer: null,
			currentFolderFile: null,
			copyFileMode: false,
			taskDateMenu: false,
			filePreviewMode: false,
			filePreviewImage: null,
			selectedFileToPreview: null,
			selectedPreviewFileUrl: null,
			selectedFileUrlTarget: null,
		selectedPreviewFileText: "",
		selectedPreviewFileUrlXfdf: null,
		selectedFileToPreviewIndex: 0,
		loadingSave: false,
		previewToolMode: "none",
		pdfSignatureInfo: null,
		previewOfficeLoading: false,
		previewOfficeError: null,
		xlsxPreviewSheets: [],
		xlsxPreviewTab: 0,
			videoPlayerOptions: {
				language: 'en',
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				height: 600,
				sources: [],
				autoplay: true,
				fluid: true,
				muted: true
			},
			selectedTreeFolder: [],
			open: ['public'],
			files: {
				html: 'mdi-language-html5',
				js: 'mdi-nodejs',
				json: 'mdi-code-json',
				md: 'mdi-language-markdown',
				pdf: 'mdi-file-pdf',
				png: 'mdi-file-image',
				txt: 'mdi-file-document-outline',
				xls: 'mdi-file-excel',
			},
			invitees: [
				{
					email: '',
					name: ''
				}
			],
			inviteAuthType: 'password',
			inviteMode: 'none',
			inviteModeOptions: [
				{text: 'None - general portal invitation', value: 'none'},
				{text: 'Upload - guest sends you documents', value: 'upload'},
				{text: 'Download - guest receives your documents', value: 'download'},
				{text: 'Sign Documents - guest reviews and signs documents', value: 'sign'}
			],
			customInviteMessage: '',
			// Deferred password setup (invited guests)
			passwordBannerDismissed: false,
			passwordSetupDialog: false,
			passwordSetupLoading: false,
			passwordSetupError: "",
			newPortalPassword: "",
			newPortalPasswordCheck: "",
			// First-vault-open invited action prompt
			firstActionDialog: false,
			firstOpenActionProcessed: false,
			// When terms acceptance is required, the first-action prompt is held
			// back until the guest agrees to the terms.
			firstActionWaitingOnTerms: false,
			// Multi-page document scan (camera capture -> single PDF)
			scanDialog: false,
			scanStep: "capture",
			scanPages: [],
			scanFileName: "",
			scanSuggesting: false,
			scanAssembling: false,
			scanProcessingPage: false,
			// Demo portal video (demo orgs only): auto-plays after the prospect's
			// first download, with guarantee CTA + booking link.
			demoOrgInfo: null,
			demoVideoDialog: false,
			demoVideoPlayerOptions: {
				language: 'en',
				sources: [],
				autoplay: true,
				fluid: true,
				muted: false
			},
			joinInvitees: [
				{
					email: '',
					name: ''
				}
			],
			joinInviteSelectedGuests: [],
			joinInviteLoading: false,
			breadcrumbs: [{
				name: "Home Folder",
				id: null
			}],
			currentDirectory: '/',
			queuePaused: true,
			displayFilesForPath: [],
			vaultFiles: [],
			selectedFiles: [],
			innerDragFiles: [],
			isInnerDragging: false,
			comments: {},
			perms: [],
			logoBucket: null,
			snackBar: false,
			snackBarType: "",
			snackBarNotify: "",
			vault: null,
			vaultToken: null,
			vaultTasks: [],
			taskCalendarFocus: '',
			colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
			taskDueDates: [],
			thumbBucket: null,
			mobileActionsMenu: {
				items: [
					{title: 'Click Me'},
					{title: 'Click Me'},
					{title: 'Click Me'},
					{title: 'Click Me 2'},
				],
				disabled: false,
				absolute: false,
				openOnHover: false,
				value: false,
				closeOnClick: true,
				closeOnContentClick: true,
				offsetX: false,
				offsetY: true,
			},
			isDragging: false,
			uploadRunnerTimer: null,
			auditHistory: [],
			uploadInProgress: false,
			permissionHeaders: [
				{text: "Name", align: 'start', sortable: true, value: 'user_name', width: "160px"},
				{text: "Email", value: 'user_email'},
				{text: "Access Portal", value: "access_vault", width: "60px", sortable: false},
				{text: "View Files", value: "view_files", width: "60px", sortable: false},
				{text: "Rename Files", value: "rename_files", width: "60px", sortable: false},
				{text: "Delete Files", value: "delete_files", width: "60px", sortable: false},
				{text: "Upload Files", value: "upload_files", width: "60px", sortable: false},
				{text: "Upload Notifications", value: "upload_notification", width: "80px", sortable: false},
				{text: "Download Notifications", value: "download_notification", width: "80px", sortable: false},
				{text: "Invitation", value: "invitation_accepted", width: "170px", sortable: false}
			],
			mainTaskHeaders: [
				{text: "Completed", sortable: true, value: 'status', width: "1%"},
				{text: "Task Name", sortable: true, value: 'name', width: "120px"},
				{text: "Due Date", value: 'due_date', width: "120px", sort: this.tasksFullTableSort},
			],
			taskTabHeaders: [
				{text: "Completed", sortable: true, value: 'status', width: "1%"},
				{text: "Task Name", sortable: true, value: 'name'},
				{text: "Client Response", value: 'clientResponse', width: "200px"},
				{text: "Attached Files", value:'attached_files',width:"200px"},
				{text: "Due Date", value: 'due_date', width: "120px", sort: this.tasksFullTableSort},
			],
			auditHistoryHeaders: [
				{text: "Date", align: 'start', sortable: true, value: 'action_date', width: "150px"},
				{text: "User", value: "username", width: "200px"},
				{text: "Action", value: 'action', width: "190px"},
				{text: "Details", value: "filename", sortable: false}
			],
		modals: {
			inviteGuests: false,
			inviteToJoin: false,
			manageGuestPerms: false,
			createFolder: false,
			createTask: false,
			renameFile: false,
			moveFile: false,
			auditHistory: false,
			viewEmailRecord: false,
			deleteConfirmation: false,
			recentActivity: false,
			sendForSignature: false
		},
		selectedEmailRecord: null,
		sendForSignaturePreselectedFile: null,
			progress: {
				deleteConfirmation: false,
				inviteGuests: false,
				manageGuestPerms: false,
				createFolder: false,
				createTask: false,
				renameFile: false,
				moveFile: false,
				auditHistory: false,
				resendInvitation: false,
				recentActivity: false,
				recentActivitySending: false,
				recentActivityDownloading: false
			},
			renameFilenameValue: "",
			fileToRename: null,
			fileCopyMode: false,
			fileCopyMoveDestination: "",
			fileSearch: "",
			loadingFiles: true,
			termsDialog: false,
			termsAndConditions: "",
			newTask: {
				title: "",
				description: "",
				due_date_formatted: "",
				due_date: null,
				status: "Open"
			},
			newTaskTitleRules: [v => !!v || 'This field is required'],
			newComment: "",
			auditTablePage: 1,
			auditTableItemsPerPage: 50,
			filesTablePage: 1,
			filesTablePageCount: 0,
			filesTableItemsPerPage: 100,
			
			// File Accumulator properties
			fileAccumulator: {
				isVisible: false,
				isMinimized: false,
				recentFiles: [],
				customMessage: "",
				subject: "",
				selectedEmails: [],
				autoShow: true,
				lastClosedTimestamp: null,
				sending: false
			},
			// Messages tab data
			messages: [],
			messagesLoaded: false,
			canLoadMoreMessages: false,
			loadingMoreMessages: false,
			messagesPage: 1,
			messagesPerPage: 50,
		// WebRTC data
		activeVaultUsers: [],
		presenceSubscription: null,
		presenceResubscribeTimer: null,
		presenceReconnectAttempts: 0,
		presenceReconcileTimer: null,
		// Portal "viewing" presence heartbeat (org dashboard participant counts)
		viewerSessionId: null,
		viewerPresenceTimer: null,
		isInCall: false,
		// "Present this file" in-call co-viewing session
		presenting: {
			active: false,
			isPresenter: false,
			presenterUserId: null,
			presenterName: null,
			fileId: null,
			fileName: null,
			following: true
		},
		presentingPendingState: null, // Initial presenter state queued until the viewer's document loads
		presentingPendingAnnotations: null, // Presenter's full-annotation XFDF baseline queued until the viewer's document loads
		previewLoadToken: 0, // Monotonic guard so out-of-order signed-URL resolves can't desync docUrl from selectedFileToPreview
		// Signature requests data (includes recipient info)
		signatureRequestsByFile: {}, // fileId -> array of signature requests with recipients
		fileSignatureStatus: {}, // fileId -> {total, completed, pending, requests}
		// Notification settings
		notificationSearch: "",
		// Multi-workflow system
		availableWorkflows: [],
		selectedWorkflowId: null
	};
},
	state: [
		'vaults',
		'user',
		"organization",
		'organizationId',
		"downloadProgress",
		'cognito',
		'pageIsLoading',
		'dialogs',
		'embeddedFullScreen',
		'uploadFileQueue',
		'currentUploadRequest'
	],
	beforeDestroy() {
		let self = this;

		document.removeEventListener("fileDragging", self.fileDraggingEventHandler);
		document.removeEventListener("fileLeaving", self.fileLeavingEventHandler);
		document.removeEventListener("fileDropped", self.fileDroppedEventHandler);
		document.removeEventListener("fileDownloaded", self.fileDownloadedEventHandler);
		if (self._visibilityHandler) {
			document.removeEventListener("visibilitychange", self._visibilityHandler);
			self._visibilityHandler = null;
		}
		//console.log(`Vault ${self.vault.id} before destroy.`);

		if (this.uploadRunnerTimer) {
			clearInterval(this.uploadRunnerTimer);
		}

		if (this.tokenRefreshTimer) {
			clearInterval(this.tokenRefreshTimer);
		}

		if (this.fileRefreshTimer) {
			clearInterval(this.fileRefreshTimer);
		}

		// Clean up presence subscription. Set the teardown guard first so a
		// "complete" callback from unsubscribe() can't schedule a resubscribe.
		this._presenceTeardown = true;
		if (this.presenceResubscribeTimer) {
			clearTimeout(this.presenceResubscribeTimer);
			this.presenceResubscribeTimer = null;
		}
		if (this.presenceReconcileTimer) {
			clearInterval(this.presenceReconcileTimer);
			this.presenceReconcileTimer = null;
		}
		if (this.presenceSubscription) {
			this.presenceSubscription.unsubscribe();
			this.presenceSubscription = null;
		}
		this.stopViewerPresence();

		this.currentUploadRequest = null;
		this.uploadFileQueue = [];

		window.onpopstate = null;
	},
	created() {
		let self = this;

		window.onpopstate = function(e) {
			console.log("History: " + JSON.stringify(window.history));

			let folderId = window.location.pathname.substring(window.location.pathname.indexOf("/folder/")).replace("/folder/", "");
			console.log('EARL Changed to ' + folderId);
			self.currentFolderFile = folderId === "main" ? null : self.vaultFiles.filter(file => file.id === folderId);

			self.refreshFiles(true, false, folderId !== "main" ? folderId : null);
		};

		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
		//window.addEventListener("resize", this.resizePreview);
	},
	mounted() {
		let self = this;

		document.addEventListener("fileDragging", self.fileDraggingEventHandler);
		document.addEventListener("fileLeaving", self.fileLeavingEventHandler);
		document.addEventListener("fileDropped", self.fileDroppedEventHandler);
		document.addEventListener("fileDownloaded", self.fileDownloadedEventHandler);

		// Pause/resume the file-refresh polling when the tab visibility
		// changes. Avoids hammering AppSync/DynamoDB for portals open in
		// background tabs and immediately refreshes when the user returns.
		self._visibilityHandler = function() {
			if (document.hidden) {
				if (self.$data.fileRefreshTimer) {
					clearInterval(self.$data.fileRefreshTimer);
					self.$data.fileRefreshTimer = null;
				}
			} else if (!self.$data.fileRefreshTimer && self.userVaultPermissions && self.userVaultPermissions.view_files) {
				self.refreshFiles(true, false, undefined, undefined, true);
			}
		};
		document.addEventListener("visibilitychange", self._visibilityHandler);
		//console.log("Vault activated");


		if (this.$route.params.folderid === "main") {
			self.currentFolderFile = null;
		}
		if (self.$route.query.embedded === "true" || self.$route.query.embedded === true) {
			self.embeddedFullScreen = true;
		}

		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
		let placeholderFiles = [
			{
				name: "placeholder",
				id: -1,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			},
			{
				name: "placeholder",
				id: -2,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			},
			{
				name: "placeholder",
				id: -3,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			}
		];
		this.auditHistory = [];
		this.vaultFiles = placeholderFiles;
		this.displayFilesForPath = placeholderFiles;
		this.doubleCheckUploadStatus();

		this.loadVault();
	},
	computed: {

		// Audit history rows after applying the activity-type chips and the free-text search.
		// Filtering here (rather than in a header `filter`) keeps the table's filtering out of
		// the per-cell render path and gives us a count to display.
		filteredAuditHistory() {
			const selected = this.auditFilterSelection || [];
			const search = (this.auditSearch || "").trim().toLowerCase();
			return (this.auditHistory || []).filter(entry => {
				if (selected.indexOf(entry.action) === -1) {
					return false;
				}
				if (!search) {
					return true;
				}
				return (entry._search_text || "").indexOf(search) > -1;
			});
		},
		allAuditFiltersSelected() {
			return this.auditFilterSelection.length === this.auditFilterOptions.length;
		},

		isGuestUser() {
			return !!(this.cognito && this.cognito.attributes && this.cognito.attributes["custom:mutableUserType"] === "guest");
		},

		// The caller's own invitation entry for the current portal (from User.vaults).
		// Carries invite_mode ("upload"/"download"/"sign") and first_action_completed.
		currentVaultInvitation() {
			if (!this.user || !this.user.vaults || !this.vault) {
				return null;
			}
			let vaultId = this.vault.id;
			let invitation = this.user.vaults.find(invite => invite && invite.vault_id === vaultId && invite._deleted !== 1);
			return invitation ? invitation : null;
		},

		passwordSetupDaysRemaining() {
			if (!this.user || !this.user.passwordSetupDeadline) {
				return null;
			}
			let diff = new Date(this.user.passwordSetupDeadline) - new Date();
			let days = Math.ceil(diff / (1000 * 60 * 60 * 24));
			return days > 0 ? days : 0;
		},

		// Blocking password prompt: deadline passed AND the guest has completed
		// their first upload/download in at least one portal.
		passwordSetupOverdue() {
			if (!(this.isGuestUser && this.user && this.user.passwordIsTemporary === true && this.user.passwordSetupDeadline)) {
				return false;
			}
			if (new Date(this.user.passwordSetupDeadline) > new Date()) {
				return false;
			}
			let vaults = this.user.vaults ? this.user.vaults : [];
			return vaults.some(invite => invite && invite._deleted !== 1 && invite.first_action_completed === true);
		},

		showPasswordBanner() {
			return this.isGuestUser && this.user && this.user.passwordIsTemporary === true
				&& !this.passwordBannerDismissed && !this.passwordSetupDialog;
		},

		firstActionInviteMode() {
			return this.currentVaultInvitation && this.currentVaultInvitation.invite_mode
				? this.currentVaultInvitation.invite_mode : null;
		},

		// Files offered by the first-open "download" prompt (everything shared so far).
		firstActionDownloadFiles() {
			return (this.vaultFiles || []).filter(file => file && file._deleted !== 1 && file.extension !== "fld");
		},

		// Files with an active signature request where this guest is a pending
		// recipient - offered by the first-open "sign" prompt.
		firstActionSignFiles() {
			let self = this;
			if (!self.user || !self.user.email || !self.signatureRequestsByFile) {
				return [];
			}
			let userEmail = self.user.email.toLowerCase();
			return (self.vaultFiles || []).filter(file => {
				if (!file || file._deleted === 1) {
					return false;
				}
				let requests = self.signatureRequestsByFile[file.id];
				if (!requests || requests.length === 0) {
					return false;
				}
				return requests.some(request => {
					if (!request || request.file_deleted) {
						return false;
					}
					if (request.status === 'completed' || request.status === 'cancelled'
						|| request.status === 'expired' || self.isSignatureRequestExpired(request)) {
						return false;
					}
					return request.recipients && Array.isArray(request.recipients)
						&& request.recipients.some(r => r && r.email && r.email.toLowerCase() === userEmail && r.status === 'pending');
				});
			});
		},

		// Header icon for the first-open welcome prompt, by invite mode.
		firstActionIcon() {
			if (this.firstActionInviteMode === 'download') {
				return 'fas fa-download';
			}
			if (this.firstActionInviteMode === 'sign') {
				return 'fas fa-file-signature';
			}
			return 'fas fa-upload';
		},

		// Number of DISTINCT people present, not raw sessions. A page refresh
		// leaves the old session lingering in presence (server TTL ~2 min, and
		// client-side until the next reconcile), so counting session rows
		// over-reports. De-duping by user_id keeps the "online" badge honest.
		onlineUserCount() {
			const ids = {};
			(this.activeVaultUsers || []).forEach(u => {
				if (u && u.user_id) {
					ids[u.user_id] = true;
				}
			});
			return Object.keys(ids).length;
		},

		// Existing vault guests offered for re-invite in the "Invite to Join" modal.
		existingGuestsForJoin() {
			let guests = [];
			if (this.vault && this.vault.permissions) {
				for (let i = 0; i < this.vault.permissions.length; i++) {
					let perm = this.vault.permissions[i];
					if (perm && perm._deleted !== 1 && perm.user_type === "guest" && perm.user_email) {
						guests.push({
							text: perm.user_name ? (perm.user_name + " <" + perm.user_email + ">") : perm.user_email,
							value: perm.user_email,
							name: perm.user_name || perm.user_email,
							email: perm.user_email
						});
					}
				}
			}
			return guests;
		},

		// Show the "Invite to Join" action only to users allowed to invite, while
		// they are the presenter in an active call.
		canInviteToJoinCall() {
			return this.isInCall && this.presenting && this.presenting.active &&
				this.presenting.isPresenter && this.vaultBelongsToUserOrg && this.userTypeVisibility;
		},

		// Viewer is actively following a presenter's file. While true, the
		// download/save/navigation controls are locked so the viewer can't
		// leave or alter the presented file until they choose "Browse Freely".
		isFollowingViewer() {
			return this.presenting && this.presenting.active &&
				!this.presenting.isPresenter && this.presenting.following;
		},

		customMessagePreview() {
			if (!this.customInviteMessage) {
				return '';
			}
			
			// Get open tasks for preview
			let openTasks = this.vaultTasks
				.filter(t => t.status !== "Done" && t._deleted !== 1)
				.map(t => t.title);
			
			// Get file names for preview (exclude folders)
			let fileNames = this.vaultFiles
				.filter(f => f._deleted !== 1 && f.extension !== 'fld')
				.map(f => f.name);
			
			// Format as HTML lists (escape user-controlled content to prevent XSS)
			const openTasksHtml = openTasks.length > 0 
				? '<ul>' + openTasks.map(t => '<li>' + this.escapeHtml(t) + '</li>').join('') + '</ul>'
				: '<em>No tasks assigned yet</em>';
			const fileListHtml = fileNames.length > 0
				? '<ul>' + fileNames.map(f => '<li>' + this.escapeHtml(f) + '</li>').join('') + '</ul>'
				: '<em>No files uploaded yet</em>';
			
			// Replace variables in the custom message (escape user-controlled values)
			let preview = this.escapeHtml(this.customInviteMessage)
				.replace(/\{\{portalName\}\}/g, this.escapeHtml(this.vault ? this.vault.name : 'Portal Name'))
				.replace(/\{\{orgName\}\}/g, this.escapeHtml(this.organization ? this.organization.companyName : 'Organization'))
				.replace(/\{\{openTasks\}\}/g, openTasksHtml)
				.replace(/\{\{fileList\}\}/g, fileListHtml)
				.replace(/\{\{taskCount\}\}/g, openTasks.length.toString())
				.replace(/\{\{fileCount\}\}/g, fileNames.length.toString())
				.replace(/\{\{expirationDate\}\}/g, new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString())
				.replace(/\{\{userName\}\}/g, this.escapeHtml(this.user ? this.user.displayName : 'Your Name'));
			
			return preview;
		},
		userTypeVisibility(){
			let self = this;
			let isVisible = false;
			if (self.cognito) {
				switch (self.cognito.attributes["custom:mutableUserType"]) {
					case "admin": {
						if (this.organization.permissions.find(perm => perm['manage_perms'] === true && perm.user_id === this.user.id && perm._deleted !== 1)) {
							isVisible = true;
						} else {
							isVisible = false;
						}
						break;
					}
					case "member": {
						if (self.userHasPermission('manage_perms')) {
							isVisible = true;
						} else if (!self.vault || self.vault.hide_perms) {
							isVisible = false;
						}
						break;
					}
					case "guest": {
						if (!self.vault || self.vault.hide_perms) {
							isVisible = false;
						} else {
							isVisible = true;
						}
						break;
					}
					default : {
						console.log("UserType not found defaulting to false");
						isVisible = false;
					}
				}
			}
			return isVisible;
		},
		vaultTasksFiltered() {
			return this.$data.vaultTasks;
			//return this.$data.vaultTasks.filter(task => task._deleted !== 1);
		},
		numberOfOpenTasks() {
			return this.$data.vaultTasks.filter(task => task.status !== "Done" && task._deleted !== 1).length;
		},
		numberOfDoneTasks() {
			return this.vaultTasks.filter(task => task.status === "Done" && task._deleted !== 1).length;
		},
		earliestTaskDate() {
			let self = this;
			let openDates = self.$data.vaultTasks.filter(task => task.status !== "Done" && task._deleted !== 1 && task.due_date);
			let earliestDate = -1;

			for (let i = 0; i < openDates.length; i++) {
				if (earliestDate < 0) {
					earliestDate = openDates[i].due_date;
				} else {
					let dueDate = moment(openDates[i].due_date);
					if (dueDate < moment(earliestDate)) {
						earliestDate = openDates[i].due_date;
					}
				}
			}

			return earliestDate;
		},
		uploadEmailAddresses() {
			let notificationEmails = [];
			if (this.vault && this.vault.permissions) {
				for (let i = 0; i < this.vault.permissions.length; i++) {
					let perm = this.vault.permissions[i];

					// Only include members who are not deleted AND have accepted their invitation
					if (perm._deleted !== 1 && perm.invitation_accepted === "true") {
						notificationEmails.push({
							email: perm.user_email,
							name: `${perm.user_name} <${perm.user_email}>`
						});
					}
				}
			}
			return notificationEmails;
		},
		renderedNotificationMessage() {
			let updatedValue = this.newNotificationEmailMessage;

			let selectedFilesListHtml = "";
			if (updatedValue.indexOf('selectedFiles') > -1 && this.recentActivityHasFileSelected) {
				for (let fileId in this.recentActivitySelected) {
					if (this.recentActivitySelected[fileId] === true) {
						let recentSelectedFile = this.vaultFiles.find(tmpFile => tmpFile.id === fileId);
						if (recentSelectedFile) {
							selectedFilesListHtml += `<li>${this.escapeHtml(recentSelectedFile.name)}</li>`;
						}
					}
				}

				if (selectedFilesListHtml) {
					selectedFilesListHtml = '<ul>' + selectedFilesListHtml + "</ul>";
				}
			}

			let openTaskHtml = "";
			let doneTaskHtml = "";
			for (let v = 0; v < this.vaultTasks.length; v++) {
				let task = this.vaultTasks[v];
				if (task._deleted !== 1) {
					if (task.status === "Open") {
						openTaskHtml += `<li>${this.escapeHtml(task.title)}</li>`;
					} else if (task.status === "Done") {
						doneTaskHtml += `<li>${this.escapeHtml(task.title)}</li>`;
					}
				}
			}

			if (openTaskHtml) {
				openTaskHtml = '<ul>' + openTaskHtml + '</ul>';
			}

			if (doneTaskHtml) {
				doneTaskHtml = '<ul>' + doneTaskHtml + '</ul>';
			}

			let terms = [
				{ token: "orgName", value: this.escapeHtml(this.organization ? this.organization.companyName : '') },
				{ token: "userName", value: this.escapeHtml(this.user ? this.user.displayName : '') },
				{ token: "portalName", value: this.escapeHtml(this.vault ? this.vault.name : '') },
				{ token: "portalUrl", value: this.escapeHtml(window.location.href) },
				{ token: "selectedFiles", value: selectedFilesListHtml },
				{ token: "openTasks", value: openTaskHtml },
				{ token: "doneTasks", value: doneTaskHtml }
			];

			for (let i = 0; i < terms.length; i++) {
				let term = terms[i];
				updatedValue = updatedValue.replaceAll("{{" + term.token + "}}", term.value);
				updatedValue = updatedValue.replaceAll("{{ " + term.token + " }}", term.value);
			}
			return updatedValue;
		},
		fileAccumulatorPreviewMessage() {
			let messageHtml = '';
			
			// Add custom message if provided (escape to prevent XSS)
			if (this.fileAccumulator.customMessage) {
				messageHtml += `<p>${this.escapeHtml(this.fileAccumulator.customMessage)}</p>`;
			}
			
			// Collect all files to include in the notification
			let completedUploadFiles = this.uploadFileQueue.filter(f => f.status === 'done').map(f => ({
				name: f.upload.filename,
				size: f.upload.size || 0
			}));
			
			let allCompletedFiles = [...this.fileAccumulator.recentFiles, ...completedUploadFiles];
			
			// Add file list first (escape file names to prevent XSS)
			if (allCompletedFiles.length > 0) {
				messageHtml += '<ul>';
				allCompletedFiles.forEach(file => {
					messageHtml += `<li><strong>${this.escapeHtml(file.name)}</strong></li>`;
				});
				messageHtml += '</ul>';
			}
			
			// Add portal link (escape portal name to prevent XSS)
			const portalUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
			const portalName = this.escapeHtml(this.vault ? this.vault.name : 'Portal');
			messageHtml += `<p>Portal: <a href="${this.escapeHtml(portalUrl)}">${portalName}</a></p>`;
			
			return messageHtml;
		},
		color () {
			switch (this.value) {
				case 0:
					return 'blue-grey'
				case 1:
					return 'teal'
				case 2:
					return 'brown'
				case 3:
					return 'indigo'
				default:
					return 'blue-grey'
			}
		},
		portalNotificationEmails() {
			return ["Bryan Stouffer <bstouffer@gmail.com>"]
		},
		recentActivityHasFileSelected() {
			let recentFileSelected = false;
			for (let x in this.recentActivitySelected) {
				if (this.recentActivitySelected.hasOwnProperty(x) && this.recentActivitySelected[x] === true) {
					recentFileSelected = true;
					break;
				}
			}
			return recentFileSelected;
		},
		numberUnreadFiles() {
			let self = this;
			let unreadFiles = self.vaultFiles.filter(file => (typeof file.uploaded_by_host !== 'undefined' || typeof file.downloaded_by_host !== 'undefined') && self.fileWasNotDownloaded(file));
			return unreadFiles.length;
		},
		allFilesSortedByDate() {
			//Only showing last 30 days
			let self = this;
			let now = new Date();
			return [...this.vaultFiles.sort( (a, b) => {
				let aDate = self.getLatestDate(a);
				let bDate = self.getLatestDate(b);
				//aDate = new Date(aDate);
				//bDate = new Date(bDate);
				//console.log(`aDate: ${aDate} - bDate: ${bDate} = ${aDate - bDate}`);

				return bDate - aDate;
			})]
				.filter(file => file.extension !== 'fld'); // && ((now.getTime() - self.getLatestDate(file)) < (86400000 * 30))

		},
		allFilesAndUploadsSortedByDate() {
			//Only showing last 30 days
			let self = this;
			let now = new Date();
			return [...this.vaultFiles.concat(this.uploadFileQueue).sort( (a, b) => {
				let aDate = self.getLatestDate(a);
				let bDate = self.getLatestDate(b);
				//aDate = new Date(aDate);
				//bDate = new Date(bDate);
				//console.log(`aDate: ${aDate} - bDate: ${bDate} = ${aDate - bDate}`);

				return bDate - aDate;
			})]
				.filter(file => file.extension !== 'fld'); // && ((now.getTime() - self.getLatestDate(file)) < (86400000 * 30))

		},
		todayYYmmddFormat() {
			let d = new Date();

			let month = '' + (d.getMonth() + 1);
			let day = '' + d.getDate();
			let year = d.getFullYear();
			if (month.length < 2)
				month = '0' + month;
			if (day.length < 2)
				day = '0' + day;

			return [year, month, day].join('');
		},
		allFilesGroupedByDateLoaded() {
			let partialList = [];
			let partialListCount = 0;

			for (let i = 0; i < this.allFilesGroupedByDate.length; i++) {
				let roomRemaining = this.numRecentLoaded - partialListCount;
				if (this.allFilesGroupedByDate[i].files.length >= roomRemaining) {
					let newGroup = {
						date: this.allFilesGroupedByDate[i].date,
						fieldId: this.allFilesGroupedByDate[i].fieldId
					};
					newGroup.files = this.allFilesGroupedByDate[i].files.slice(0, roomRemaining);
					partialList.push(newGroup);
					break;
				} else {
					partialListCount += this.allFilesGroupedByDate[i].files.length;
					partialList.push(this.allFilesGroupedByDate[i]);
				}
			}
			return partialList;
		},
		allFilesGroupedByDate() {
			//numRecentLoaded
			let now = new Date();
			let dateYYmmddFormat = function(d) {
				let month = '' + (d.getMonth() + 1);
				let day = '' + d.getDate();
				let year = d.getFullYear();
				if (month.length < 2)
					month = '0' + month;
				if (day.length < 2)
					day = '0' + day;

				return [year, month, day].join('');
			};
			let sortedFiles = this.allFilesAndUploadsSortedByDate;
			let dateMap = {};
			dateMap[dateYYmmddFormat(now)] = {
				files: [],
				date: now.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
				fieldId: dateYYmmddFormat(now)
			};

			for (let sf = 0; sf < sortedFiles.length; sf++) {
				let d = new Date(parseInt(this.getLatestDate(sortedFiles[sf])));
				let fileDateString = dateYYmmddFormat(d);
				if (sortedFiles[sf]._deleted !== 1) {
					if (!dateMap.hasOwnProperty(fileDateString)) {
						dateMap[fileDateString] = {
							files: [],
							date: d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
							fieldId: fileDateString
						};
					}
					dateMap[fileDateString].files.push(sortedFiles[sf]);
				}
			}
			let dateMapArray = [];
			for (let dmKey in dateMap) {
				if (dateMap.hasOwnProperty(dmKey)) {
					dateMapArray.unshift(dateMap[dmKey]);
				}
			}
			return dateMapArray;
		},
		imagePreviewArray() {
			return self.filePreviewImage ? [self.filePreviewImage] : [];
		},
		oneSelection() {
			return this.selectedFiles && this.selectedFiles.length === 1;
		},
		oneFileSelection() {
			return this.selectedFiles && this.selectedFiles.length === 1 && this.selectedFiles[0].extension !== "fld";
		},
		vaultBelongsToUserOrg() {
			return this.vault && this.user && this.user.memberOf === this.vault.org_id;
		},
		taxiIntegrationEnabled() {
			return Boolean(this.organization && this.organization.taxiIntegration && this.organization.taxiIntegration.enabled === true);
		},
		taxiLink() {
			return this.vault && this.vault.taxi_link ? this.vault.taxi_link : null;
		},
		taxiLinkStatus() {
			return this.taxiLink && this.taxiLink.status ? this.taxiLink.status : '';
		},
		taxiLinkDisplay() {
			const link = this.taxiLink;
			if (!link || !link.status) return null;
			switch (link.status) {
				case 'linked':
					return { color: 'success', icon: 'mdi-check-circle', text: 'Linked' + (link.display_name ? ': ' + link.display_name : '') };
				case 'verifying':
					return { color: 'grey', icon: 'mdi-progress-clock', text: 'Verifying…' };
				case 'not_found':
					return { color: 'warning', icon: 'mdi-account-question', text: 'Not found in Taxi' };
				case 'credential_rejected':
					return { color: 'error', icon: 'mdi-key-remove', text: 'Taxi credential rejected' };
				case 'error':
					return { color: 'error', icon: 'mdi-alert-circle', text: 'Error' };
				default:
					return null;
			}
		},
		mobileAndTabletCheck() {
			let check = false;
			(function(a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		},
		currentFolderTree() {
			let self = this;

			//DONE: Mark any selected folder as disabled.
			//DONE: Only show current directory and below.

			let getFoldersInFolder = function(folder) {
				let folderItem = {
					id: folder.id,
					name: folder.name,
					locked: !!self.selectedFiles.find(file => file.id === folder.id)
				};
				let subFolders = self.vaultFiles.filter(file => file.extension === "fld" && file._deleted !== 1 && file.parent_folder_file_id === folder.id);
				if (subFolders && subFolders.length > 0 && !folderItem.locked) {
					folderItem.children = subFolders.map(subFolder => {
						return {
							id: subFolder.id,
							name: subFolder.name,
							locked: !!self.selectedFiles.find(file => file.id === subFolder.id)
						};
					});
					for (let i = 0; i < subFolders.length; i++) {
						getFoldersInFolder(subFolders[i]);
					}
				}
				return folderItem;
			};

			let folderTreeBuilder = [];
			let tmpRootChildren = [];
			let rootFolders = self.vaultFiles.filter(file => file.extension === "fld" && file._deleted !== 1 && !file.parent_folder_file_id);
			for (let f = 0; f < rootFolders.length; f++) {
				let folder = rootFolders[f];
				let folderItem = getFoldersInFolder(folder);
				tmpRootChildren.push(folderItem);
			}
			folderTreeBuilder.push({
				name: "Home Folder",
				id: -1,
				locked: false,
				children: tmpRootChildren,
				open: true
			});

			return folderTreeBuilder;
		},
		responsiveFileHeaderLayout() {
			let breakpointName = this.$vuetify.breakpoint.name;
			if (this.viewMode === 1) {
				if (breakpointName !== "xs" || breakpointName !== "sm") {
					breakpointName = "md";
				} else if (breakpointName === "md") {
					breakpointName = "sm";
				}
			}
			switch (breakpointName) {
				case 'xs':
				case 'sm':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "100%"}
					];
				case 'md':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "190px"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "200px"}
					];
				case 'lg':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "50%"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "170px"},
						{text: "Size", value: "size", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "300px"}
					];
				default:
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "60%"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "170px"},
						{text: "Type", value: "extension", sortable: true, width: "150px"},
						{text: "Size", value: "size", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "300px"}
					];
			}
		},
		filteredFilesOnSearchAndDelete() {
			let files = [];
			if (this.fileSearch) {
				files = this.vaultFiles.filter(item => this.filterFilesOnSearch(item.name, this.fileSearch, item));
			} else {
				files = this.displayFilesForCurrentDirectory;
			}

			return this.customSort(files, "name", false);
		},
		filteredFilesOnlyOnSearchAndDelete() {
			let files = this.filteredFilesOnSearchAndDelete.filter(item => item.extension !== 'fld');
			return this.customSort(files, "name", false);
		},
		filteredGuestPermissions() {
			if (this.vault) {
				let guests = this.vault.permissions.filter(function(permissions) {
					return permissions.invitation_accepted.match(true) && permissions.user_type === 'guest' && permissions._deleted !== 1;
				});
				
				// Apply search filter if search term exists
				if (this.notificationSearch && this.notificationSearch.trim()) {
					const searchLower = this.notificationSearch.toLowerCase().trim();
					guests = guests.filter(member => 
						(member.user_name && member.user_name.toLowerCase().includes(searchLower)) ||
						(member.user_email && member.user_email.toLowerCase().includes(searchLower))
					);
				}
				
				return guests;
			}
			return [];
		},
		filteredMemberVaultPerms() {
			let members = this.memberVaultPerms.filter(member => member._deleted !== 1);
			
			// Apply search filter if search term exists
			if (this.notificationSearch && this.notificationSearch.trim()) {
				const searchLower = this.notificationSearch.toLowerCase().trim();
				members = members.filter(member => 
					(member.user_name && member.user_name.toLowerCase().includes(searchLower)) ||
					(member.user_email && member.user_email.toLowerCase().includes(searchLower))
				);
			}
			
			return members;
		},
		filteredPendingGuestPermissions() {
			if (this.vault) {
				return this.vault.permissions.filter(function(permissions) {
					return !permissions.invitation_accepted.match(true) && permissions.user_type === 'guest' && permissions._deleted !== 1;
				});
			}
		},
		activePermissions() {
			if (this.vault) {
				const permissions = this.vault.permissions.filter(permission => 
					permission._deleted !== 1
				);

				// Check if active user is a member/admin of the vault's organization
				const activeUserType = this.cognito && this.cognito.attributes ? 
									   this.cognito.attributes["custom:mutableUserType"] : 'guest';

				// User is considered staff if they belong to the org AND are admin/member
				const isOrgStaff = this.vaultBelongsToUserOrg && 
								   (activeUserType === 'admin' || activeUserType === 'member');

				if (isOrgStaff) {
					// Include all active permissions (guest, admin, member)
					return permissions;
				}

				// Otherwise (Guests/External), only show guests and self
				// This hides organization members/admins from guests
				return permissions.filter(permission => 
					permission.user_type === 'guest' || 
					(this.user && permission.user_id === this.user.id)
				);
			}
			return [];
		},
		
	// Workflow States computed properties
	workflowStateOptions() {
		// If vault is using new workflow system, return states from selected workflow
		if (this.vault && this.vault.workflowId && this.vault.workflow && this.vault.workflow.states) {
			return this.vault.workflow.states;
		}
		
		// Legacy: First try organization workflowStates (for admins/members)
		if (this.organization && this.organization.workflowStates && this.organization.workflowStates.length > 0) {
			return this.organization.workflowStates;
		}
		// Fallback to vault's orgWorkflowStates (for guests)
		if (this.vault && this.vault.orgWorkflowStates && this.vault.orgWorkflowStates.length > 0) {
			return this.vault.orgWorkflowStates;
		}
		return [];
	},
	
	// Available workflow states for current vault
	currentWorkflowStates() {
		if (!this.vault) return [];
		
		// If vault has a workflow assigned, use its states
		if (this.vault.workflow && this.vault.workflow.states) {
			return this.vault.workflow.states;
		}
		
		return [];
	},
	
	// Check if using new workflow system vs legacy
	isUsingNewWorkflowSystem() {
		return this.vault && this.vault.workflowId;
	},
		
	currentWorkflowStateName() {
		// Return the workflow state name, looking it up from ID if necessary
		if (!this.vault) {
			return null;
		}
		
		// New workflow system: use currentWorkflowStateName if available
		if (this.isUsingNewWorkflowSystem) {
			if (this.vault.currentWorkflowStateName) {
				return this.vault.currentWorkflowStateName;
			}
			// Lookup from currentWorkflowStateId
			if (this.vault.currentWorkflowStateId !== undefined && this.vault.workflow && this.vault.workflow.states) {
				const state = this.vault.workflow.states.find(s => s.id === this.vault.currentWorkflowStateId);
				if (state) {
					return state.name;
				}
			}
			return null;
		}
		
		// Legacy system: use workflowStateName
		// If we have the name stored directly, use it (but verify it's not orphaned)
		if (this.vault.workflowStateName && this.vault.workflowStateName !== 'Not Set') {
			// Check if this workflow state still exists in organization settings
			if (this.isCurrentWorkflowStateOrphaned) {
				return this.vault.workflowStateName + ' (Deleted)';
			}
			return this.vault.workflowStateName;
		}
		
		// Fall back to looking up the name from the ID
		// This ensures resilience when workflowStateName is missing but workflowStateId is present
		if (this.vault.workflowStateId && this.workflowStateOptions && this.workflowStateOptions.length > 0) {
			const state = this.workflowStateOptions.find(s => s.id === this.vault.workflowStateId);
			if (state && state.name) {
				return state.name;
			}
			// ID exists but state not found - it was deleted
			return 'Unknown State (Deleted)';
		}
		
		return null;
	},
		
		isCurrentWorkflowStateOrphaned() {
			if (!this.vault || !this.vault.workflowStateId || !this.organization || !this.organization.workflowStates) {
				return false;
			}
			
			// Check if the vault's workflowStateId exists in the organization's current workflow states
			const stateExists = this.organization.workflowStates.find(state => state.id === this.vault.workflowStateId);
			return !stateExists;
		},
		
		userCanEditWorkflow() {
			if (!this.cognito || !this.cognito.attributes) return false;
			
			const userType = this.cognito.attributes["custom:mutableUserType"];
			
			// Guests cannot edit workflow state
			if (userType === "guest") return false;
			
			// Admins and members can edit
			return userType === "admin" || userType === "member";
		},
		displayFilesForCurrentDirectory() {
			let filesInFolder = [];
			let folderFileId = this.currentFolderFile ? this.currentFolderFile.id : null;

			if (this.fileSearch) {
				filesInFolder = this.vaultFiles;
			} else {
				if (this.vaultFiles) {
					let tmpFiles =
						this.vaultFiles.filter(vf => vf.status !== "uploading")
							.concat(this.uploadFileQueue.filter(qf => qf.status !== "done"))
							.filter(file =>
								file.parent_folder_file_id === folderFileId ||
								(!folderFileId && !file.parent_folder_file_id)
							);
					if (tmpFiles) {
						filesInFolder = tmpFiles;
					}
				}
			}

		return filesInFolder;
	},
	filteredGuestPermissions() {
		if (!this.vault || !this.vault.permissions) return [];
		
		const search = this.notificationSearch ? this.notificationSearch.toLowerCase() : '';
		
		return this.vault.permissions.filter(member => {
			if (member._deleted === 1) return false;
			if (!this.vaultBelongsToUserOrg && (!this.user || this.user.id !== member.user_id)) return false;
			
			// Apply search filter if present
			if (search) {
				const name = member.user_name ? member.user_name.toLowerCase() : '';
				const email = member.user_email ? member.user_email.toLowerCase() : '';
				return name.includes(search) || email.includes(search);
			}
			
			return true;
		});
	},
	filteredMemberVaultPerms() {
		if (!this.memberVaultPerms) return [];
		
		const search = this.notificationSearch ? this.notificationSearch.toLowerCase() : '';
		
		return this.memberVaultPerms.filter(member => {
			if (member._deleted === 1) return false;
			
			// Apply search filter if present
			if (search) {
				const name = member.user_name ? member.user_name.toLowerCase() : '';
				const email = member.user_email ? member.user_email.toLowerCase() : '';
				return name.includes(search) || email.includes(search);
			}
			
			return true;
		});
	}
	},
	watch: {
		// Reset to page 1 when items per page changes
		filesTableItemsPerPage() {
			this.filesTablePage = 1;
		},
		auditTableItemsPerPage() {
			this.auditTablePage = 1;
		},
		auditFilterSelection() {
			this.auditTablePage = 1;
		},
		auditSearch() {
			this.auditTablePage = 1;
		},
		// Reset viewMode if tier doesn't support tasks panel
		viewMode(newValue) {
			if (newValue === 1 && this.vault && this.vault.orgTier && this.vault.orgTier !== 'enterprise' && this.vault.orgTier !== 'large firm') {
				this.viewMode = 0;
			}
		},
		'vault.orgTier'() {
			// Reset viewMode if tier changes and doesn't support tasks
			if (this.viewMode === 1 && this.vault && this.vault.orgTier && this.vault.orgTier !== 'enterprise' && this.vault.orgTier !== 'large firm') {
				this.viewMode = 0;
			}
		},
		// Apply signature status when files are loaded
		vaultFiles: {
			handler(newFiles, oldFiles) {
				// Check if we transitioned from placeholder files to real files
				const hadPlaceholders = oldFiles && oldFiles.some(f => typeof f.id === 'number' && f.id < 0);
				const hasPlaceholders = newFiles && newFiles.some(f => typeof f.id === 'number' && f.id < 0);
				
				if (hadPlaceholders && !hasPlaceholders && this.vault && this.vault.id && this.signatureRequestsByFile) {
					console.log('✅ Real files loaded, applying signature status...');
					this.applySignatureStatusToFiles();
				}
			},
			deep: false
		}
	},
	methods: {
		getInitials(name) {
			if (!name) return '?';
			const parts = name.trim().split(' ');
			if (parts.length === 1) {
				return parts[0].substring(0, 2).toUpperCase();
			}
			return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
		},
		toggleAllGuestNotifications() {
			if (!this.vault || !this.vault.permissions) return;
			
			// Check if all are enabled
			const allEnabled = this.filteredGuestPermissions.every(m => m.upload_notification);
			
			// Toggle all to opposite state
			this.filteredGuestPermissions.forEach(member => {
				if (member.upload_notification !== !allEnabled) {
					this.updateGuestPermissions(member.user_email, 'upload_notification');
				}
			});
		},
		toggleAllTeamNotifications() {
			if (!this.memberVaultPerms) return;
			
			// Check if all upload notifications are enabled
			const allUploadEnabled = this.filteredMemberVaultPerms.every(m => m.upload_notification);
			
			// Toggle all to opposite state
			this.filteredMemberVaultPerms.forEach(member => {
				if (member.upload_notification !== !allUploadEnabled) {
					this.updateGuestPermissions(member.user_email, 'upload_notification');
				}
			});
		},
		loadMoreRecentFiles() {
			this.numRecentLoaded += 50;
		},
		getInitials(name) {
			if (!name) return '?';
			const parts = name.trim().split(' ');
			if (parts.length >= 2) {
				return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
			}
			return name.substring(0, 2).toUpperCase();
		},
		fileDraggingEventHandler(event) { this.dragFile(event, true); },
		fileLeavingEventHandler(event) { this.dragFile(event, false); },
		fileDroppedEventHandler(event) { this.receiveFilesFromOutsideDrop(event); },
		fileDownloadedEventHandler(event) { this.downloadProgress.num_downloaded++; },
		startInnerDrag(event, item) {
			event.dataTransfer.dropEffect = 'copy';
			event.dataTransfer.effectAllowed = 'copy';
			if (this.selectedFiles && this.selectedFiles.length > 0) {
				this.innerDragFiles = this.selectedFiles;
			} else if (item) {
				this.innerDragFiles = [item];
			}
			this.isInnerDragging = true;
		},
		async receiveFilesFromBrowseInput(event) {
			if (event && event.target && event.target.files && event.target.files instanceof FileList) {
				//alert(JSON.stringify(event.target.file[0]));
				await this.processFilesForUpload(event.target.files, [], this.lastTaskIdFromUpload);
			} else {
				this.error("Invalid input type file event.");
			}
		},
		async receiveFilesFromOutsideDrop(event) {
			console.log("Files from outer drop.");
			let self = this;
			//Directories only happen during drag / drop.. get the files recursively, then push down
			if (event instanceof CustomEvent && event.type === "fileDropped") {
				if (event.detail.dataTransfer.files.length > 0) {
					let allEntries = await self.getAllFileEntries(event.detail.dataTransfer);
					try {
						await self.processFilesForUpload(allEntries.files, allEntries.directories)
						let currentTasks = document.querySelectorAll(".task-drop-item");
						let targetTask = null;
						for (let t = 0; t < currentTasks.length; t++) {
							let taskDropZone = currentTasks[t];
							let targetRect = taskDropZone.getBoundingClientRect();
							if(self.rectanglesIntersect({
								top: event.detail.clientY,
								right: event.detail.clientX + 10,
								bottom: event.detail.clientY + 10,
								left: event.detail.clientX
							}, targetRect)) {
								targetTask = taskDropZone.dataset.source ? taskDropZone.dataset.source : -1;
							}
						}
						if (targetTask && targetTask !== -1 && self.vault.orgTier !== 'professional') {
							for (let e = 0; e < self.uploadFileQueue.length; e++) {
								self.uploadFileQueue[e].upload.taskId = targetTask;
							}
							console.log("Attach file to target task.");
						}


					} catch (error) {
						console.log(error);
					}
				} else {
					await self.receiveFilesFromInsideDrop(event);
				}
			} else {
				console.log("Invalid outside file drop event.");
			}
		},
		async receiveFilesFromInsideDrop(event) {
			return new Promise((resolve, reject) => {
				let self = this;
				let dragRect = event.detail.target.getBoundingClientRect();
				let currentFolders = document.querySelectorAll(".directory-item");
				let currentTasks = document.querySelectorAll(".task-drop-item");
				let targetFolder = null;
				let targetTask = null;

				for (let c = 0; c < currentFolders.length; c++) {
					let folder = currentFolders[c];
					let targetRect = folder.getBoundingClientRect();
					if(self.rectanglesIntersect({
						top: event.detail.clientY,
						right: event.detail.clientX + 10,
						bottom: event.detail.clientY + 10,
						left: event.detail.clientX
					}, targetRect)) {
						targetFolder = folder.dataset.source ? folder.dataset.source : -1;
						if (targetFolder !== -1) {
							let targetFolderItem = self.vaultFiles.find(tmp => tmp.id === targetFolder);
							console.log("Moving file to " + targetFolderItem.name);
						} else {
							console.log("Moving file to home directory.");
						}
					}
				}

				for (let t = 0; t < currentTasks.length; t++) {
					let taskDropZone = currentTasks[t];
					let targetRect = taskDropZone.getBoundingClientRect();
					if(self.rectanglesIntersect({
						top: event.detail.clientY,
						right: event.detail.clientX + 10,
						bottom: event.detail.clientY + 10,
						left: event.detail.clientX
					}, targetRect)) {
						targetTask = taskDropZone.dataset.source ? taskDropZone.dataset.source : -1;
					}
				}

				self.innerDragFiles = self.innerDragFiles.filter(tmpFile => tmpFile.extension !== 'fld');

				if (targetTask && targetTask !== -1 && self.vault.orgTier !== 'professional') {
					self.attachFileToTask(targetTask, self.innerDragFiles);
					console.log("Attach file to target task.");
				}

				if (targetFolder && self.userVaultPermissions && self.userVaultPermissions.rename_files) {
					console.log("Files from inner drop.");
					//console.log(`Drag ${self.innerDragFiles.join(',')} to ${targetFolder}`);

					self.moveSelectedFilesAndFolders(self.innerDragFiles, targetFolder);
				}

				//self.refreshFiles(true);
				resolve(true);
			});
		},
		attachFileToTask(taskId, files) {
			let self = this;
			let taskChanged = false;
			let task = self.vaultTasks.find(t => t.id === taskId);
			if (task) {
				for (let f = 0; f < files.length; f++) {
					let file = files[f];
					if (!task.attached_files || task.attached_files.length === 0) {
						task.attached_files = [];
					}
					if (task.attached_files && task.attached_files.indexOf(file.id) < 0) {
						task.attached_files.push(file.id);
						taskChanged = true;
					}
				}
				console.log(JSON.stringify(task));

				if (task.action_type === "File Request" && self.cognito && self.cognito.attributes["custom:mutableUserType"] === 'guest') {
					task.status = "Done";
				}
			}
			if (taskChanged) {
				self.editTask(task);
			}
		},
		rectanglesIntersect(r1, r2) {
			return !(r2.left > r1.right ||
				r2.right < r1.left ||
				r2.top > r1.bottom ||
				r2.bottom < r1.top);
		},
		async processFilesForUpload(files, directories, taskId) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				//console.log("Want standard input.");
				let droppedItems = await this.processDroppedFiles({files, directories});
				console.log("Have " + droppedItems.length + " dropped items.");
				for (let di = 0; di < droppedItems.length; di++) {
					droppedItems[di] = self.mockFileSchemaForUploadQueue(droppedItems[di], self);

					if (taskId) {
						droppedItems[di].upload.taskId = taskId;
					}
					//console.log("Dropped item: " + di);
					//console.dir(droppedItems[di]);
					//1. Check for existing file being uploaded.
					let matchingUpload = self.uploadFileQueue.find(file => (file.parent_folder_file_id + "_" + file.name) === (droppedItems[di].parent_folder_file_id + "_" + droppedItems[di].name));
					//console.log("Dropped item ID: " + droppedItems[di].id);
					self.recentActivitySelected[droppedItems[di].id] = true;
					if (typeof matchingUpload === "undefined" || !matchingUpload) {
						let uploadFullPath = droppedItems[di].upload.directory + "__" + droppedItems[di].upload.filename;

						for (let x = 0; self.vaultFiles.length > x; x++) {
							if (uploadFullPath === ((self.vaultFiles[x].parent_folder_file_id ? self.vaultFiles[x].parent_folder_file_id : null) + "__" + self.vaultFiles[x].name)
								&& self.vaultFiles[x]._deleted !== 1) {
								self.vaultFiles[x].status = "uploading";
								break;
							}
						}

						self.uploadFileQueue.push(droppedItems[di]);
					}
				}
				self.queuePaused = false;

				resolve(true);
			});
		},
		mockFileSchemaForUploadQueue(droppedFile, self) {
			let currentTime = new Date();
			droppedFile.id = droppedFile.upload.uuid;
			droppedFile.parent_folder_file_id = droppedFile.upload.directory;
			droppedFile.vault_id = self.vault.id;
			droppedFile.org_id = self.organizationId;

			if (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator',
				'iPad', 'iPhone', 'iPod'].includes(navigator.platform)) {
				let fileModified = new Date(droppedFile.body.lastModified);
				if (droppedFile.upload.filename.match(/\d{11}__.+(\.MOV$)/)) {
					droppedFile.upload.filename = "Video " + moment(fileModified).format("ddd, MMM Do YYYY, h:mm:ss a") + ".mov";
				} else if (droppedFile.upload.filename === "image.jpg" || droppedFile.upload.filename === "image.jpeg") {
					droppedFile.upload.filename = "Photo " + moment(fileModified).format("ddd, MMM Do YYYY, h:mm:ss a") + ".jpg";
				}
			}

			droppedFile.name = droppedFile.upload.filename;
			droppedFile.extension = droppedFile.upload.filename && droppedFile.upload.filename.indexOf('.') > -1 ? droppedFile.upload.filename.split('.').pop() : '';

			if (!droppedFile.meta) {
				droppedFile.meta = {};
			}
			if (droppedFile.body) {
				droppedFile.size = droppedFile.body.size;
			} else {
				droppedFile.size = droppedFile.meta && droppedFile.meta.size ? droppedFile.meta.size : droppedFile.body.fileSize;
			}

			//droppedFile.meta.size = droppedFile.size;

			droppedFile.created_date = currentTime.getTime();
			droppedFile.created_by = self.cognito.attributes.sub;
			droppedFile.created_by_name = self.cognito.attributes.name;
			droppedFile.modified_on = currentTime.getTime();
			droppedFile.modified_by = self.cognito.attributes.sub;
			droppedFile.modified_by_name = self.cognito.attributes.name;
			droppedFile.downloaded_by = [];
			droppedFile.downloaded_by_host = false;
			droppedFile.uploaded_by_host = self.cognito.attributes["custom:mutableUserType"] === 'admin' || self.cognito.attributes["custom:mutableUserType"] === 'member'
			droppedFile.comments =  [];
			droppedFile._version = 0;
			droppedFile._deleted = 0;
			droppedFile._lastChangedAt = currentTime.getTime();
			if (!droppedFile.fullPath) {
				droppedFile.fullPath = "";
			}
			return droppedFile;
		},
		abortFileUpload(file) {
			if (file && file.upload && file.upload.request) {
				try {
					if (file.status !== "done") {
						file.upload.request.abort();
						this.removeFileFromQueue(file.upload.uuid);
						this.notification('success', `Uploading File ${file.name} has been cancelled.`);
					} else {
						this.removeFileFromQueue(file.upload.uuid);
					}
				} catch (error) {
					this.error(`Unable to cancel file upload for ${file.name}.`);
				}
			} else if (file && file.upload) {
				this.removeFileFromQueue(file.upload.uuid);
				this.notification('success', `File ${file.name} has been removed from the upload queue.`);
			}
		},

		async getAllFileEntries(dataTransfer) {
			let dataTransferItemList = [];
			for (let i = 0; i < dataTransfer.files.length; i++) {
				dataTransferItemList.push({file: dataTransfer.files[i], item: dataTransfer.items[i], entity: dataTransfer.items[i].webkitGetAsEntry()});
			}
			return new Promise(async (resolve, reject) => {
				let self = this;
				let fileEntries = [];
				let dirEntries = [];
				// Use BFS to traverse entire directory/file structure
				let queue = [...dataTransferItemList];

				while (queue.length > 0) {
					let originalEntry = queue.shift();
					let entry = originalEntry;
					if (entry && entry.entity) {
						entry = entry.entity;
					}

					if (!entry) {
						console.error("No file entry found.");
					}

					let entryMetadata = await self.getFileMetadata(entry);
					let entryFileHandler = await self.getFileHandler(entry);

					if (entry.isFile) {
						fileEntries.push({fileHandler: entryFileHandler, fileMeta: entryMetadata, fileBody: originalEntry, fileWebKit: entry});
						//console.log(`${entry.name}, ${entry.fullPath}, isFile: ${entry.isFile}`);
					} else {
						dirEntries.push(entry);
						//console.log(`${entry.name}, ${entry.fullPath}, isDirectory: ${entry.isDirectory}`);
						queue.push(...await self.readAllDirectoryEntries(entry.createReader()));
					}
				}
				resolve({directories: dirEntries, files: fileEntries});
			});
		},
		async readAllDirectoryEntries(directoryReader) {
			let self = this;
			let entries = [];
			let readEntries = await self.readEntriesPromise(directoryReader);
			while (readEntries.length > 0) {
				entries.push(...readEntries);
				readEntries = await self.readEntriesPromise(directoryReader);
			}
			return entries;
		},
		async readEntriesPromise(directoryReader) {
			try {
				return await new Promise((resolve, reject) => {
					directoryReader.readEntries(resolve, reject);
				});
			} catch (err) {
				console.log(err);
			}
		},
		async createMissingFolders(directories, rootFolderId) {
			let self = this;
			return new Promise(async (resolve, reject) => {
				let missingFolderIds = [];
				for (let d = 0; d < directories.length; d++) {
					//console.log(`Check or create: ${directories[d].fullPath}`);
					let dirPaths = directories[d].fullPath.split('/');
					let lastParent = rootFolderId;
					for (let p = 0; p < dirPaths.length; p++) {
						//walk through each existing vault file folder.
						//console.log(`Does ${dirPaths[p]} exist?`);
						if (dirPaths[p]) {
							let matchingFolder = self.vaultFiles.find(file =>
								file.name.toLowerCase() === dirPaths[p].toLowerCase() &&
								file.extension.toLowerCase() === "fld" &&
								(
									(!file.parent_folder_file_id && !lastParent) ||
									file.parent_folder_file_id === lastParent)
							);
							if (matchingFolder) {
								lastParent = matchingFolder.id;
							} else {
								lastParent = await self.createNewFolder(dirPaths[p], lastParent);
								missingFolderIds.push(lastParent);
							}
						}
					}
				}
				resolve(missingFolderIds);
			});
		},
		async assignParentFolderIds(files, baseFolderId) {
			let self = this;

			return new Promise(async (resolve, reject) => {
				let updatedFiles = [];
				for (let f = 0; f < files.length; f++) {
					let fileEntry = files[f];
					//let file = fileEntry && fileEntry.fileBody ? fileEntry.fileBody : fileEntry.fileMeta;
					let filePath = "";
					if (fileEntry && fileEntry.fileWebKit && fileEntry.fileWebKit.fullPath) {
						filePath = fileEntry.fileWebKit.fullPath;
					}
					if (!filePath) {
						filePath = fileEntry.webkitRelativePath;
					}

					let paths = filePath.split('/').filter(seg => !!seg);


					let lastParentFolderId = baseFolderId ? baseFolderId : null;

					for (let p = 0; p < paths.length - 1; p++) {
						let tmpPath = paths[p];
						let matchedPath =
							self.vaultFiles.find(existingFile => existingFile.name.toLowerCase() === tmpPath.toLowerCase() && existingFile.extension === "fld" && ((!existingFile.parent_folder_file_id && !lastParentFolderId) || existingFile.parent_folder_file_id === lastParentFolderId));
						if (matchedPath) {
							lastParentFolderId = matchedPath.id;
						} else {
							reject("Unable to map path for file.");
						}
					}

					let fileBody = fileEntry.fileWebKit ? fileEntry.fileWebKit : fileEntry.fileBody;
					if (!fileBody) {
						fileBody = fileEntry;
					}
					updatedFiles.push({
						entry: fileEntry.fileHandler ? fileEntry.fileHandler : fileEntry,
						meta: fileEntry.fileMeta ? fileEntry.fileMeta : fileEntry,
						body: fileBody,
						status: 'queued',
						upload: {
							progress: 0,
							directory: lastParentFolderId,
							completedAt: null,
							filename: fileEntry.name ? fileEntry.name : fileEntry.fileHandler.name,
							uuid: self.uuid()
						}
					});
				}
				resolve(updatedFiles);
			});
		},
		async getFileHandler(entry) {
			return new Promise((resolve, reject) => {
				try {
					if (entry && typeof entry.file === "function") {
						entry.file(function (file) {
							resolve(file);
						});
					} else {
						resolve(entry);
					}
				} catch (error) {
					console.log("Unable to get file for entry.");
					reject(error);
				}
			});
		},
		async getFileMetadata(entry) {
			return new Promise((resolve, reject) => {
				try {
					if (entry && typeof entry.getMetadata === "function") {
						entry.getMetadata(function (metadata) {
							resolve(metadata);
						});
					} else {
						resolve({});
					}
				} catch (error) {
					console.log("Unable to get metadata for entry.");
					reject(error);
				}
			});
		},
		async processDroppedFiles(allEntries) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				let rootFolderId = self.currentFolderFile ? self.currentFolderFile.id : null;

				//2. Check each directory, create directory if needed
				let missingFolderIds = await self.createMissingFolders(allEntries.directories, rootFolderId);
				//remove these from queue immediately

				console.log("Created missing folders: " + missingFolderIds.length);

				//3. Process meta data for each file
				//let filesWithMetaData = await self.gatherMetaDataForFiles(allEntries.files);


				//4. Map parent folder id to each file
				let fileEntries = await self.assignParentFolderIds(allEntries.files, rootFolderId);
				//console.log("Received " + fileEntries.length + " files from drop.");

				resolve(fileEntries);
			});
		},
		dragFile(event, isOver) {
			this.isDragging = isOver;
			//event.preventDefault();
		},
		async uploadFiles() {
			let self = this;
			if (self.uploadInProgress !== true && self.uploadFileQueue.length > 0) {
				self.uploadInProgress = true;
				
				// Only show file accumulator when there are actual files to process
				// and user hasn't recently closed it
				const filesToProcess = self.uploadFileQueue.filter(f => f.status !== "done" && f.status !== "error");
				if (filesToProcess.length > 0) {
					const uploadStartTimestamp = Date.now();
					const shouldShow = this.fileAccumulator.autoShow && 
						!this.fileAccumulator.isVisible &&
						(!this.fileAccumulator.lastClosedTimestamp || 
						 uploadStartTimestamp > this.fileAccumulator.lastClosedTimestamp);
					
					if (shouldShow) {
						this.showFileAccumulatorForUploads();
					}
				}
				
				let currentFileIndex = 0;
				let currentUploadFile = null;
				for (let f = 0; f < self.uploadFileQueue.length; f++) {
					if (self.uploadFileQueue[f].status !== "done" && self.uploadFileQueue[f].status !== "error") {
						currentUploadFile = self.uploadFileQueue[f];
						currentFileIndex = f;
						break;
					}
				}

				if (currentUploadFile) {
					//self.log("Send off the request for a new file.");
					//self.debug("Upload directly to s3, then when successful call fileuploaded");

					let currentPath = self.breadcrumbs.map(crumb => crumb.name).join('/');
					let targetPath = currentPath + "/" + (currentUploadFile.entry.fullPath ? currentUploadFile.entry.fullPath : "");
					targetPath = targetPath.replaceAll("//", "/");
					let folderObject = await self.getFolderIdForPath(targetPath);
					if (!currentUploadFile.parent_folder_file_id && folderObject.folderId) {
						currentUploadFile.parent_folder_file_id = folderObject.folderId;
					}

					//Get existing file name.

					//DONE: Collapse folders, find existing, and show updates on screen...
					//DONE: Folder itself should be the progress bar and remove upload queue...
					let uploadFullPath = currentUploadFile.upload.directory + "__" + currentUploadFile.upload.filename;
					let existingFileId = null;
					for (let x = 0; self.vaultFiles.length > x; x++) {
						if (uploadFullPath === ((self.vaultFiles[x].parent_folder_file_id ? self.vaultFiles[x].parent_folder_file_id : null) + "__" + self.vaultFiles[x].name)
							&& self.vaultFiles[x]._deleted !== 1) {
							existingFileId = self.vaultFiles[x].id;
						}
					}

					//console.log("Upload File Path: " + uploadFullPath);
					//console.log("Existing File ID: " + existingFileId);

					let existingVaultFile = this.vaultFiles.find(selectedFile => (existingFileId && selectedFile.id === existingFileId) || selectedFile.id === currentUploadFile.upload.uuid);
					if (existingVaultFile) {
						existingVaultFile.status = "uploading";
					}

					vaultService.uploadFile(
						self.$data.vault.id,
						self.$data.vault.org_id,
						currentUploadFile,
						currentFileIndex,
						self.$data.vaultToken.Credentials,
						existingFileId
					).then(response => {
						currentUploadFile.status = "done";
						currentUploadFile.upload.progress = 100;
						currentUploadFile.upload.completedAt = new Date();
						self.updateQueueWithFile(currentUploadFile, existingFileId);
						self.uploadInProgress = false;
						self.markFirstVaultActionCompleted("upload");
						if (currentUploadFile.upload && currentUploadFile.upload.taskId) {
							self.attachFileToTask(currentUploadFile.upload.taskId, [response]);
						}
						//TODO This overwrite method could get bulky if there are a lot of files to sift through to find the duplicate
						if (!self.vaultFiles) {
							self.vaultFiles = [];
						}
						/*
						for(let x=0; self.vaultFiles.length > x;x++){
							if(response.name === self.vaultFiles[x].path && self.vaultFiles[x]._deleted !== 1){
								self.deleteFile(self.vaultFiles[x]);
							}
						}
						*/

						if (!existingFileId) {
							self.vaultFiles.push(response);
						} else {
							let fileThumbKey = self.getS3KeyForThumbnail(response, self.$data.vault);
							setTimeout(function() {
								EventBus.$emit("refreshlazy", {oldId: fileThumbKey, newId: fileThumbKey});
							}, 10000);
						}

						if (self.uploadFileQueue.length > 0) {
							setTimeout(self.uploadFiles, 300);
						}

						/*
						if (self.uploadFileQueue.length === 0) {
							self.refreshFiles(true);
						}*/
					}).catch(error => {
						console.log("ERROR: Unable to call uploadFile from the vault service: " + JSON.stringify(error));
						currentUploadFile.status = "error";
						self.updateQueueWithFile(currentUploadFile, existingFileId);
						self.uploadInProgress = false;
						self.notification('error', "Upload failed on file - " + currentUploadFile.upload.filename);
						setTimeout(self.uploadFiles, 300);
					});
				} else {
					self.uploadInProgress = false;
				}
			}
		},
		updateQueueWithFile(file, existingFileId) {
			//console.log(`Update file in queue ${file.upload.uuid} or ${existingFileId}`);
			if (existingFileId) {
				//let existingVaultFile = this.vaultFiles.find(selectedFile => (existingFileId && selectedFile.id === existingFileId) || selectedFile.id === file.upload.uuid);
				for (let sf = 0; sf < this.vaultFiles.length; sf++) {
					if ((existingFileId && this.vaultFiles[sf].id === existingFileId) || this.vaultFiles[sf].id === file.upload.uuid) {
						let currentTime = new Date();
						this.vaultFiles[sf]._lastChangedAt = currentTime.getTime();
						this.vaultFiles[sf].status = "done";
						
						// Add to file accumulator when upload completes
						this.addToFileAccumulator(this.vaultFiles[sf]);
					}
				}

				//file == existingQueueFile
				//console.log("Updated queue length: " + this.vaultFiles.length);
			} else {
				console.log("No update the file queue.");
			}
		},
		clearTasks() {
			let self = this;
			self.progress.clearTasksDialog = true;
			self.openPopup('clearTasksDialog');
			self.closePopup('editTask');
		},
		confirmClearTasks(event) {
			let self = this;
			console.log("Confirmed.");

			vaultService.mutation("deleteTask", {
				task_id: "66c6b8f7-f1b2-4d48-a29b-3b6837accbc5",
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				num_tasks_closed: 0,
				num_tasks_open: 0,
				earliest_open_task_date: ""
			}).then(response => {
				console.log(response);
				self.closePopup('clearTasksDialog');

				for (let i = 0; i < self.vaultTasks.length; i++) {
					self.vaultTasks[i]._deleted = 1;
				}

				self.progress.clearTasksDialog = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				alert("Unable to remove all tasks, please try again.");
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			});
		},
		openComposeNotificationTaskRemindersEditor() {
			this.newNotificationEmailMessage = this.defaultTaskNotificationEmailMessage + "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		openComposeNotificationEditor() {
			this.newNotificationEmailMessage = this.defaultNotificationEmailMessage + "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		openComposeFilesNotificationEditor() {
			this.newNotificationEmailMessage = "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		testPopupMethod(data) {
			return new Promise((resolve, reject) => {
				alert("Test: " + JSON.stringify(data));
				resolve();
			});
		},
		selectNoRecentFiles() {
			let self = this;
			for (let i = 0; i < self.vaultFiles.length; i++) {
				let file = self.vaultFiles[i];
				//console.log("Key: " + key);
				self.$set(self.recentActivitySelected, file.id, false);
			}
			//console.log("Unselect unread files: " + JSON.stringify(self.recentActivitySelected));
		},
		selectUnreadFiles() {
			let self = this;

			for (let i = 0; i < self.vaultFiles.length; i++) {
				let file = self.vaultFiles[i];
				if ((typeof file.uploaded_by_host !== 'undefined'
						|| typeof file.downloaded_by_host !== 'undefined')
					&& self.fileWasNotDownloaded(file)) {
					self.$set(self.recentActivitySelected, file.id, true);
				} else {
					self.$set(self.recentActivitySelected, file.id, false);
				}
			}
			//console.log("Select unread files: " + JSON.stringify(this.recentActivitySelected));
		},
		addComment(task) {
			let currentTime = new Date();
			task.comments.push({
				id: this.uuid(),
				comment: this.newComment,
				created_date: currentTime.getTime(),
				created_by: this.cognito.attributes.sub,
				user_name: this.cognito.attributes.name,
				_version: 0,
				_deleted: 0,
				_lastChangedAt: currentTime.getTime()
			});
			this.newComment = "";
		},
		permissionSummary(member) {
			let permissions = "None";
			let permissionsList = [];
			if (member) {
				if (member.view_files) {
					permissionsList.push("Download");
				}
				if (member.upload_files) {
					permissionsList.push("Upload");
				}
				if (member.rename_files) {
					permissionsList.push("Move, Rename");
				}
				if (member.delete_files) {
					permissionsList.push("Delete");
				}
			}
			if (permissionsList.length > 0) {
				permissions = permissionsList.join(", ");
			}
			return permissions;
		},
		sendNotificationEmail(email) {
			return new Promise((resolve, reject) => {
				let now = new Date();
				if (!this.selectedNotificationEmails || this.selectedNotificationEmails.length === 0) {
					this.notification("error", "Please select at least one portal guest to send the email.");
					reject("Please select at least one portal guest to send the email.");
				} else {
					let toEmails = "admin";
					if (this.cognito.attributes["custom:mutableUserType"] !== "guest" && this.cognito.attributes["custom:mutableOrgId"] === this.vault.org_id) {
						toEmails = this.selectedNotificationEmails.map(notEm => {return notEm.email}).join(",");
					}

					vaultService.mutation("newAuditNotificationAction", {
						action: "custom_upload",
						vault_id: this.vault.id,
						org_id: this.vault.org_id ? this.vault.org_id : '',
						description: this.editedEmailMessage,
						filename: toEmails,
						action_date: now.getTime().toString()
					}).then(result => {
						this.notification("success", "File activity notification email send successfully.");
						resolve();
					}).catch(error => {
						this.notification("error", "Unable to send file activity notification email, please try again.");
						console.log(error);
						reject("Unable to send file activity notification email, please try again.");
					});
				}
			});
		},
		saveTask(task) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				self.progress.createTask = true;
				if (!task || !task.title) {
					self.notification('error', "Please complete the required fields before saving this task.");
				} else {
					if (task && !task.id) {
						if (task.multiCreate === true) {
							let taskTitles = task.title.split("\n");
							for (let i = 0; i < taskTitles.length; i++) {
								let tmpTask = JSON.parse(JSON.stringify(task));
								tmpTask.title = taskTitles[i];
								await self.createTask(tmpTask);
							}
						} else {
							await self.createTask(task);
						}
					} else {
						self.editTask(task);
					}
				}
				self.progress.createTask = false;
				resolve(); //TODO: Make promises and await create and edit methods
			});
		},
		setTodayTaskCalendar() {
			this.taskCalendarFocus = '';
			//this.notification('success', "Test Message");
		},
		getTasksForCalendar(event) {
			let self = this;
			const taskDueDates = []

			if (self.vaultTasks) {
				for (let i = 0; i < self.vaultTasks.length; i++) {
					let tmpTask = self.vaultTasks[i];
					if (tmpTask.due_date) {
						let min = new Date(`${tmpTask.due_date}T01:00:00`).getTime();
						let max = new Date(`${tmpTask.due_date}T22:59:59`).getTime();

						taskDueDates.push({
							name: tmpTask.title,
							'start': min,
							'end': max,
							status: tmpTask.status,
							color: this.colors[this.rnd(0, this.colors.length - 1)],
							timed: false,
							task_id: tmpTask.id
						});
					}
				}

				self.taskDueDates = taskDueDates;
			}
		},
		dueDateCheck(task){
			if(task && task.status !== "Done"){
				let today = moment(new Date());
				return today.isBefore(task.due_date);
			}else{
				return true;
			}

		},
		editTaskFromCalendar(event) {
			if (event && event.nativeEvent) {
				event.nativeEvent.stopPropagation();
			}

			let task = this.vaultTasks.find(tmpTask => tmpTask.id === event.eventParsed.input.task_id);
			this.openEditTask(task);
		},
		getTaskColor (event) {
			return 'green';
		},
		rnd (a, b) {
			return Math.floor((b - a + 1) * Math.random()) + a
		},
		deleteTask(task) {
			let self = this;
			console.log(JSON.stringify(task));
			self.progress.taskDeleteDialog = true;

			let numClosed = self.numberOfDoneTasks - (task.status !== "Done" ? 0 : 1);
			let numOpen = self.numberOfOpenTasks - (task.status !== "Done" ? 1 : 0);
			let earliestDate = self.earliestTaskDate;
			vaultService.mutation("deleteTask", {
				task_id: task.id,
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				num_tasks_closed: numClosed,
				num_tasks_open: numOpen,
				earliest_open_task_date: earliestDate
			}).then(response => {
				console.log(response);
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');

				for (let i = 0; i < self.vaultTasks.length; i++) {
					if (self.vaultTasks[i].id === task.id) {
						self.vaultTasks[i]._deleted = 1;
						self.vaultTasks.splice(i, 1);
						break;
					}
				}
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			});
		},
		openEditTask(task) {
			task.due_date_formatted = task.due_date ? this.formatDate(task.due_date) : '';
			if(this.cognito.attributes['custom:mutableUserType'] === "guest"){
				this.openPopup('editTask_guest', task);
			}else{
				this.openPopup('editTask', task);
			}
		},
		clearNewTask(date) {
			//this.$refs.newTaskForm.resetValidation();
			this.newTask = {
				title: "",
				action_type: "General",
				description: "",
				due_date: date ? (new Date(date)).toISOString().split('T')[0] : null,
				due_date_formatted: date ? this.formatDate(date) : "",
				status: "Open",
				_deleted: 0
			};
		},
		updateFileToTask(task, refs) {
			this.lastTaskIdFromUpload = task.id;
			if (refs) {
				refs.file.click();
			}
		},
		openCreateNewTaskPopup(event) {
			if (this.cognito.attributes['custom:mutableUserType'] !== 'guest') {
				this.clearNewTask(event ? event.date : undefined);
				this.openPopup('createTask', this.newTask)
			}
		},
		createTask(task) {
			return new Promise((resolve, reject) => {
				let self = this;
				self.progress.createTask = true;

				if (!task) {
					task = self.newTask;
				}

				task.id = self.uuid();

				let numClosed = self.numberOfDoneTasks + (task.status !== "Done" ? 0 : 1);
				let numOpen = self.numberOfOpenTasks + (task.status !== "Done" ? 1 : 0);
				let earliestDate = self.earliestTaskDate;

				vaultService.mutation("addTask", {
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					attached_files: task.attached_files ? task.attached_files : [],
					action_type: task.action_type ? task.action_type : "",
					title: task.title ? task.title : "",
					description: task.description ? task.description : "",
					status: task.status,
					clientResponse: "",
					send_reminder: task.send_reminder ? task.send_reminder : false,
					due_date: task.due_date ? task.due_date : "",
					assigned_guest_ids: task.assigned_guest_ids ? task.assigned_guest_ids : [],
					assigned_guest_names: task.assigned_guest_names ? task.assigned_guest_names : [],
					assigned_member_ids: task.assigned_member_ids ? task.assigned_member_ids : [],
					assigned_member_names: task.assigned_member_names ? task.assigned_member_names : [],
					num_tasks_closed: numClosed,
					num_tasks_open: numOpen,
					earliest_open_task_date: earliestDate
				}).then(response => {
					task.id = response;
					self.closePopup('createTask');
					self.clearNewTask();
					self.progress.createTask = false;
				self.vaultTasks.push(task);

				if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
					self.viewMode = 1;
				} else {
					self.viewMode = 0;
				}
					self.getTasksForCalendar();
					resolve(task);
				}).catch(error => {
					console.log("Error: " + JSON.stringify(error));
					self.closePopup('createTask');
					self.clearNewTask();
					self.progress.createTask = false;
					reject("Error creating task.");
				});
			});
		},
		editTask(task) {
			console.dir(task);

			let self = this;
			self.progress.createTask = true;
			let now = new Date();

			let numClosed = self.numberOfDoneTasks;
			let numOpen = self.numberOfOpenTasks;
			let earliest = self.earliestTaskDate;

			if (typeof task.send_reminder === 'undefined' || task.send_reminder === null) {
				task.send_reminder = false;
			}

			vaultService.mutation("updateTask",
				{
					...task,
					num_tasks_closed: numClosed,
					num_tasks_open: numOpen,
					earliest_open_task_date: earliest
				}
			).then(response => {
				console.log(response);
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.createTask = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.createTask = false;
			});
			if(task.status === 'Done'){
				vaultService.mutation("newAuditNotificationAction", {
					action: "Task Complete",
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					filename: task.title,
					description: "Task Complete",
					action_date: now.getTime().toString()
				}).then(response => {
					console.log("Task Complete Notification Trigger.");
				});
			}
		},
		taskBlob(task){
			let taskHeader = "Task Title:";
			switch(task.action_type) {
				case 'Question?':
					taskHeader = 'Answer the following:';
					break;
				case 'File Request':
					taskHeader = 'Upload this File:';
					break;
				case 'Sign Document':
					taskHeader = 'Sign this File:';
					break;
				case 'Fill Form':
					taskHeader = 'Fill out this form:';
					break;
				case 'General':
					taskHeader = 'Task To Do:';
					break;
			}
			return taskHeader;
		},
		taskTitleFieldName(task) {
			let taskHeader = "Enter Task Title or Request";
			switch(task.action_type) {
				case 'Question?':
					taskHeader = 'Enter Question you want Answered';
					break;
				case 'File Request':
					taskHeader = 'Description of File you want Uploaded';
					break;
				case 'Sign Document':
					taskHeader = 'Description of the PDF you want Signed';
					break;
				case 'Fill Form':
					taskHeader = 'Description of the PDF you want Completed.';
					break;
				case 'General':
					taskHeader = 'Enter Task Title or Request';
					break;
			}
			return taskHeader;
		},
		selectActivityForDate(dateId) {
			console.log(JSON.stringify(this.recentActivitySelected));
			for (let ra = 0; ra < this.allFilesGroupedByDate.length; ra++) {
				let groupedFiles = this.allFilesGroupedByDate[ra];
				//console.log(JSON.stringify(this.allFilesGroupedByDate));
				if (dateId === groupedFiles.fieldId) {
					for (let fa = 0; fa < groupedFiles.files.length; fa++) {
						let selectFile = groupedFiles.files[fa];
						this.recentActivitySelected[selectFile.id] = true;
					}
				}
			}
		},
		getLatestDate(file) {
			let tmpDate = file._lastChangedAt;
			if (file.modified_on) {
				tmpDate = file.modified_on;
			} else if (file.created_date) {
				tmpDate = file.created_date;
			}
			return tmpDate;
		},
		userNameFromFile(file) {
			let info = this.userInfoFromFile(file);
			return info.displayName;
		},
		modifiedDateFromFile(file) {
			let info = this.userInfoFromFile(file);
			return info.modifiedDate;
		},
		userInfoFromFile(file) {
			//1. look for modified_by/on fields
			//2. look for created field
			//2a. get name from file info
			//2b. get name from members if org
			//2c. get name from vault permissions
			//3. if nothing assume uploaded by host

			let userId = file ? file.created_by : -1;
			let userName = "Uploaded by Host";
			let userEmail = null;
			let modifiedDate = file.created_date;
			let displayName = userName;

			if (!userId) {
				userId = -1;
			}

			if (file && file.modified_by) {
				userId = file.modified_by;
				userName = file.modified_by_name;
				userEmail = file.modified_by_email;
				modifiedDate = file.modified_on;
				if (userEmail && this.userTypeVisibility) {
					displayName = userName + " (" + userEmail + ")";
				} else {
					displayName = userName;
				}

			} else {
				if (!modifiedDate) {
					modifiedDate = file._lastChangedAt;
				}

				//find name

				let permissions = this.vault && this.vault.permissions ? this.vault.permissions : [];
				let permission = permissions.find(perm => perm.user_id === userId);
				if (permission && permission.user_name) {
					userName = permission.user_name;
					if (permission.user_email && this.userTypeVisibility) {
						displayName = permission.user_name + " (" + permission.user_email + ")";
					} else {
						displayName = permission.user_name;
					}
					displayName = permission.user_name + " (" + permission.user_email + ")";
				} else if (this.organization && this.organization.permissions) {
					let orgPermissions = this.organization.permissions ? this.organization.permissions : [];
					let orgPermission = orgPermissions.find(perm => perm.user_id === userId && perm._deleted !== 1);
					if (orgPermission && orgPermission.user_name) {
						userName = orgPermission.user_name;
						if (orgPermission.user_email && this.userTypeVisibility) {
							displayName = orgPermission.user_name + " (" + orgPermission.user_email + ")";
						} else {
							displayName = orgPermission.user_name;
						}
					}
				}
			}

			return {
				displayName,
				userName,
				userEmail,
				userId,
				modifiedDate
			};
		},
		tasksFullTableSort(a, b) {
			//Sort date oldest first but an older date should be above a blank value
			if (!a && b) {
				return 1;
			} else if (a && !b) {
				return -1;
			} else if (!a && !b) {
				return 0;
			} else {
				return new Date(a) - new Date(b);
			}
		},
		customSort(items, index, isDesc) {
			//console.log("Sort by " + index);
			items.sort((a, b) => {
				if (index === '_lastChangedAt') {
					if (!isDesc[0]) {
						return new Date(b[index]) - new Date(a[index]);
					} else {
						return new Date(a[index]) - new Date(b[index]);
					}
				}
				else {
					if(typeof a[index] !== 'undefined'){
						if ((a.extension === "fld" || b.extension === "fld") && a.extension !== b.extension) {
							return a.extension === "fld" ? -1 : 1;
						} else if (!isDesc[0]) {
							return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
						}
						else {
							return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
						}
					}
				}
			});
			return items;
		},
		parentPdfSave(){
			this.loadingSave = !this.loadingSave;
			this.$refs["web-viewer"].savePdf();
		},
		pdfMessageReceived(xfdf, file, pdfSigned) {

			//TODO send the array buffer from export up to here to send to S3
			let self = this;
			self.pdfViewerFormDirty = false;
			self.loadingSave = false;
			console.log("PDF Saved..");
			let now = new Date();

			//Audit Notification
			vaultService.mutation("newAuditNotificationAction", {
				action: pdfSigned ? "PDF Signed" : "PDF Form Filled",
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				file_id: file.id,
				filename: file.name,
				description: pdfSigned ? "Signed PDF Form" : "Saved PDF Form.",
				action_date: now.getTime().toString()
			}).then(notificationEmails => {
				self.setFileDownloadedBy(file);
				if (notificationEmails !== self.vault.id) {
					if (notificationEmails.indexOf("|time_suppressed") > -1) {
						//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
					} else {
						self.notification("success", "PDF Save Notification emailed to " + notificationEmails);
					}
				}
				file._lastChangedAt = now.getTime();
			});

			//check for related task
			let tasksOpenWithThisFile =
				self.vaultTasks.filter(t =>
					t.attached_files &&
					t.attached_files.indexOf(file.id) > -1 &&
					t.status !== 'Done' &&
					(t.action_type === 'Fill Form' || t.action_type === 'Sign Document'));
			console.log(tasksOpenWithThisFile.length + " tasks open related to this file.");
			if (tasksOpenWithThisFile.length > 0) {
				if (confirm("There is an associated task open named: " + tasksOpenWithThisFile[0].title + ", would you like to mark this as complete?") === true) {
					for (let t = 0; t < tasksOpenWithThisFile.length; t++) {
						tasksOpenWithThisFile[t].status = "Done";
						self.editTask(tasksOpenWithThisFile[t]);
					}
				}
			}
		},
		updatePdfDirtyFlag(flagState) {
			this.pdfViewerFormDirty = flagState;
		},
		fileStatusIcon(status) {
			switch(status) {
				case "complete": return 'fas fa-check-circle';
				case "uploading": return 'fas fa-sync-alt';
				default: return 'fas fa-times-circle';
			}
		},
		fileFromFullPath(fullPath) {
			return fullPath.replace(/^.*[\\\/]/, '');
		},
		dirFromFullPath(fullPath) {
			return fullPath.replace(/(.*?)[^/]*\..*$/,'$1');
		},
		humanFileSize(bytes, si=false, dp=1) {
			const thresh = si ? 1000 : 1024;

			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}

			const units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
			let u = -1;
			const r = 10**dp;

			do {
				bytes /= thresh;
				++u;
			} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


			return bytes.toFixed(dp) + ' ' + units[u];
		},
		uuid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
		removeUrlExtension(name) {
			return name && name.indexOf(".url") > -1 ? name.replace(".url", "") : name;
		},
		// First-open invited action: the welcome/orientation modal is shown ONCE per
		// guest per portal (tracked in localStorage on dismissal). Upload mode offers
		// the file picker; download mode offers a Download button for the shared
		// files; sign mode offers a Review & Sign button for documents awaiting the
		// guest's signature (nothing happens without a click).
		checkFirstOpenAction() {
			let self = this;
			if (!self.isGuestUser) {
				self.checkPasswordSetupPrompt();
				return;
			}
			let invite = self.currentVaultInvitation;
			if (!invite || !invite.invite_mode || invite.first_action_completed === true) {
				self.checkPasswordSetupPrompt();
				return;
			}
			// Only welcome the guest once - re-prompting on every open was reading
			// as nagging. (The flag is set on dismissal, not display, so a prompt
			// pulled back for terms acceptance can still re-show after agreeing.)
			if (self.firstActionPromptAlreadyShown()) {
				self.checkPasswordSetupPrompt();
				return;
			}
			// When the org requires terms acceptance, hold the welcome prompt
			// back until the guest agrees (acceptTerms re-runs this check).
			if (self.termsDialog === true) {
				self.firstActionWaitingOnTerms = true;
				return;
			}
			self.firstActionDialog = true;
		},
		firstActionPromptStorageKey() {
			let userId = this.cognito && this.cognito.attributes && this.cognito.attributes.sub
				? this.cognito.attributes.sub : "anon";
			return "zapaWelcomePromptShown_" + userId + "_" + (this.vault ? this.vault.id : "");
		},
		firstActionPromptAlreadyShown() {
			try {
				return !!localStorage.getItem(this.firstActionPromptStorageKey());
			} catch (e) {
				return false;
			}
		},
		// Close the welcome prompt and remember it was seen so it never re-prompts.
		dismissFirstActionPrompt() {
			this.firstActionDialog = false;
			try {
				localStorage.setItem(this.firstActionPromptStorageKey(), new Date().toISOString());
			} catch (e) {
				console.log("Unable to persist welcome prompt state.");
			}
		},
		// Download-mode prompt CTA: open the first shared file as a preview. The
		// guest downloads from the preview, which is what marks the first action
		// complete (nothing downloads without an explicit click there).
		downloadFirstActionFiles() {
			let self = this;
			self.dismissFirstActionPrompt();
			let firstFile = self.firstActionDownloadFiles[0];
			if (firstFile) {
				self.$nextTick(function() {
					self.selectFileToPreview(firstFile, self.vault, true, true);
				});
			}
		},
		// Sign-mode prompt CTA: open the first document awaiting the guest's
		// signature. selectFileToPreview routes pending recipients straight into
		// the sign workbench.
		signFirstActionFiles() {
			let self = this;
			self.dismissFirstActionPrompt();
			let firstFile = self.firstActionSignFiles[0];
			if (firstFile) {
				self.$nextTick(function() {
					self.selectFileToPreview(firstFile, self.vault, false, true);
				});
			}
		},
		markFirstVaultActionCompleted(actionType) {
			let self = this;
			let invite = self.currentVaultInvitation;
			if (!self.isGuestUser || !invite || !invite.invite_mode || invite.first_action_completed === true) {
				return;
			}
			if (invite.invite_mode !== actionType) {
				return;
			}
			invite.first_action_completed = true;
			self.dismissFirstActionPrompt();
			vaultService.mutation("markVaultFirstAction", {vaultId: self.vault.id}).then(() => {
				self.checkPasswordSetupPrompt();
			}).catch(error => {
				console.log("Unable to record first portal action.");
			});
			if (actionType === "download") {
				// Demo portals: auto-play the firm-side experience video after the
				// prospect's very first download.
				self.maybeShowDemoVideo();
			}
		},
		loadDemoOrgInfo(orgId) {
			let self = this;
			if (!self.isGuestUser || self.demoOrgInfo !== null) {
				return;
			}
			vaultService.query("getPublicOrgById", {org_id: orgId}).then(publicOrg => {
				// false (vs null) marks the lookup as done so we don't re-query.
				self.demoOrgInfo = publicOrg && publicOrg.isDemoOrg ? publicOrg : false;
			}).catch(error => {
				self.demoOrgInfo = false;
			});
		},
		maybeShowDemoVideo() {
			// Show the popup if there's anything to offer: video, booking CTA, or both.
			let hasContent = this.demoOrgInfo && (this.demoOrgInfo.demoVideoUrl || this.demoOrgInfo.demoBookingUrl);
			if (hasContent && !this.demoVideoDialog) {
				if (this.demoOrgInfo.demoVideoUrl) {
					this.demoVideoPlayerOptions.sources = [{
						type: this.demoOrgInfo.demoVideoUrl.indexOf(".webm") > -1 ? "video/webm" : "video/mp4",
						src: this.demoOrgInfo.demoVideoUrl
					}];
				}
				this.demoVideoDialog = true;
			}
		},
		checkPasswordSetupPrompt() {
			if (this.passwordSetupOverdue) {
				this.passwordSetupDialog = true;
			}
		},
		// ===== Multi-page document scan =====
		startDocumentScan() {
			this.scanPages = [];
			this.scanStep = "capture";
			this.scanFileName = "";
			this.scanSuggesting = false;
			this.scanAssembling = false;
			this.scanDialog = true;
			this.addScanPage();
		},
		addScanPage() {
			if (this.$refs.scanPageInput) {
				this.$refs.scanPageInput.click();
			}
		},
		async onScanPageSelected(event) {
			let self = this;
			if (!event || !event.target || !event.target.files || !event.target.files.length) {
				return;
			}
			let pageFile = event.target.files[0];
			// Allow re-capturing the same file (e.g. retake) to fire change again.
			event.target.value = "";
			self.scanProcessingPage = true;
			try {
				let page = await self.downscaleScanPage(pageFile, 1600, 0.82);
				self.scanPages.push(page);
			} catch (error) {
				console.log("Unable to process captured page.");
				self.notification("error", "Unable to process that photo. Please try again.");
			}
			self.scanProcessingPage = false;
		},
		// Downscale an image blob to a JPEG capped at maxEdge pixels on its long
		// side. Used at 1600px for PDF pages and 1200px for the AI naming request
		// (which must stay under the AppSync ~1MB request limit as base64).
		downscaleScanPage(imageBlob, maxEdge, quality) {
			return new Promise((resolve, reject) => {
				let objectUrl = URL.createObjectURL(imageBlob);
				let img = new Image();
				img.onload = function() {
					try {
						let scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
						let canvas = document.createElement("canvas");
						canvas.width = Math.round(img.width * scale);
						canvas.height = Math.round(img.height * scale);
						canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
						URL.revokeObjectURL(objectUrl);
						canvas.toBlob(function(blob) {
							if (!blob) {
								reject(new Error("Unable to encode page image."));
								return;
							}
							resolve({
								blob: blob,
								dataUrl: canvas.toDataURL("image/jpeg", 0.6),
								width: canvas.width,
								height: canvas.height
							});
						}, "image/jpeg", quality);
					} catch (canvasError) {
						URL.revokeObjectURL(objectUrl);
						reject(canvasError);
					}
				};
				img.onerror = function() {
					URL.revokeObjectURL(objectUrl);
					reject(new Error("Unable to load page image."));
				};
				img.src = objectUrl;
			});
		},
		removeScanPage(index) {
			this.scanPages.splice(index, 1);
		},
		finishScanCapture() {
			let self = this;
			if (self.scanPages.length === 0) {
				return;
			}
			self.scanStep = "name";
			self.requestScanNameSuggestion();
		},
		requestScanNameSuggestion() {
			let self = this;
			if (self.scanSuggesting || self.scanPages.length === 0) {
				return;
			}
			self.scanSuggesting = true;
			// Re-encode the first page smaller so the base64 payload stays well
			// under the AppSync request size limit.
			self.downscaleScanPage(self.scanPages[0].blob, 1200, 0.7).then(smallPage => {
				return self.blobToBase64(smallPage.blob);
			}).then(imageBase64 => {
				return vaultService.mutation("suggestFileName", {
					org_id: self.vault.org_id,
					vault_id: self.vault.id,
					image: imageBase64
				});
			}).then(suggestedName => {
				// Don't clobber a name the user already started typing.
				if (suggestedName && !self.scanFileName) {
					self.scanFileName = suggestedName;
				}
				self.scanSuggesting = false;
			}).catch(error => {
				console.log("Unable to suggest a filename for the scanned document.");
				self.scanSuggesting = false;
			});
		},
		blobToBase64(blob) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				reader.onload = function() {
					// Strip the "data:image/jpeg;base64," prefix.
					let result = reader.result;
					resolve(result.substring(result.indexOf(",") + 1));
				};
				reader.onerror = function() {
					reject(new Error("Unable to read page image."));
				};
				reader.readAsDataURL(blob);
			});
		},
		blobToArrayBuffer(blob) {
			// FileReader instead of Blob.arrayBuffer() for older mobile browsers.
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				reader.onload = function() {
					resolve(reader.result);
				};
				reader.onerror = function() {
					reject(new Error("Unable to read page image."));
				};
				reader.readAsArrayBuffer(blob);
			});
		},
		async confirmScanUpload() {
			let self = this;
			let cleanName = (self.scanFileName || "").trim().replace(/\.pdf$/i, "").trim();
			if (!cleanName) {
				cleanName = "Scanned Document " + moment(new Date()).format("MMM Do YYYY, h-mm a");
			}
			self.scanAssembling = true;
			try {
				// Code-split: pdf-lib only loads when a scan is actually confirmed.
				let pdfLib = await import("pdf-lib");
				let pdfDoc = await pdfLib.PDFDocument.create();
				for (let p = 0; p < self.scanPages.length; p++) {
					let page = self.scanPages[p];
					let jpgBytes = await self.blobToArrayBuffer(page.blob);
					let jpgImage = await pdfDoc.embedJpg(jpgBytes);
					let pdfPage = pdfDoc.addPage([page.width, page.height]);
					pdfPage.drawImage(jpgImage, {x: 0, y: 0, width: page.width, height: page.height});
				}
				let pdfBytes = await pdfDoc.save();
				let pdfFile = new File([pdfBytes], cleanName + ".pdf", {type: "application/pdf"});

				// null taskId: scans start from the toolbar, never from a task prompt,
				// so don't attach to a stale lastTaskIdFromUpload.
				await self.processFilesForUpload([pdfFile], [], null);
				self.uploadFiles();

				self.scanDialog = false;
				self.scanPages = [];
				self.scanFileName = "";
			} catch (error) {
				console.log("Unable to assemble scanned document.");
				self.notification("error", "Unable to create the PDF. Please try again.");
			}
			self.scanAssembling = false;
		},
		cancelDocumentScan() {
			this.scanDialog = false;
			this.scanPages = [];
			this.scanFileName = "";
		},
		submitPermanentPassword() {
			let self = this;
			self.passwordSetupError = "";
			if (!self.newPortalPassword || self.newPortalPassword.length < 8) {
				self.passwordSetupError = "Password must be at least 8 characters.";
				return;
			}
			if (self.newPortalPassword !== self.newPortalPasswordCheck) {
				self.passwordSetupError = "Passwords do not match.";
				return;
			}
			self.passwordSetupLoading = true;
			vaultService.mutation("setPermanentPassword", {newPassword: self.newPortalPassword}).then(() => {
				self.passwordSetupLoading = false;
				self.passwordSetupDialog = false;
				self.passwordBannerDismissed = true;
				if (self.user) {
					self.user.passwordIsTemporary = false;
				}
				self.newPortalPassword = "";
				self.newPortalPasswordCheck = "";
				self.notification("success", "Your password has been updated.");
			}).catch(error => {
				self.passwordSetupLoading = false;
				let message = error && error.errors && error.errors.length > 0 && error.errors[0].message
					? error.errors[0].message : null;
				self.passwordSetupError = message ? message : "Unable to update password, please try again.";
			});
		},
		acceptTerms() {
			let self = this;
			self.termsDialog = false
			// Release the first-open welcome prompt that was held back for terms.
			if (self.firstActionWaitingOnTerms) {
				self.firstActionWaitingOnTerms = false;
				self.checkFirstOpenAction();
			}
			vaultService.mutation("setVaultAsTermsAccepted", {'vault_id': self.vault.id, 'remove_vault': false}).then(response => {
				//console.log("Returned from set vault terms as accepted. " + response);
				//audit action
				let now = new Date();
				vaultService.mutation("newAuditNotificationAction", {
					action: "Portal Terms Accepted",
					vault_id: self.vault.id,
					org_id: this.organization && this.organization.id ? this.organization.id : this.organizationId,
					description: `Guest ${self.user.displayName} (${self.user.email}) accepted the following terms and conditions for portal ${self.vault.name}: ${self.termsAndConditions}`,
					action_date: now.getTime().toString()
				});

				vaultService.query("getUserById", undefined, "user", {vuexCache: false}).then(() => {});
			}).catch(err => {
				console.dir(err);
				self.notification('error', "Unable to set vault terms as accepted.");
			});
		},
		navigateFilePreview(offset) {
			let self = this;

			let changeFile = function() {
				self.loadingSave = false;
				let nextIndex = self.selectedFileToPreviewIndex;
				if (self.filteredFilesOnlyOnSearchAndDelete.length > 0) {
					nextIndex = self.selectedFileToPreviewIndex + offset;
					if (nextIndex < 0) {
						nextIndex = 0;
					} else if (nextIndex >= self.filteredFilesOnlyOnSearchAndDelete.length) {
						nextIndex = self.filteredFilesOnlyOnSearchAndDelete.length - 1;
					}
					if (nextIndex !== self.selectedFileToPreviewIndex) {
						// Arrow navigation should always open the PDF preview, never
						// redirect into the sign/return workbench - so skip the pending
						// signature-request check (that redirect only belongs to an
						// explicit file open, not paging through the preview).
						self.selectFileToPreview(self.filteredFilesOnlyOnSearchAndDelete[nextIndex], self.vault, true);
					}
				}
			}

			if (self.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you still wish to leave the page?") === true) {
					self.pdfViewerFormDirty = false;
					changeFile();
				}
			} else {
				changeFile();
			}
		},
		markSelectedAsRead(overrideSelectedFilesWithRecentSelected) {
			let fileIds = [];
			let self = this;
			if (self.recentActivitySelected && overrideSelectedFilesWithRecentSelected) {
				for (let x in self.recentActivitySelected) {
					if (self.recentActivitySelected[x] === true) {
						let tmpFile = self.vaultFiles.find(file => file.id === x);
						if (tmpFile) {
							self.setFileDownloadedBy(tmpFile, true);
							fileIds.push(tmpFile.id);
						}
					}
				}
			} else {
				for (let i = 0; i < self.selectedFiles.length; i++) {
					self.setFileDownloadedBy(self.selectedFiles[i], true);
					if (self.selectedFiles[i].id) {
						fileIds.push(self.selectedFiles[i].id);
					}
				}
			}

			vaultService.mutation("markFilesAsRead", {fileIds, "org_id": self.vault.org_id, "vault_id": self.vault.id}).then(() => {
				console.log("Files marked as read.");
			});
		},
		markFileAsRead(file) {
			// Mark a single file as read
			let self = this;
			if (file && file.id) {
				self.setFileDownloadedBy(file, true);
				let fileIds = [file.id];
				vaultService.mutation("markFilesAsRead", {fileIds, "org_id": self.vault.org_id, "vault_id": self.vault.id}).then(() => {
					console.log("File marked as read.");
				});
			}
		},
		handleFileContextMenu(event, item) {
			// Handle right-click context menu with Ctrl key detection
			// If Ctrl is pressed, allow native browser context menu (for developer tools)
			if (event.ctrlKey) {
				return; // Let browser handle it
			}
			
			// Otherwise, prevent default and show custom context menu
			// Note: The v-menu in the actions column already provides the context menu
			// This handler is mainly for Ctrl key detection
			// We could also trigger the menu programmatically here if needed
		},
		fileWasNotDownloaded(file) {
			return !this.fileWasDownloaded(file);
		},
		fileWasDownloaded(file) {
			let wasDownloaded = false;
			//0. if not folder
			if (file.extension === "fld") {
				wasDownloaded = true;
			} else if (this.cognito && (this.cognito.attributes["custom:mutableUserType"] === "admin" || this.cognito.attributes["custom:mutableUserType"] === "member") &&
				(!!file.downloaded_by_host || !!file.uploaded_by_host)) {
				//1. else if (admin or member) && downloaded_by_host
				wasDownloaded = true;
			} else if (this.cognito) {
				//2. else if (guest) && myId in [downloaded_by]
				wasDownloaded = file.downloaded_by ? file.downloaded_by.indexOf(this.cognito.attributes.sub) > -1 : false;
				if (!wasDownloaded && file.created_by === this.cognito.attributes.sub) {
					wasDownloaded = true;
				}
			}

			return wasDownloaded;
		},
	selectFileToPreview(file, vault, skipSignatureCheck = false, skipUrlUpdate = false) {
		let self = this;
		self.selectedFileUrlTarget = null;

		if (typeof file === 'string') {
			file = self.vaultFiles.find(f => f.id === file);
		}
		
		// Skip if file not found
		if (!file) {
			console.log('File not found for preview');
			return;
		}

		if (file.upload && (file.upload.progress >= 0 && file.upload.progress < 100)) {
			console.log("Skipping file open during upload.");
		} else {
			// Check if this file has a pending signature request (skip if explicitly requested)
			if (!skipSignatureCheck && file.extension.toLowerCase() === 'pdf' && self.signatureRequestsByFile && self.signatureRequestsByFile[file.id]) {
				const userEmail = self.user && self.user.email ? self.user.email.toLowerCase() : null;
				const userOrgId = self.organization && self.organization.id ? self.organization.id : null;
				
				if (userEmail) {
					// Look through signature requests for this file
					for (const request of self.signatureRequestsByFile[file.id]) {
						// Skip requests with deleted files
						if (request.file_deleted) {
							continue;
						}
						
						// Skip completed, cancelled, or expired requests
						// (also treat a past expires_at date as expired, since the
						// stored status may not have been updated yet)
						if (request.status === 'completed' || request.status === 'cancelled' || request.status === 'expired' || self.isSignatureRequestExpired(request)) {
							continue;
						}
						
						if (request.recipients && Array.isArray(request.recipients)) {
							// First check if current user is a direct recipient
							const userRecipient = request.recipients.find(r => 
								r.email && r.email.toLowerCase() === userEmail
							);
							
							// If user is a recipient who has already completed
							if (userRecipient && userRecipient.status === 'completed') {
								console.log('User has already completed this signature request, opening in preview mode');
								self.notification('info', 'You have already completed this signature request.');
								// Continue to open in preview mode (don't return early)
							}
							// If user is a pending recipient, open in sign mode
							else if (userRecipient && userRecipient.status === 'pending' && userRecipient.token) {
								console.log('User is a pending recipient for this file, opening in sign mode');
								// Sign-intent invites: reaching the sign workbench is the
								// guest's first invited action.
								self.markFirstVaultActionCompleted("sign");
								self.$router.push({
									name: 'PdfWorkbenchSign',
									params: {
										signatureRequestId: request.id,
										token: userRecipient.token
									}
								});
								return; // Exit early, don't preview
							}
							
							// Check if user can sign on behalf of organization
							if (userOrgId) {
								const orgEmail = `org:${userOrgId}`;
								const orgRecipient = request.recipients.find(r => 
									r.email && r.email === orgEmail
								);
								
								// If organization has already completed
								if (orgRecipient && orgRecipient.status === 'completed') {
									console.log('Organization has already completed this signature request, opening in preview mode');
									self.notification('info', 'Your organization has already completed this signature request.');
									// Continue to open in preview mode (don't return early)
								}
								// If organization is a pending recipient, open in sign mode
								else if (orgRecipient && orgRecipient.status === 'pending' && orgRecipient.token) {
									console.log('User can sign on behalf of organization, opening in sign mode');
									self.$router.push({
										name: 'PdfWorkbenchSign',
										params: {
											signatureRequestId: request.id,
											token: orgRecipient.token
										}
									});
									return; // Exit early, don't preview
								}
							}
						}
					}
				}
			}
			
				let now = new Date();
				// Bump the load token synchronously. Any signed-URL promise from a
				// previous (superseded) selection will see a stale token when it
				// resolves and bail out, so docUrl can never end up pointing at a
				// different file than selectedFileToPreview (prevents saving the
				// wrong file when arrows are clicked quickly).
				self.previewLoadToken = self.previewLoadToken + 1;
				let previewToken = self.previewLoadToken;
				self.selectedFileToPreview = file;
				self.filePreviewImage = null;
				self.selectedFileToPreviewIndex = self.filteredFilesOnlyOnSearchAndDelete.indexOf(file);
				self.selectedPreviewFileUrlXfdf = null;
				
				// Update URL with file ID for shareable preview links
				if (!skipUrlUpdate && file && file.id) {
					let currentUrl = new URL(window.location.href);
					currentUrl.searchParams.set('file', file.id);
					window.history.replaceState({}, document.title, currentUrl.toString());
				}
				if (file.extension.toLowerCase() === "fld") {
					self.downloadFile(file, vault);
				} else {
					vaultService.getSignedFileUrl(file, vault, true).then(fileUrl => {
						// A newer file selection started while this URL was being
						// signed - discard this stale result.
						if (previewToken !== self.previewLoadToken) {
							console.log("Skipping stale file preview load for", file.name);
							return;
						}
						self.tab = 0;
						self.selectedPreviewFileText = "";
						self.selectedPreviewFileUrl = fileUrl;
						switch (file.extension.toLowerCase()) {
							case "fld":
								self.downloadFile(file, vault); break;
							case "apng":
							case "gif":
							case "jpg":
							case "jpeg":
							case "jfif":
							case "pjpeg":
							case "pjp":
							case "png":
							case "webp":
							case "bmp":
							case "ico":
							case "cur":
							case "tif":
							case "tiff":
								self.previewToolMode = "image";
								self.filePreviewMode = true;
								self.filePreviewImage = fileUrl;

								//self.$viewerApi({ images: [fileUrl], })

								//self.imagePreviewContainer.load(fileUrl);
								break;
							case "docx":
								self.previewToolMode = "docx";
								self.filePreviewMode = true;
								self.renderDocxPreview(fileUrl, previewToken);
								break;
							case "xlsx":
							case "xls":
								self.previewToolMode = "xlsx";
								self.filePreviewMode = true;
								self.renderXlsxPreview(fileUrl, previewToken);
								break;
							case "doc":
							case "pptx":
							case "ppt":
								// No reliable open-source in-browser renderer for these
								// formats; fall back to the embedded Google Docs viewer.
								self.previewToolMode = "office-embed";
								self.filePreviewMode = true;
								break;
							case "pdf":
								self.previewToolMode = "pdf";
								self.selectedPreviewFileUrlXfdf = null;
                                self.filePreviewMode = true;

								break;
							case "mp3":
							case "aif":
							case "wav":
								self.previewToolMode = "audio";
								self.filePreviewMode = true;
								break;
						case "m4v":
						case "avi":
						case "mp4":
						case "webm":
							self.videoPlayerOptions.sources = [{
								type: file.extension === "webm" ? "video/webm" : "video/mp4",
								src: fileUrl
							}];
							self.previewToolMode = "video";
							self.filePreviewMode = true;
							//self.resizePreview();
							break;
							case "url":
								self.previewToolMode = "bookmark";
								self.filePreviewMode = true;
								self.downloadFile(file, vault, true, true);
								break;
							case "txt":
								self.previewToolMode = "text";
								vaultService.downloadFile(vault, file, this.$data.vaultToken.Credentials, true).then(data => {
									console.log("Loaded saved text data.");
									self.selectedPreviewFileText = data.Body;
									self.filePreviewMode = true;
								}).catch(error => {
									console.log("No xfdf data found for PDF. " + JSON.stringify(error));
									self.filePreviewMode = true;
								});
								break;
							default:
								self.previewToolMode = "notavailable";
								self.filePreviewMode = true;
								//this.downloadFile(file, vault);
								break;
						}

						vaultService.mutation("newAuditNotificationAction", {
							action: "Download",
							vault_id: vault.id,
							org_id: vault.org_id,
							file_id: file.id,
							filename: file.name,
							description: "Portal File Preview.",
							action_date: now.getTime().toString()
						}).then(notificationEmails => {
							self.setFileDownloadedBy(file);
							if (notificationEmails !== vault.id) {
								if (notificationEmails.indexOf("|time_suppressed") > -1) {
									//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
								} else {
									self.notification("success", "Download Notification emailed to " + notificationEmails);
								}
							}
						});
					});
				}

			}
		},
		fetchPreviewArrayBuffer(fileUrl) {
			return fetch(fileUrl).then(response => {
				if (!response.ok) {
					throw new Error("Failed to download file for preview (HTTP " + response.status + ")");
				}
				return response.arrayBuffer();
			});
		},
		renderDocxPreview(fileUrl, previewToken) {
			let self = this;
			self.previewOfficeLoading = true;
			self.previewOfficeError = null;
			// $nextTick so the preview container ref is rendered before we write to it
			self.$nextTick(() => {
				self.fetchPreviewArrayBuffer(fileUrl).then(buffer => {
					if (previewToken !== self.previewLoadToken) {
						return null;
					}
					let container = self.$refs.docxPreviewContainer;
					container.innerHTML = "";
					return renderDocxAsync(buffer, container, null, {
						inWrapper: true,
						ignoreLastRenderedPageBreak: true
					});
				}).then(() => {
					if (previewToken === self.previewLoadToken) {
						self.previewOfficeLoading = false;
					}
				}).catch(error => {
					console.log("Failed to render docx preview. " + (error && error.message ? error.message : error));
					if (previewToken === self.previewLoadToken) {
						self.previewOfficeLoading = false;
						self.previewOfficeError = "This Word document could not be previewed.";
					}
				});
			});
		},
		renderXlsxPreview(fileUrl, previewToken) {
			let self = this;
			self.previewOfficeLoading = true;
			self.previewOfficeError = null;
			self.xlsxPreviewSheets = [];
			self.xlsxPreviewTab = 0;
			self.fetchPreviewArrayBuffer(fileUrl).then(buffer => {
				if (previewToken !== self.previewLoadToken) {
					return;
				}
				let workbook = XLSX.read(new Uint8Array(buffer), {type: "array"});
				self.xlsxPreviewSheets = workbook.SheetNames.map(name => {
					return {
						name: name,
						html: self.buildXlsxSheetHtml(workbook.Sheets[name])
					};
				});
				self.previewOfficeLoading = false;
			}).catch(error => {
				console.log("Failed to render spreadsheet preview. " + (error && error.message ? error.message : error));
				if (previewToken === self.previewLoadToken) {
					self.previewOfficeLoading = false;
					self.previewOfficeError = "This spreadsheet could not be previewed.";
				}
			});
		},
		buildXlsxSheetHtml(sheet) {
			// header/footer set to empty strings so we get just the <table>,
			// not a full HTML document
			let html = XLSX.utils.sheet_to_html(sheet, {header: "", footer: ""});
			if (!sheet["!ref"]) {
				return html;
			}
			let parsed = new DOMParser().parseFromString(html, "text/html");
			let table = parsed.querySelector("table");
			if (!table) {
				return html;
			}
			// Decorate the SheetJS table so it reads like a spreadsheet:
			// a row-number gutter plus an A/B/C column-letter header row.
			let rows = table.querySelectorAll("tr");
			for (let i = 0; i < rows.length; i++) {
				let gutter = parsed.createElement("td");
				gutter.className = "xlsx-gutter";
				gutter.textContent = String(i + 1);
				rows[i].insertBefore(gutter, rows[i].firstChild);
			}
			let range = XLSX.utils.decode_range(sheet["!ref"]);
			let thead = parsed.createElement("thead");
			let headerRow = parsed.createElement("tr");
			let corner = parsed.createElement("th");
			corner.className = "xlsx-gutter";
			headerRow.appendChild(corner);
			for (let col = range.s.c; col <= range.e.c; col++) {
				let th = parsed.createElement("th");
				th.textContent = XLSX.utils.encode_col(col);
				headerRow.appendChild(th);
			}
			thead.appendChild(headerRow);
			table.insertBefore(thead, table.firstChild);
			return table.outerHTML;
		},
		setFileDownloadedBy(file, onlyUpdateDownloadedBy) {
			if (this.cognito.attributes["custom:mutableUserType"] === "admin" || this.cognito.attributes["custom:mutableUserType"] === "member") {
				if (onlyUpdateDownloadedBy !== true) {
					file.downloaded_by_host = true;
				}
			}
			let downloadedArray = file.downloaded_by ? file.downloaded_by : [];
			if (downloadedArray.indexOf(this.cognito.attributes.sub) === -1) {
				downloadedArray.push(this.cognito.attributes.sub);
			}
		},
		resizePreview() {
			if (this.$refs.filePreviewRow.clientWidth > 0) {
				//this.videoPlayerOptions.width = this.$refs.filePreviewRow.clientWidth - 20;
			} else {
				//this.videoPlayerOptions.width = this.$refs.topVaultBar.clientWidth - 20;
			}
		},
		closeFilePreview() {
			if (this.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you still wish to leave the page?") === true) {
					this.filePreviewMode = false;
					this.selectedPreviewFileUrl = null;
					this.pdfViewerFormDirty = false;
					this.removeFileFromUrl();
					this.handlePreviewClosedWhilePresenting();
				}
			} else {
				this.filePreviewMode = false;
				this.selectedPreviewFileUrl = null;
				this.removeFileFromUrl();
				this.handlePreviewClosedWhilePresenting();
			}
		},
		handlePreviewClosedWhilePresenting() {
			if (!this.presenting.active) {
				return;
			}
			if (this.presenting.isPresenter) {
				this.stopPresenting();
			} else {
				// Stop following but keep the session so the user can resume
				this.presenting.following = false;
			}
		},
		removeFileFromUrl() {
			// Remove the file query parameter from URL when closing preview
			let currentUrl = new URL(window.location.href);
			if (currentUrl.searchParams.has('file')) {
				currentUrl.searchParams.delete('file');
				window.history.replaceState({}, document.title, currentUrl.toString());
			}
		},
		saveExternalEmail() {
			let self = this;
			vaultService.mutation("saveVaultExternalEmail", {vault_id: this.vault.id, org_id: this.vault.org_id, email: this.vault.external_email}).then(response => {
				self.notification('success', "Vault external email saved.");
			}).catch(error => {
				self.notification('error', "Unable to save external email address. Please try again.");
				//console.log(JSON.stringify(error));
			});
		},
	saveExternalSystemIds() {
		let self = this;
		// Build the externalSystemIds object from the edit values
		const externalSystemIds = {};
		if (self.organization && self.organization.externalSystems) {
			self.organization.externalSystems.forEach(system => {
				const editKey = '_editExternalId_' + system;
				const value = self.vault[editKey];
				if (value && value.trim()) {
					externalSystemIds[system] = value.trim();
				}
			});
		}
		
		// Taxi customer ids are exactly 6 digits (spec D1); reject client-side so a typo
		// doesn't wipe the existing link with a server-side validation error.
		const previousTaxiId = self.taxiCustomerIdFrom(self.parsedExternalSystemIds());
		const newTaxiId = self.taxiCustomerIdFrom(externalSystemIds);
		if (newTaxiId && !/^[0-9]{6}$/.test(newTaxiId)) {
			self.notification('error', "Taxi customer id must be exactly 6 digits.");
			return;
		}
		
		vaultService.mutation("updateVaultSettings", {
			"vault_id": self.vault.id,
			"org_id": self.vault.org_id,
			// AWSJSON type requires a JSON string
			"externalSystemIds": JSON.stringify(externalSystemIds),
			"archived": Boolean(self.vault.archived) || false,
			"private_mode": Boolean(self.vault.private_mode) || false,
			"hide_perms": Boolean(self.vault.hide_perms) || false,
			"isTemplate": Boolean(self.vault.isTemplate) || false
		}).then(response => {
			// Update the vault's externalSystemIds with the saved values
			self.vault.externalSystemIds = externalSystemIds;
			self.notification('success', "External system IDs saved.");
			// Verify whenever a Taxi id is saved and the portal isn't already linked to that id
			// (mirrors updateVaultSettings.handleTaxiLinkChange); clear the link when it's removed.
			if (newTaxiId) {
				if (!self.taxiLinkedTo(newTaxiId)) {
					self.$set(self.vault, 'taxi_link', { status: 'verifying', customer_id: newTaxiId });
					self.verifyTaxiLink();
				}
			} else if (previousTaxiId) {
				self.$set(self.vault, 'taxi_link', { status: 'unlinked' });
			}
		}).catch(error => {
			self.notification('error', "Unable to save external system IDs. Please try again.");
		});
	},
	/** The Taxi customer id from an externalSystemIds map; the "taxi" key matches case-insensitively. */
	taxiCustomerIdFrom(ids) {
		if (!ids || typeof ids !== 'object') return '';
		const key = Object.keys(ids).find(k => k.toLowerCase() === 'taxi');
		const value = key ? ids[key] : '';
		return typeof value === 'string' ? value.trim() : '';
	},
	taxiLinkedTo(customerId) {
		const link = this.taxiLink;
		return Boolean(link && link.status === 'linked' && link.customer_id === customerId);
	},
	/**
	 * On portal load: if a Taxi id is set but the stored link isn't `linked` to it (portal was
	 * linked before the org credential existed, Taxi was down, id set via the API...), verify now
	 * instead of showing a stale status until someone clicks Re-verify.
	 */
	autoVerifyTaxiLink() {
		if (!this.vault || !this.vaultBelongsToUserOrg || !this.taxiIntegrationEnabled) return;
		if (!this.userVaultPermissions || !this.userVaultPermissions.manage_perms) return;
		const customerId = this.taxiCustomerIdFrom(this.parsedExternalSystemIds());
		if (!customerId || this.taxiLinkedTo(customerId)) return;
		this.verifyTaxiLink(true);
	},
	parsedExternalSystemIds() {
		let stored = this.vault && this.vault.externalSystemIds ? this.vault.externalSystemIds : {};
		if (typeof stored === 'string') {
			try {
				stored = JSON.parse(stored);
			} catch (e) {
				stored = {};
			}
		}
		return stored && typeof stored === 'object' ? stored : {};
	},
	/**
	 * Taxi file push: run the activation handshake for this portal (spec §3 / §4.1) and show
	 * the outcome. The server also runs it asynchronously when the id changes; calling it here
	 * gives the admin an immediate answer instead of a stale "Verifying…".
	 * @param {boolean} [silent] Skip toasts (auto-verify on load); the status chip still updates.
	 */
	verifyTaxiLink(silent) {
		let self = this;
		if (!self.vault || self.taxiLinkVerifying) return;
		self.taxiLinkVerifying = true;
		vaultService.mutation("verifyTaxiLink", {
			"org_id": self.vault.org_id,
			"vault_id": self.vault.id
		}).then(link => {
			self.$set(self.vault, 'taxi_link', link || { status: 'unlinked' });
			if (link && link.status === 'linked') {
				if (!silent) self.notification('success', "Portal linked to Taxi" + (link.display_name ? ": " + link.display_name : "") + ".");
				self.loadTaxiDeliveries();
			} else if (link && link.error && !silent) {
				self.notification('warning', "Taxi link: " + link.error);
			}
		}).catch(error => {
			console.error("Unable to verify Taxi link:", error);
			if (!silent) self.notification('error', "Unable to verify the Taxi link. Please try again.");
		}).finally(() => {
			self.taxiLinkVerifying = false;
		});
	},
	/**
	 * Load the Taxi delivery ledger for this portal so files can show Sent / Sending / Failed.
	 * Only members with manage_perms can read it; guests and unlinked portals skip the call.
	 */
	loadTaxiDeliveries() {
		let self = this;
		if (!self.vault || !self.vaultBelongsToUserOrg || !self.taxiIntegrationEnabled) return;
		if (!self.userVaultPermissions || !self.userVaultPermissions.manage_perms) return;
		const link = self.vault.taxi_link;
		const hasLinkHistory = link && link.status && link.status !== 'unlinked';
		if (!hasLinkHistory) return;
		vaultService.query("getTaxiDeliveries", {
			"org_id": self.vault.org_id,
			"vault_id": self.vault.id
		}, undefined, {vuexCache: false}).then(rows => {
			self.taxiDeliveries = rows || [];
			self.indexTaxiDeliveries();
		}).catch(error => {
			console.error("Unable to load Taxi deliveries:", error);
		});
	},
	indexTaxiDeliveries() {
		// Newest row per file wins (file.signed after file.uploaded, or a resend).
		const byFile = {};
		this.taxiDeliveries.forEach(row => {
			if (!row || !row.file_id) return;
			const existing = byFile[row.file_id];
			if (!existing || (row.updated_at || row.created_at || '') > (existing.updated_at || existing.created_at || '')) {
				byFile[row.file_id] = row;
			}
		});
		this.taxiDeliveriesByFile = byFile;
	},
	taxiDeliveryForFile(file) {
		if (!file || !file.id) return null;
		return this.taxiDeliveriesByFile[file.id] || null;
	},
	taxiDeliveryDisplay(file) {
		const row = this.taxiDeliveryForFile(file);
		if (!row) return null;
		switch (row.status) {
			case 'delivered':
				return { color: 'success', icon: 'mdi-cloud-check', text: 'Sent to Taxi', title: 'Sent to Taxi ' + (row.delivered_at ? new Date(row.delivered_at).toLocaleString() : '') };
			case 'failed':
				return { color: 'error', icon: 'mdi-cloud-alert', text: 'Taxi failed', title: row.last_error || 'Delivery failed', resend: true };
			case 'pending':
			case 'retrying':
				return { color: 'grey', icon: 'mdi-cloud-upload', text: 'Sending to Taxi', title: row.last_error ? 'Retrying: ' + row.last_error : 'Queued' };
			default:
				return null;
		}
	},
	resendTaxiDelivery(file) {
		let self = this;
		const row = self.taxiDeliveryForFile(file);
		if (!row || row.status !== 'failed' || self.taxiResending[row.id]) return;
		self.$set(self.taxiResending, row.id, true);
		vaultService.mutation("resendTaxiDelivery", {
			"org_id": self.vault.org_id,
			"vault_id": self.vault.id,
			"delivery_id": row.id
		}).then(updated => {
			self.taxiDeliveries = self.taxiDeliveries.map(r => r.id === updated.id ? Object.assign({}, r, updated) : r);
			self.indexTaxiDeliveries();
			self.notification('success', "Resending to Taxi.");
		}).catch(error => {
			console.error("Unable to resend Taxi delivery:", error);
			self.notification('error', "Unable to resend to Taxi. Please try again.");
		}).finally(() => {
			self.$set(self.taxiResending, row.id, false);
		});
	},
		openMoveSelectedFilesAndFolders(copyModeOrSpecificFiles) {
			// Handle both old signature (copyMode boolean) and new signature (specificFiles array)
			let specificFiles = null;
			let copyMode = false;
			
			if (Array.isArray(copyModeOrSpecificFiles)) {
				// New signature: specific files array passed
				specificFiles = copyModeOrSpecificFiles;
			} else {
				// Old signature: copyMode boolean
				copyMode = !!copyModeOrSpecificFiles;
			}
			
			if (specificFiles && specificFiles.length > 0) {
				// Temporarily set selectedFiles for the move operation
				let originalSelectedFiles = this.selectedFiles;
				this.selectedFiles = specificFiles;
				this.copyFileMode = false;
				this.openPopup('selectFolder');
				// Note: selectedFiles will be restored after the move/copy completes
				// or we can add a callback to restore them
			} else if (this.selectedFiles && this.selectedFiles.length > 0) {
				this.copyFileMode = copyMode;
				this.openPopup('selectFolder');
			} else {
				alert("Please select files to move or copy.");
			}
		},
		moveSelectedFilesAndFolders(filesToMove, targetFolderId) {
			let self = this;
			if (typeof filesToMove === 'undefined') {
				filesToMove = self.selectedFiles;
			}
			if (typeof targetFolderId === 'undefined') {
				targetFolderId = self.selectedTreeFolder && self.selectedTreeFolder.length > 0 ? self.selectedTreeFolder[0] : null;
			}

			self.popupError('selectFolder', null);

			if (!targetFolderId) {
				self.popupError('selectFolder', "Please select a destination folder.");
			} else {
				if ((self.currentFolderFile && self.currentFolderFile.id === targetFolderId)
					|| (!self.currentFolderFile && targetFolderId === -1)) {
					self.popupError('selectFolder', "The current folder is selected as the target folder.");
				} else {
					//if all filesToMove must have currentFolder as parent_folder_file_id..
					let allSelectedHaveSameParentFolderFileId = true;
					let allSelectedAreCurrentFolderId = true;
					let lastParentFolderId = -1;
					let selectedFileIds = [];
					let filesWillBeOverwritten = [];
					let letMoveProceed = true;
					let overwrittenFileIds = [];

					for (let i = 0; i < filesToMove.length; i++) {
						let foundConflictFile = self.vaultFiles.find(checkFile =>
							checkFile.parent_folder_file_id === targetFolderId
							&& checkFile._deleted !== 1
							&& checkFile.name === filesToMove[i].name);
						if (foundConflictFile) {
							filesWillBeOverwritten.push(filesToMove[i].name);
							letMoveProceed = false;
						}

						if (lastParentFolderId === -1) {
							lastParentFolderId = filesToMove[i].parent_folder_file_id;
						} else if (lastParentFolderId !== filesToMove[i].parent_folder_file_id) {
							allSelectedHaveSameParentFolderFileId = false;
						}
						if ((self.currentFolderFile && self.currentFolderFile.id !== filesToMove[i].parent_folder_file_id) ||
							(self.currentFolderFile !== filesToMove[i].parent_folder_file_id)) {
							allSelectedAreCurrentFolderId = false;
						}
						selectedFileIds.push(filesToMove[i].id);
						overwrittenFileIds.push(foundConflictFile ? foundConflictFile.id : null);
					}

					if (filesWillBeOverwritten.length > 0
						&& confirm('Are you sure you want to overwrite the following files: ' + filesWillBeOverwritten.join(", ") + '?')) {
						letMoveProceed = true;
					}

					//all selectedFiles, update parent_folder_file_id to be new folder.
					if (!allSelectedHaveSameParentFolderFileId) {
						self.popupError('selectFolder', "All selected files must be in the same folder.");
					} else if (!letMoveProceed) {
						self.modals.moveFile = false;
						self.progress.moveFile = false;
						self.popupError('selectFolder', "Request to move files has been canceled.");
					} else {
						//Send to lambda, selectedFileIds[ID] and targetFolderId[ID] as the target. -1 => null

						vaultService.mutation("moveFile", {
							"file_id": selectedFileIds,
							"overwrite_id": overwrittenFileIds,
							"org_id": self.$data.vault.org_id,
							"vault_id": self.$data.vault.id,
							"destination": targetFolderId !== -1 ? targetFolderId : undefined,
							"copy": self.copyFileMode
						}).then(response => {
							//TODO: Fix thumbnail on copied file.
							filesToMove = [];
							self.refreshFiles(true);
							self.modals.moveFile = false;
							self.progress.moveFile = false;
							self.notification('success', "File(s) moved Successfully!");

							self.selectedTreeFolder = [];
							self.closePopup('selectFolder');

							Promise.all(filesToMove.map(fileInfo => {
								vaultService.mutation("newAuditNotificationAction", {
									action: copyMode === true ? "Copy" : "Move",
									vault_id: self.$data.vault.id,
									org_id: self.$data.vault.org_id,
									file_id: fileInfo.id,
									filename: fileInfo.name,
									action_date: now.getTime().toString()
								});
							}));
						}).catch(error => {
							self.modals.moveFile = false;
							self.progress.moveFile = false;
							vaultService._error(error);
							self.notification('error', "Unable to move file, please contact the portal administrator for permission.");
							self.popupError('selectFolder', "Unable to move file, please contact the portal administrator for assistance. " + error);
						});
					}

				}
			}
		},
		showVersionHistory(file) {
			let self = this;

			vaultService.downloadFileVersions(this.vault, file, this.$data.vaultToken.Credentials);

			self.openPopup('versionHistory');
		},
		momentDate(timestamp, dateOnly) {
			if (typeof timestamp === 'string' && timestamp.indexOf('-') > -1) {
				return moment(timestamp).format(dateOnly ? "M/D/YYYY" : "M/D/YYYY h:mma");
			} else {
				return moment.unix(timestamp / 1000).format(dateOnly ? "M/D/YYYY" : "M/D/YYYY h:mma");
			}
		},
		formatDate (date) {
			if (!date) return null

			const [year, month, day] = date.split('T')[0].split('-')
			let formattedDate = `${month}/${day}/${year}`;
			//console.log(`Format - ${date} -> ${formattedDate}`);
			return formattedDate;
		},
		parseDate (date) {
			if (!date) return null

			const [month, day, year] = date.split('/')
			let parsedDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
			//console.log(`Parse - ${date} -> ${parsedDateString}`);
			return parsedDateString;
		},
		userHasPermission(name) {
			let hasLocalPermissions = false;
			let hasOrgPermissions = false;

			if (this.vault && this.user) {
				hasLocalPermissions = !!this.vault.permissions.find(perm => perm[name] === true && perm.user_id === this.user.id && perm._deleted !== 1);

				if (this.organization && this.vault.org_id === this.organization.id) {
					if (this.cognito.attributes["custom:mutableUserType"] === "admin") {
						hasOrgPermissions = true;
					} else if (!hasLocalPermissions) {
						hasOrgPermissions = !!this.organization.permissions.find(perm => perm[name] === true && perm.user_id === this.user.id && perm._deleted !== 1);
					}
				}
			}

			return hasLocalPermissions || hasOrgPermissions;
		},
		updatingUserComment(note, file) {
			let self = this;
			vaultService.mutation("updateFileComment", {
				"file_id": file.id,
				"org_id": self.$data.vault.org_id,
				"vault_id": self.$data.vault.id,
				"comment": note
			}).then(result => {
				let now = new Date();
				vaultService.mutation("newAuditNotificationAction", {
					action: "File Comment",
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					file_id: file.id,
					filename: file.name,
					description: "Commented on file.",
					action_date: now.getTime().toString()
				}).then(notificationEmails => {
					self.setFileDownloadedBy(file);
					if (notificationEmails !== self.vault.id) {
						if (notificationEmails.indexOf("|time_suppressed") > -1) {
							//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
						} else {
							self.notification("success", "Comment Notification emailed to " + notificationEmails);
						}
					}
				});
			}).catch(error => {
				console.error(JSON.stringify(error));
			});
		},
		renderFileComments(file) {
			//Get id from vault permissions.
			//Only show comments from people who current have permissions.
			//Show current user's comments first.
			return file.comments.map(comment => {
				let nameInitials = "";
				try {
					nameInitials = comment.user_name ? comment.user_name.match(/\b(\w)/g).join('') : "";
				} catch(e) {
					//console.error("Comment without initials.");
				}
				return {
					initials: nameInitials,
					name: comment.user_name,
					userId: comment.created_by,
					class: {
						"background-color": toMaterialStyle(comment.user_name).backgroundColor,
						"color": toMaterialStyle(comment.user_name).color
					},
					lastModified: parseInt(comment._lastChangedAt),
					comment: comment.comment
				};
			});
		},
		saveFileComments({file, comment, note}) {
			//console.log(`Change file ${file.name} comment from ${comment.comment} to ${note}.`);
			let files = this.vaultFiles;
			let updated = false;
			for (let i = 0; i < this.vaultFiles.length; i++) {
				if (this.vaultFiles[i].id === file.id) {
					if (!this.vaultFiles[i].comments) {
						this.vaultFiles[i].comments = [];
					}

					for (let c = 0; c < this.vaultFiles[i].comments.length; c++) {
						if (this.vaultFiles[i].comments[c].created_by === this.user.id) {
							this.vaultFiles[i].comments[c].comment = note;
							this.vaultFiles[i].comments[c].user_name = this.user.displayName;
							updated = true;
							break;
						}
					}
				}
			}
		},
		fileHasNoUserComment(file) {
			return !file.comments.find(comment => comment.created_by === this.user.id);
		},
		isVaultPendingInvitation() {
			let vaultIsPendingInvitation = false;
			let self = this;
			if (self.vault && self.cognito && self.cognito.attributes['custom:mutableUserType'] === "guest") {
				let foundPermission = self.vault.permissions.find(testPerm =>
					testPerm.user_id === self.cognito.attributes.sub &&
					testPerm.invitation_accepted === "none" && testPerm._deleted !== 1);
				if (!!foundPermission) {
					vaultIsPendingInvitation = true;
				}
			}
			return vaultIsPendingInvitation;
		},
		openRenameFileModal(file) {
			if (!file) {
				console.error("[openRenameFileModal] No file provided");
				this.notification('error', "Please select a file to rename.");
				return;
			}
			this.fileToRename = file;
			this.renameFilenameValue = file.name;
			this.modals.renameFile = true;
		},
		openSendForSignatureWithFile(file) {
			if (!file) {
				console.error("[openSendForSignatureWithFile] No file provided");
				this.notification('error', "Please select a PDF file to send for signature.");
				return;
			}
			if (file.extension !== 'pdf') {
				this.notification('error', "Only PDF files can be sent for signature.");
				return;
			}
			
			// Check if file already has an active signature request
			const fileRequests = this.signatureRequestsByFile && this.signatureRequestsByFile[file.id];
			if (fileRequests && fileRequests.length > 0) {
				const activeRequest = fileRequests.find(req => 
					req.status !== 'completed' && 
					req.status !== 'cancelled' && 
					req.status !== 'expired' && 
					!this.isSignatureRequestExpired(req) && 
					req._deleted !== 1
				);
				
				if (activeRequest) {
					this.notification('error', "This file already has an active signature request. Please wait for it to be completed or cancelled before sending a new request.");
					return;
				}
			}
			
			// Set the preselected file
			this.sendForSignaturePreselectedFile = file;
			// Open the modal
			this.modals.sendForSignature = true;
		},
	closeSendForSignatureModal() {
		// Clear the preselected file when closing the modal
		this.sendForSignaturePreselectedFile = null;
		this.modals.sendForSignature = false;
	},
	handleEditPdf(fileInfo) {
		// Close the send for signature modal
		this.closeSendForSignatureModal();
		
		// Open the PDF in the viewer so user can access the Forms tab
		if (fileInfo && fileInfo.id) {
			this.selectFileToPreview(fileInfo, this.vault);
		} else {
			this.showSnackbar('error', 'Unable to open PDF file');
		}
	},
	handleSignatureRequestSent(responses) {
		console.log('Signature request sent, responses:', responses);
		
		// Show success notification
		if (responses && responses.length > 0) {
			this.notification('success', `Signature request sent to ${responses.length} recipient(s)!`);
		}
		
		// Reload signature requests to get updated status
		if (this.vault && this.vault.id) {
			this.loadSignatureRequestsForPortal(this.vault.id);
		}
	},
	async loadSignatureRequestsForPortal(portalId) {
		// Guests included: they need their pending signature requests for the
		// first-open "sign" prompt and for click-to-sign routing from the file
		// list (the backend strips recipient tokens that are not theirs).
		try {
			console.log('Loading signature requests for portal:', portalId);
			
			// Query signature requests for this portal
			const signatureRequests = await vaultService.query('getSignatureRequestsByPortalId', {
				portal_id: portalId
			}, undefined, { vuexCache: false });
			
			if (!signatureRequests || !Array.isArray(signatureRequests)) {
				console.log('No signature requests found for portal');
				return;
			}
			
			console.log(`Found ${signatureRequests.length} signature requests for portal`);
			console.log('Current vaultFiles count:', this.vaultFiles ? this.vaultFiles.length : 0);
			console.log('Current vault.files count:', this.vault && this.vault.files ? this.vault.files.length : 0);
			
			// Store signature requests by file_id (including recipient info)
			this.signatureRequestsByFile = {};
			
			// Group signature requests by file_id and calculate status
			const fileSignatureStatus = {};
			
			signatureRequests.forEach(request => {
				if (!request.file_id) return;
				// Skip deleted requests entirely - they should not affect the file tag
				if (request._deleted === 1) return;
				
				// Store the full request with recipient info
				if (!this.signatureRequestsByFile[request.file_id]) {
					this.signatureRequestsByFile[request.file_id] = [];
				}
				this.signatureRequestsByFile[request.file_id].push(request);
				
				if (!fileSignatureStatus[request.file_id]) {
					fileSignatureStatus[request.file_id] = {
						total: 0,
						completed: 0,
						pending: 0,
						expired: 0,
						cancelled: 0,
						requests: []
					};
				}
				
				const fileStatus = fileSignatureStatus[request.file_id];
				fileStatus.total++;
				fileStatus.requests.push(request);
				
				// Check request status
				// 'completed' = all recipients signed
				// 'cancelled' = request was cancelled, must not count as pending
				// 'expired' = request expired (by status or a past expires_at date)
				// 'partially_completed'/'pending' = still awaiting signatures
				if (request.status === 'completed') {
					fileStatus.completed++;
				} else if (request.status === 'cancelled') {
					fileStatus.cancelled++;
				} else if (request.status === 'expired' || this.isSignatureRequestExpired(request)) {
					fileStatus.expired++;
				} else {
					fileStatus.pending++;
				}
			});
			
		// Store the file signature status for later application
		this.fileSignatureStatus = fileSignatureStatus;
		
		// Apply status immediately if files are already loaded, otherwise watcher will handle it
		const hasPlaceholders = this.vaultFiles && this.vaultFiles.some(f => typeof f.id === 'number' && f.id < 0);
		if (!hasPlaceholders) {
			this.applySignatureStatusToFiles();
		} else {
			console.log('⚠️ vaultFiles still has placeholders. Signature status will be applied once files are loaded.');
		}
			
		} catch (error) {
			console.error('Error loading signature requests for portal:', error);
		}
	},
	applySignatureStatusToFiles() {
		if (!this.fileSignatureStatus || Object.keys(this.fileSignatureStatus).length === 0) {
			return;
		}
		
		// Update file objects with signature status
		Object.keys(this.fileSignatureStatus).forEach(fileId => {
			const statusInfo = this.fileSignatureStatus[fileId];
			let overallStatus = 'not_sent';
			let outstandingCount = statusInfo.pending;
			
			// Precedence: active (pending) requests first, then expired,
			// then completed, then cancelled. Cancelled/expired requests
			// must never surface as "Pending".
			if (statusInfo.pending > 0) {
				overallStatus = statusInfo.completed > 0 ? 'in_progress' : 'pending';
			} else if (statusInfo.expired > 0) {
				overallStatus = 'expired';
				outstandingCount = 0;
			} else if (statusInfo.completed > 0) {
				overallStatus = 'completed';
				outstandingCount = 0;
			} else if (statusInfo.cancelled > 0) {
				overallStatus = 'cancelled';
				outstandingCount = 0;
			}
			
			// Update in vaultFiles (this is the reactive data used by the UI)
			const vaultFileIndex = this.vaultFiles.findIndex(f => f.id === fileId);
			
			if (vaultFileIndex !== -1) {
				this.$set(this.vaultFiles[vaultFileIndex], 'signature_status', overallStatus);
				this.$set(this.vaultFiles[vaultFileIndex], 'signatures_outstanding', outstandingCount);
				console.log(`✅ Updated vaultFiles[${vaultFileIndex}] (${this.vaultFiles[vaultFileIndex].name}): ${overallStatus}, ${outstandingCount} outstanding`);
			}
				
			// Also update in vault.files for consistency
			if (this.vault && this.vault.files) {
				const fileIndex = this.vault.files.findIndex(f => f.id === fileId);
				if (fileIndex !== -1) {
					this.$set(this.vault.files[fileIndex], 'signature_status', overallStatus);
					this.$set(this.vault.files[fileIndex], 'signatures_outstanding', outstandingCount);
				}
			}
			
			// Also update in vault.file_infos for consistency
			if (this.vault && this.vault.file_infos) {
				const fileInfoIndex = this.vault.file_infos.findIndex(f => f.id === fileId);
				if (fileInfoIndex !== -1) {
					this.$set(this.vault.file_infos[fileInfoIndex], 'signature_status', overallStatus);
					this.$set(this.vault.file_infos[fileInfoIndex], 'signatures_outstanding', outstandingCount);
				}
			}
		});
	},
		renameFile(file, name) {
			let self = this;
			self.progress.renameFile = true;
			let now = new Date();

			// Check if file exists
			if (!file) {
				console.error("[renameFile] No file provided");
				self.notification('error', "No file selected to rename.");
				self.progress.renameFile = false;
				self.modals.renameFile = false;
				return;
			}

			if (!name) {
				self.notification('error', "Failed to Rename file, please enter a valid filename.");
				self.progress.renameFile = false;
			} else {
				//1. Get extension from file.name
				//2. Get extension from name
				//3. If name has no extension, append extension from file.name
				if (!file.folder) {
					let nameParts = name.split('.');
					let newNameExtension = name.split('.').pop();
					if (file.extension !== "fld" && (nameParts.length < 2 || newNameExtension.length > 4)) {
						file.name = name + "." + file.extension;
						file.extension = newNameExtension;
					}
				}

				vaultService.mutation("renameFile", {
					"isFolder": file.extension === "fld" ? true : false,
					"file_id": file.id,
					"org_id": this.$data.vault.org_id,
					"vault_id": this.$data.vault.id,
					"name": name
				}).then(response => {
					self.selectedFiles = [];

				self.modals.renameFile = false;
				self.progress.renameFile = false;
				self.renameFilenameValue = "";
				self.fileToRename = null;
				self.notification('success', "File rename successful!");

					vaultService.mutation("newAuditNotificationAction", {
						action: "Rename",
						vault_id: self.$data.vault.id,
						org_id: self.$data.vault.org_id,
						file_id: file.id,
						description: "From filename " + file.name,
						filename: name,
						action_date: now.getTime().toString()
					});

					self.refreshFiles(true);
				}).catch(error => {
					vaultService._log(error);
				self.modals.renameFile = false;
				self.progress.renameFile = false;
				self.renameFilenameValue = "";
				self.fileToRename = null;
				self.notification('error', "Failed to Rename file, please ensure that you have permissions and have a file extension.");
				});
			}
		},
		clickFileThumbnail(event, item, vault) {
			event.preventDefault();
			event.stopImmediatePropagation();

			if (!item) {
				this.selectedFiles = [];
			} else if (event.ctrlKey || event.shiftKey) {
				//Add or remove from selectedFiles
				let isSelectedState = false;

				for (let f = 0; f < this.selectedFiles.length; f++) {
					if (this.selectedFiles[f].id === item.id) {
						isSelectedState = true;
						this.selectedFiles.splice(f, 1);
						break;
					}
				}
				if (isSelectedState === false) {
					this.selectedFiles.push(item);
				}
			} else {
				//Replace selectedFiles with [item]
				this.selectedFiles = [item];
			}
		},
		isSelectedFile(item) {
			let isSelectedState = false;
			for (let f = 0; f < this.selectedFiles.length; f++) {
				if (this.selectedFiles[f].id === item.id) {
					isSelectedState = true;
					break;
				}
			}

			return isSelectedState;
		},
		folderDate(timestamp) {
			if (!timestamp) {
				return "";
			} else {
				return this.momentDate(timestamp);
			}
		},
		fileSize(size) {
			let bytes = size;
			if (bytes >= 1073741824) {
				bytes = (bytes / 1073741824).toFixed(2) + " GB";
			} else if (bytes >= 1048576) {
				bytes = (bytes / 1048576).toFixed(2) + " MB";
			} else if (bytes >= 1024) {
				bytes = (bytes / 1024).toFixed(2) + " KB";
			} else if (bytes > 1) {
				bytes = bytes + " bytes";
			} else if (bytes === 1) {
				bytes = bytes + " byte";
			} else {
				bytes = "0 bytes";
			}
			return bytes;
		},
		getVaultAuditHistory() {
			this.modals.auditHistory = true;
			this.auditTablePage = 1;
			this.auditSearch = "";
			this.progress.auditHistory = true;
			vaultService.query("getVaultAuditHistoryById", {
				vault_id: this.vault.id, 
				loadAuditHistory: true
			}, undefined, {vuexCache: false}).then(response => {
				const history = (response.getVaultById && response.getVaultById.audit_history) || [];
				// Format the audit history entries before displaying
				this.auditHistory = history.map((entry, index) => {
					const row = {
						...entry,
						// Audit rows have no unique id of their own; file_id repeats across actions
						_key: index
					};
					if (entry.action === 'Email') {
						// Keep the full formatted body for the email viewer, but show a
						// compact subject / recipients summary in the table row
						const parsed = this.parseEmailRecord(entry);
						row.description_formatted = this.formatEmailContent(entry.description || '');
						row.email_subject = parsed.subject;
						row.email_recipients = parsed.recipients;
					}
					row._search_text = [
						row.username,
						row.action,
						row.filename,
						row.email_subject,
						row.email_recipients,
						row.action === 'Email' ? '' : row.description
					].filter(part => !!part).join(' ').toLowerCase();
					return row;
				});
			}).catch(error => {
				console.error(error);
			}).finally(() => {
				this.progress.auditHistory = false;
			});
		},
		auditActionIcon(action) {
			const option = this.auditFilterOptions.find(opt => opt.text === action);
			return option ? option.icon : 'mdi-information-outline';
		},
		toggleAllAuditFilters() {
			if (this.allAuditFiltersSelected) {
				this.auditFilterSelection = [];
			} else {
				this.auditFilterSelection = this.auditFilterOptions.map(opt => opt.text);
			}
		},
		viewEmailRecord(item) {
			this.selectedEmailRecord = this.parseEmailRecord(item);
			this.modals.viewEmailRecord = true;
		},
		closeEmailRecord() {
			this.modals.viewEmailRecord = false;
			this.selectedEmailRecord = null;
		},
		parseEmailRecord(item) {
			// Stored format: "Sent Email Notification: <subject> to <recipients> with message: <html>"
			let raw = item.description_html || item.description || '';
			let subject = '';
			let recipients = '';
			let bodyHtml = raw;

			const marker = ' with message: ';
			const markerIndex = raw.indexOf(marker);
			if (markerIndex > -1 && raw.indexOf('Sent Email Notification: ') === 0) {
				let prefix = raw.substring('Sent Email Notification: '.length, markerIndex);
				bodyHtml = raw.substring(markerIndex + marker.length);
				let toIndex = prefix.lastIndexOf(' to ');
				if (toIndex > -1) {
					subject = prefix.substring(0, toIndex).trim();
					recipients = prefix.substring(toIndex + 4).trim();
				} else {
					subject = prefix.trim();
				}
			}

			return {
				subject: subject,
				recipients: recipients,
				bodyHtml: bodyHtml,
				sentBy: item.username || '',
				sentAt: item.action_date ? this.momentDate(item.action_date) : '',
				actionDate: item.action_date || '',
				portalName: this.vault && this.vault.name ? this.vault.name : ''
			};
		},
		// HTML shown in the preview iframe. Inline images in the original message were
		// attached by Content-ID (cid:), which isn't available here, so hide them.
		emailRecordPreviewHtml(record) {
			if (!record) {
				return '';
			}
			return this.injectIntoEmailBody(record.bodyHtml, '<style>img[src^="cid:"]{display:none;}</style>');
		},
		// Standalone HTML document for download/print: the original message with a
		// record header (subject, recipients, sender, date, portal) at the top.
		buildEmailRecordDocument(record) {
			const rows = [
				['Subject', record.subject],
				['To', record.recipients],
				['Sent by', record.sentBy],
				['Date', record.sentAt],
				['Portal', record.portalName]
			].filter(row => row[1]).map(row => {
				return `<tr><td style="padding:2px 12px 2px 0;color:#555;white-space:nowrap;"><strong>${this.escapeHtml(row[0])}:</strong></td><td style="padding:2px 0;">${this.escapeHtml(row[1])}</td></tr>`;
			}).join('');

			const header = `<style>img[src^="cid:"]{display:none;}</style>
<div style="font-family:sans-serif;font-size:13px;border-bottom:1px solid #ccc;margin-bottom:16px;padding-bottom:12px;">
	<table border="0" cellspacing="0" cellpadding="0">${rows}</table>
</div>`;

			return this.injectIntoEmailBody(record.bodyHtml, header);
		},
		injectIntoEmailBody(html, snippet) {
			html = html || '';
			const bodyTagMatch = html.match(/<body[^>]*>/i);
			if (bodyTagMatch) {
				const insertAt = bodyTagMatch.index + bodyTagMatch[0].length;
				return html.substring(0, insertAt) + snippet + html.substring(insertAt);
			}
			return `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body>${snippet}${html}</body></html>`;
		},
		emailRecordFilename(record) {
			let base = record.subject || 'email';
			base = base.replace(/[^a-z0-9\-_ ]/gi, '').trim().replace(/\s+/g, '_');
			if (!base) {
				base = 'email';
			}
			let datePart = '';
			if (record.actionDate) {
				const d = new Date(parseInt(record.actionDate, 10));
				if (!isNaN(d.getTime())) {
					datePart = '_' + d.toISOString().substring(0, 10);
				}
			}
			return `${base}${datePart}.html`;
		},
		downloadEmailRecord() {
			const record = this.selectedEmailRecord;
			if (!record) {
				return;
			}
			try {
				const blob = new Blob([this.buildEmailRecordDocument(record)], { type: 'text/html;charset=utf-8' });
				const objectUrl = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = objectUrl;
				link.download = this.emailRecordFilename(record);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
			} catch (error) {
				console.error('Unable to download email record:', error);
				this.notification('error', 'Unable to download this email, please try again.');
			}
		},
		printEmailRecord() {
			const record = this.selectedEmailRecord;
			if (!record) {
				return;
			}
			const printWindow = window.open('', '_blank');
			if (!printWindow) {
				this.notification('error', 'Please allow pop-ups to print or save this email as a PDF.');
				return;
			}
			printWindow.document.open();
			printWindow.document.write(this.buildEmailRecordDocument(record));
			printWindow.document.close();
			printWindow.focus();
			setTimeout(() => {
				printWindow.print();
			}, 250);
		},
		getFilenameForId(fileId) {
			let fileName = "";
			let tmpFile = this.vaultFiles.find(file => file.id === fileId);
			if (tmpFile) {
				fileName = tmpFile.name;
			}
			return fileName;
		},
		getFilesForPath(folderFileId, recursive) {
			let self = this;
			if (typeof folderFileId === "undefined") {
				folderFileId = this.currentFolderFile;
			}

			console.log(`Folder: ${folderFileId}`);

			let filesInFolder = [];

			if (this.vaultFiles) {
				let tmpFiles =
					this.vaultFiles
						.filter(file => file.parent_folder_file_id === folderFileId || (!folderFileId && !file.parent_folder_file_id));

				if (recursive) {
					for (let i = 0; i < tmpFiles.length; i++) {
						if (tmpFiles[i].extension === 'fld') {
							tmpFiles = tmpFiles.concat(self.getFilesForPath(tmpFiles[i].id, true));
						}
					}
				} else {
					tmpFiles = tmpFiles.filter(file => file.extension !== 'fld');
				}

				if (tmpFiles) {
					filesInFolder = tmpFiles;
				}
			}

			return filesInFolder;
		},
		getTypeName(ext) {
			return vaultService.getExtensionName(ext);
		},
		changeDirectory(parentFolderFile, refreshSelection) {
			if (typeof refreshSelection === 'undefined' || refreshSelection === true) {
				this.selectedFiles = [];
			}
			
			// Preserve file query parameter if present
			let fileQueryParam = '';
			let currentUrl = new URL(window.location.href);
			if (currentUrl.searchParams.has('file')) {
				fileQueryParam = '?file=' + currentUrl.searchParams.get('file');
			}

			if (parentFolderFile && parentFolderFile.id) {
				//console.log(`Change Dir to ${parentFolderFile.name} and id ${parentFolderFile.id}`);
				this.currentFolderFile = parentFolderFile;
				document.title = "Portal: " + this.vault.name + " - " + parentFolderFile.name;
				window.history.pushState({ directory: parentFolderFile ? parentFolderFile.id : null }, document.title, `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}${fileQueryParam}`);
				//this.$router.push(`/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}`);
				/*
				if (window.location.pathname !== `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}`) {
					this.$router.push({
						name: 'Portal',
						params: {vaultid: this.vault.id, orgid: this.vault.org_id, folderid: parentFolderFile.id}
					});
				}
				 */
			} else {
				this.currentFolderFile = null;
				document.title = "Portal: " + this.vault.name;
				window.history.pushState({ directory: parentFolderFile ? parentFolderFile.id : null }, document.title, `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main${fileQueryParam}`);
				//this.$router.push(`/org/${this.vault.org_id}/vault/${this.vault.id}`);
				/*
				if (window.location.pathname !== `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main`) {
					this.$router.push({name: 'Portal', params: {vaultid: this.vault.id, orgid: this.vault.org_id}});
				}
				 */
			}

			//this.displayFilesForPath = this.getFilesForPath(parentFolderFile ? parentFolderFile.id : null);

			let crumbs = [];
			if (parentFolderFile && parentFolderFile.id) {
				crumbs.push(parentFolderFile);
			}

			let seekFolderRoot = parentFolderFile && parentFolderFile.parent_folder_file_id ? parentFolderFile.parent_folder_file_id : null;
			while (seekFolderRoot) {
				let foundNextFolder = this.vaultFiles.find(file => file.extension === "fld" && file.id === seekFolderRoot);
				if (foundNextFolder) {
					crumbs.push(foundNextFolder);
					seekFolderRoot = foundNextFolder.parent_folder_file_id ? foundNextFolder.parent_folder_file_id : null;
				} else {
					seekFolderRoot = null;
				}
			}

			crumbs.push({
				name: "Home Folder",
				id: null //PATH VAR SHOULD BE REMOVED
			});

			crumbs.reverse();

			//console.log(`crumbs ${JSON.stringify(crumbs)}`);
			this.breadcrumbs = crumbs;

			//TODO: ASYNC LOAD Thumb for each in this.displayFilesForPath that hasn't already loaded.

		},
		editPermissions() {
			if (this.cognito && this.cognito.attributes['custom:mutableUserType'] !== "guest" && this.organization && this.cognito.attributes.sub === this.organization.id) {
				this.modals.manageGuestPerms = true;
			}
		},
		getFolderIdForPath(fullFilePath) {
			let self = this;
			return new Promise(async (resolve) => {
				let segments = fullFilePath.split('/');
				segments.pop();

				let getFolderIdForName = function(folderName, parentFolderId) {
					return new Promise((resolveFolder) => {
						let existingFolder = self.vaultFiles.find(file =>
							( file.parent_folder_file_id === (parentFolderId ? parentFolderId : null) || file.parent_folder_file_id === (parentFolderId ? parentFolderId : ""))
							&& file.name.toLowerCase() === folderName.toLowerCase()
							&& file.extension === "fld");

						if (!existingFolder && folderName) {
							//create folder
							self.createNewFolder(folderName, parentFolderId).then(folderId => {
								resolveFolder(folderId);
							});
						} else {
							resolveFolder(existingFolder ? existingFolder.id : null);
						}
					});
				};

				segments = segments.map(segment => { return { name: segment, folderId: null, parentFolderId: null }; });
				let lastSegment = null;
				while (segments.length) {
					let nextSegment = segments.shift();
					if (nextSegment.name !== 'Home Folder') {
						let tmpParentFileFolder = self.vaultFiles.find(file =>
							file.parent_folder_file_id === ((lastSegment.parentFolderId ? lastSegment.parentFolderId : null) || ((lastSegment.parentFolderId ? lastSegment.parentFolderId : "")))
							&& file.name.toLowerCase() === lastSegment.name.toLowerCase()
							&& file.extension === "fld");
						if (tmpParentFileFolder) {
							nextSegment.parentFolderId = tmpParentFileFolder.id;
						} else {
							console.log("No parent folder id.");
						}

						//find existing folder for this path.
						//1. find folders with same parent, 2. check names
						nextSegment.folderId = await getFolderIdForName(nextSegment.name, nextSegment.parentFolderId);
					}

					lastSegment = nextSegment;
				}

				resolve(lastSegment);
			});
		},
	updateGuestPermissions(email, valueToChange) {
		let self = this;
		
		// Find the member in both guest and team member lists
		let member = null;
		let memberList = null;
		
		// Check guest permissions first
		if (self.vault && self.vault.permissions) {
			member = self.vault.permissions.find(p => p.user_email === email);
			if (member) {
				memberList = self.vault.permissions;
			}
		}
		
		// If not found in guests, check team members
		if (!member && self.memberVaultPerms) {
			member = self.memberVaultPerms.find(p => p.user_email === email);
			if (member) {
				memberList = self.memberVaultPerms;
			}
		}
		
		// Store the original value before making the change
		const originalValue = member ? member[valueToChange] : null;
		
		// Optimistically update the UI
		if (member) {
			self.$set(member, valueToChange, !originalValue);
		}
		
		//console.log(`Update ${valueToChange} permissions for ${email} on vault ${self.vault.id}`)
		vaultService.mutation("updatePerms", {
			memberEmail: email,
			valueToChange,
			vaultId: self.vault.id
		}).then(response => {
			//Commenting this out to make it more fluid, might have to check again if it becomes a problem
			//self.loadVault(true);
		}).catch(error => {
			//console.log(error);
			self.notification('error', "Unable to update notification settings. Please try again.");
			
			// Revert the UI change on error
			if (member) {
				self.$set(member, valueToChange, originalValue);
			}
		});
	},
		updateGuestName(email, newName) {
			let self = this;
			if (!newName || newName.trim() === '') {
				self.notification('error', "Guest name cannot be empty.");
				// Reload the vault to reset the name
				self.loadVault(true);
				return;
			}
			
			vaultService.mutation("updatePerms", {
				memberEmail: email,
				valueToChange: 'user_name',
				vaultId: self.vault.id,
				newValue: newName.trim()
			}).then(response => {
				self.notification('success', "Guest name updated successfully.");
			}).catch(error => {
				self.notification('error', "Unable to update guest name.");
				// Reload the vault to reset the name
				self.loadVault(true);
			});
		},
		startGuestNameEdit(item) {
			// Use Vue.set to ensure reactivity for new properties
			this.$set(item, '_editingName', true);
			this.$set(item, '_editNameValue', item.user_name);
		},
		saveGuestNameEdit(item) {
			let self = this;
			if (!item._editNameValue || item._editNameValue.trim() === '') {
				self.notification('error', "Guest name cannot be empty.");
				return;
			}
			
			vaultService.mutation("updatePerms", {
				memberEmail: item.user_email,
				valueToChange: 'user_name',
				vaultId: self.vault.id,
				newValue: item._editNameValue.trim()
			}).then(response => {
				// Update the actual name and exit edit mode
				item.user_name = item._editNameValue.trim();
				item._editingName = false;
				item._editNameValue = null;
				self.notification('success', "Guest name updated successfully.");
			}).catch(error => {
				self.notification('error', "Unable to update guest name.");
				// Exit edit mode and revert to original name
				item._editingName = false;
				item._editNameValue = null;
			});
		},
		cancelGuestNameEdit(item) {
			// Exit edit mode without saving
			item._editingName = false;
			item._editNameValue = null;
		},
		getFileLinkUrl(file) {
			let fileUrl = `${location.protocol}//${window.location.hostname}${location.port !== 443 ? (':' + location.port) : ''}/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main?download=${file.id}&name=${encodeURIComponent(encodeURIComponent(file.name))}&extension=${file.extension}`;
			this.copyToClipboard(fileUrl);
			this.notification('success', `URL for file "${file.name}" has been copied to the clipboard.`);
		},
		refreshVaultToken() {
			let self = this;

			vaultService.getVaultToken(self.vault).then(response => {
				if (response.token) {
					self.$data.vaultToken = response.token;
				}
			}).catch(error => {
				self.$data.vaultToken = null;
				self.error("Invalid permissions for vault token.");
				//self.notification('error', "Invalid permissions.");
			});
		},
		pathFromParentFolderId(parentFolderId) {
			let path = "/";
			let tmpId = parentFolderId;
			try {
				while (tmpId) {
					let tmpFileEntry = this.vaultFiles.find(file => file.id === tmpId);
					if (tmpFileEntry) {
						path = "/" + tmpFileEntry.name + path;
						let tmpTmpId = tmpFileEntry && tmpFileEntry.parent_folder_file_id ? tmpFileEntry.parent_folder_file_id : null;
						tmpId = tmpTmpId !== tmpId ? tmpTmpId : null;
					} else {
						tmpId = null;
					}
				}
			} catch (e) {
				tmpId = null;
				console.dir(e);
			}

			if (path === "/" && this.vault) {
				path = this.vault.name;
			}

			return path;
		},
		getZipEntryPathForFile(fileShell) {
			let folderSegments = [];
			let parentFolderId = fileShell && fileShell.parent_folder_file_id ? fileShell.parent_folder_file_id : null;

			while (parentFolderId) {
				let folder = this.vaultFiles.find(file => file.id === parentFolderId && file.extension === 'fld');
				if (folder) {
					folderSegments.unshift(folder.name);
					parentFolderId = folder.parent_folder_file_id ? folder.parent_folder_file_id : null;
				} else {
					parentFolderId = null;
				}
			}

			if (folderSegments.length > 0) {
				return folderSegments.join('/') + '/' + fileShell.name;
			}

			return fileShell.name;
		},
		copyToClipboard(str) {
			const el = document.createElement('textarea');  // Create a <textarea> element
			el.value = str;                                 // Set its value to the string that you want copied
			el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
			el.style.position = 'absolute';
			el.style.left = '-9999px';                      // Move outside the screen to make it invisible
			document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
			const selected =
				document.getSelection().rangeCount > 0        // Check if there is any content selected previously
					? document.getSelection().getRangeAt(0)     // Store selection if found
					: false;                                    // Mark as false to know no selection existed before
			el.select();                                    // Select the <textarea> content
			document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
			document.body.removeChild(el);                  // Remove the <textarea> element
			if (selected) {                                 // If a selection existed before copying
				document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
				document.getSelection().addRange(selected);   // Restore the original selection
			}
		},
	loadVault(skipToken) {
		let self = this;
		vaultService.query("getVaultById", {vault_id: self.$route.params.vaultid,loadAuditHistory: false}, undefined, {vuexCache: false}).then(vault => {
			if(vault === "DELETED_VAULT"){
				self.error("Portal is Deleted.");
				self.notification('error', "Portal has been Deleted.");
				self.$router.push('/vaults');
			}
			//DONE: Set org id in state.
			if (self.cognito && self.cognito.attributes["custom:mutableUserType"] === "guest") {
				self.organizationId = vault.org_id;
				EventBus.$emit("refreshlazy", {oldId: "", newId: self.organizationId});
				self.loadDemoOrgInfo(vault.org_id);
			}
			
			// Load workflows for organization
			self.loadWorkflows();

		self.memberVaultPerms = [];
		self.originalVaultName = vault.name;

			//userVaultPermissions
			let existingMemberVaultPerms = null;
			if (vault) {
				existingMemberVaultPerms = vault.permissions.find(vPerm => self.cognito.attributes.sub === vPerm.user_id && vPerm._deleted !== 1);
				if (existingMemberVaultPerms) {
					self.userVaultPermissions.view_files = existingMemberVaultPerms.view_files;
					self.userVaultPermissions.upload_files = existingMemberVaultPerms.upload_files;
					self.userVaultPermissions.rename_files = existingMemberVaultPerms.rename_files;
					self.userVaultPermissions.delete_files = existingMemberVaultPerms.delete_files;
					self.userVaultPermissions.manage_perms = existingMemberVaultPerms.manage_perms;
					self.userVaultPermissions.create_vault = existingMemberVaultPerms.create_vault;
					self.userVaultPermissions.access_vault = existingMemberVaultPerms.access_vault;
				}
			}

			self.$data.vault = vault;
			
			// Ensure workflow state name is synced with ID if missing
			// This must happen AFTER vault is assigned so computed properties work correctly
			if (vault.workflowStateId && (!vault.workflowStateName || vault.workflowStateName === 'Not Set')) {
				self.$nextTick(() => {
					self.syncWorkflowStateName(vault);
				});
			}

				// Initialize tags for editing
				if (!Array.isArray(self.$data.vault.tags)) {
					self.$data.vault.tags = [];
				}
				self.$data.vault._editTagsArray = [...self.$data.vault.tags];

				// Initialize external system IDs for editing
				if (self.organization && self.organization.externalSystems) {
					// Parse if stored as JSON string (AWSJSON type returns a string)
					let storedIds = self.$data.vault.externalSystemIds || {};
					if (typeof storedIds === 'string') {
						try {
							storedIds = JSON.parse(storedIds);
						} catch (e) {
							console.error("Failed to parse externalSystemIds:", e);
							storedIds = {};
						}
					}
					// Stored keys match the org label case-insensitively ("taxi" set via the API
					// shows under the org's "Taxi" label); saving re-keys under the label.
					self.organization.externalSystems.forEach(system => {
						const editKey = '_editExternalId_' + system;
						const storedKey = Object.keys(storedIds).find(k => k.toLowerCase() === String(system).toLowerCase());
						self.$set(self.$data.vault, editKey, storedKey ? storedIds[storedKey] || '' : '');
					});
				}
				
				//For each permission on the organization.permissions...
				if (self.organization) {
					for (let i = 0; i < self.organization.permissions.length; i++) {
						let orgPermission = self.organization.permissions[i];
						
						// Skip deleted permissions
						if (orgPermission._deleted === 1) {
							continue;
						}

						if (existingMemberVaultPerms && self.cognito.attributes.sub === orgPermission.user_id) {
							orgPermission.upload_notification = orgPermission.upload_notification || !!existingMemberVaultPerms.upload_notification;
							orgPermission.download_notification = orgPermission.download_notification || !!existingMemberVaultPerms.download_notification;
						} else {
							orgPermission.upload_notification = false;
							orgPermission.download_notification = false;
						}

						if (orgPermission.user_id === self.cognito.attributes.sub) {
							self.userVaultPermissions.view_files = self.userVaultPermissions.view_files || orgPermission.view_files;
							self.userVaultPermissions.upload_files = self.userVaultPermissions.upload_files || orgPermission.upload_files;
							self.userVaultPermissions.rename_files = self.userVaultPermissions.rename_files || orgPermission.rename_files;
							self.userVaultPermissions.delete_files = self.userVaultPermissions.delete_files || orgPermission.delete_files;
							self.userVaultPermissions.create_vault = self.userVaultPermissions.create_vault || orgPermission.create_vault;
							self.userVaultPermissions.access_vault = self.userVaultPermissions.access_vault || orgPermission.access_vault;
						}

						self.memberVaultPerms.push(orgPermission);
					}

					try {
						woopra.identify({Company: self.organization.companyName});
					} catch (error) {
						console.log("Unable to track comapny name.")
					}
				}

			document.title = "Portal: " + vault.name;

			// Load signature requests for this portal and update file statuses
			self.loadSignatureRequestsForPortal(vault.id);

			// Taxi file push: delivery statuses for the file list (no-op unless linked + manage_perms),
			// and re-run the link check if a Taxi id is set but the stored link is stale
			self.loadTaxiDeliveries();
			self.autoVerifyTaxiLink();

			if (skipToken !== true) {
					vaultService.getVaultToken(vault).then(response => {
						if (response.token) {
							//self.debug(`Got portal token.`);
							//self.debug(token);
							self.$data.vaultToken = response.token;
							self.$data.thumbBucket = response.awsMobile.aws_user_thumbs_s3_bucket;

							//Flag need to accept terms, set terms, check user for terms accepted
							if (!self.user.acceptedTermVaults || self.user.acceptedTermVaults.indexOf(self.vault.id) < 0) {
								if (response.token.termsEnforced === true
									&& (self.cognito.attributes["custom:mutableUserType"] === "guest" || self.user.memberOf !== self.vault.org_id)) {
									//alert(response.token.termsAndConditions);
									self.termsAndConditions = response.token.termsAndConditions;
									self.termsDialog = true;
									// If the first-open welcome prompt beat the token response,
									// pull it back until the guest accepts the terms.
									if (self.firstActionDialog) {
										self.firstActionDialog = false;
										self.firstActionWaitingOnTerms = true;
									}
								}
							}

							if (self.$data.tokenRefreshTimer) {
								clearInterval(self.$data.tokenRefreshTimer);
							}

							self.$data.tokenRefreshTimer = setInterval(function() {
								self.refreshVaultToken();
							}, 1200000);

							//TODO: Check url parameters to download file.
							if (self.$route.query.download) {
								let downloadFile = {
									id: self.$route.query.download,
									name: self.$route.query.name,
									extension: self.$route.query.extension
								};

								window.history.replaceState({}, document.title, `/org/${self.vault.org_id}/vault/${self.vault.id}/folder/main`);

								try{
									downloadFile.name = decodeURIComponent(downloadFile.name);
									self.selectFileToPreview(downloadFile,self.vault);
								}catch (e) {
									console.log("Trying to open file from URL : " + JSON.stringify(e));
									self.notification("error", "Unable to open file, please try again.");
								}
								/*vaultService.downloadSignedFile(vault, downloadFile).then(() => {
									self.setFileDownloadedBy(downloadFile);
								}).catch(error => {
									//console.log(JSON.stringify(error));
									self.notification("error", "Unable to download file, please try again.");
								});*/
							}

					vaultService.query("getTasksByVaultId", {vault_id: self.vault.id}, undefined, {vuexCache: false}).then(response => {
						self.vaultTasks = response;
						if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
							self.viewMode = 1;
						} else {
							self.viewMode = 0;
						}
						self.getTasksForCalendar();
					}).catch(error => {
								console.error(error);
							});

							self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
						} else {
							self.error("Invalid permissions for vault token.");
							self.notification('error', "Invalid permissions.");

							self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
						}
					}).catch(error => {
						self.$data.vaultToken = null;
						self.error("Error: Invalid Permissions to access portal.");
						//self.notification('error', "Invalid permissions.");

						self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
					});

					vaultService.mutation("newAuditNotificationAction", {
						action: "Open Portal",
						vault_id: self.vault.id,
						org_id: self.vault.org_id,
						description: "Portal accessed by user.",
						action_date: (new Date()).getTime().toString()
					});

					// Initialize WebRTC presence
					self.initializePresence();
				}
			}).catch(error => {
				if(error.message === "GraphQL error: DELETED_VAULT"){
					self.error("Portal is Deleted.");
					self.notification('error', "Portal has been Deleted.");
				}else{
					self.error("Unable to get vault by id.");
					self.notification('error', "Unable to access portal.");
				}
				self.$router.push('/vaults');
			});
		},
		extensionIcon(ext) {
			let icon = "fa fa-file";
			if (ext) {
				switch (ext.toLowerCase()) {
					case "doc":
					case "docx":
						icon = "fas fa-file-word";
						break;
					case "pdf":
						icon = "fas fa-file-pdf";
						break;
					case "txt":
						icon = "fas fa-file-alt";
						break;
					case "fld":
						icon = "fas fa-folder";
						break;
					case "url":
						icon = "fas fa-external-link-alt";
						break;
					case "jpg":
					case "jpeg":
					case "gif":
					case "png":
					case "tif":
					case "tiff":
					case "bmp":
					case "eps":
					case "svg":
					case "webp":
						icon = "fas fa-file-image";
						break;
				case "mp4":
				case "mpg":
				case "mov":
				case "m4v":
				case "webm":
					icon = "fas fa-file-video";
					break;
					case "mp3":
					case "wav":
					case "aif":
						icon = "fas fa-file-audio";
						break;
					case "pptx":
					case "ppt":
						icon = "fas fa-file-powerpoint";
						break;
					case "xlsx":
					case "xls":
						icon = "fas fa-file-excel";
						break;
					default:
						icon = "fas fa-file";
						break;
				}
			}
			return icon;
		},
		retryFileFromQueue(fileId) {
			console.log(`Retry file from queue ${fileId}`);
			for (let sf = 0; sf < this.uploadFileQueue.length; sf++) {
				if (this.uploadFileQueue[sf].upload.uuid === fileId) {
					//this.debug(`Set file from queue to RETRY ${this.uploadFileQueue[sf].name}`);
					console.log(`Set file from queue to RETRY ${this.uploadFileQueue[sf].entry.name}`);
					this.uploadFileQueue[sf].status = "retry";
					break;
				}
			}
		},
		editVaultName() {
			this.vaultNameEditing = true;
			setTimeout(() => {
				if (document.getElementById("vault-name")) {
					document.getElementById("vault-name").focus();
				}
			}, 100);

		},
		updateVaultName() {
			let self = this;
			if (self.vault) {
				let existingVaultName = self.vaults.find(vault => vault.name.toLowerCase().trim() === self.vault.name.toLowerCase().trim() && vault.id !== self.vault.id);
				
				if (!existingVaultName) {
					vaultService.mutation("updateVaultSettings", {
						"vault_id": self.$data.vault.id,
						"org_id": self.$data.vault.org_id,
						"name": self.vault.name,
						"archived": Boolean(self.vault.archived) || false,
						"private_mode": Boolean(self.vault.private_mode) || false,
						"hide_perms": Boolean(self.vault.hide_perms) || false,
						"isTemplate": Boolean(self.vault.isTemplate) || false
					}).then(() => {
						self.notification('success', "Portal name updated.");
						self.originalVaultName = self.vault.name;
					}).catch(error => {
						self.notification('error', "Unable to rename portal.");
						self.vault.name = self.originalVaultName;
					});
				} else {
					self.notification('error', "Unable to rename portal.");
					self.vault.name = self.originalVaultName;
				}
			}
		},
		updateVaultHidePerms(){
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"hide_perms": !!self.vault.hide_perms,
					"archived": Boolean(self.vault.archived) || false,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.loadVault();
					self.notification('success', "Portal hide permissions changed.");
				}).catch(error => {
					self.notification('error', "Unable to update portal hide permissions.");
					self.vault.hide_perms = !self.vault.hide_perms;
				});
			}
		},
		updateVaultPrivateMode() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"private_mode": !!self.vault.private_mode,
					"archived": Boolean(self.vault.archived) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal privacy mode updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal privacy mode.");
					self.vault.private_mode = !self.vault.private_mode;
				});
			}
		},
		updateVaultArchiveStatus() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"archived": !!self.vault.archived,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal archive status updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal archive status.");
					self.vault.archived = !self.vault.archived;
				});
			}
		},
		updateVaultTemplateStatus() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"isTemplate": !!self.vault.isTemplate,
					"archived": Boolean(self.vault.archived) || false,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false
				}).then(() => {
					self.notification('success', "Portal template status updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal template status.");
					self.vault.isTemplate = !self.vault.isTemplate;
				});
			}
		},
syncWorkflowStateName(vault) {
	// Helper method to ensure workflowStateName is synced with workflowStateId
	// This provides resilience when the name field is missing but ID is present
	let self = this;
	
	if (!vault || !vault.workflowStateId) {
		return;
	}
	
	// Determine which workflow states array to use
	let workflowStates = [];
	if (self.organization && self.organization.workflowStates && self.organization.workflowStates.length > 0) {
		workflowStates = self.organization.workflowStates;
	} else if (vault.orgWorkflowStates && vault.orgWorkflowStates.length > 0) {
		workflowStates = vault.orgWorkflowStates;
	}
	
	if (workflowStates.length === 0) {
		return;
	}
	
	// Look up the name from the ID
	const state = workflowStates.find(s => s.id === vault.workflowStateId);
	if (state && state.name) {
		// Update the vault object with the looked-up name using Vue.set for reactivity
		self.$set(vault, 'workflowStateName', state.name);
	}
},
	
	updateVaultWorkflowState() {
		let self = this;
		
		// New workflow system
		if (self.isUsingNewWorkflowSystem && self.vault) {
			// Update currentWorkflowStateId
			vaultService.mutation("updateVaultSettings", {
				"vault_id": self.vault.id,
				"org_id": self.vault.org_id,
				"currentWorkflowStateId": self.vault.currentWorkflowStateId,
				"archived": Boolean(self.vault.archived) || false,
				"private_mode": Boolean(self.vault.private_mode) || false,
				"hide_perms": Boolean(self.vault.hide_perms) || false,
				"isTemplate": Boolean(self.vault.isTemplate) || false
			}).then(() => {
				// Refresh vault to get updated currentWorkflowStateName
				self.loadVault();
				const stateName = self.currentWorkflowStateName;
				if (stateName) {
					self.notification('success', "Portal workflow status updated to: " + stateName);
				}
			}).catch(error => {
				self.notification('error', "Unable to update portal workflow status.");
				console.error("Error updating workflow state:", error);
			});
			return;
		}
		
		// Legacy workflow system
		if (self.vault && self.organization && self.organization.workflowStatesEnabled) {
			// Find the current workflow state name
			let workflowStateName = null;
			let workflowStateId = self.vault.workflowStateId;
			
			if (workflowStateId && self.organization.workflowStates) {
				const currentState = self.organization.workflowStates.find(state => state.id === workflowStateId);
				workflowStateName = currentState ? currentState.name : null;
			}
			
			// If workflowStateId is null (cleared), also clear the name
			if (workflowStateId === null || workflowStateId === undefined) {
				workflowStateName = null;
			}
			
			vaultService.mutation("updateVaultSettings", {
				"vault_id": self.$data.vault.id,
				"org_id": self.$data.vault.org_id,
				"workflowStateId": workflowStateId,
				"workflowStateName": workflowStateName,
				"archived": Boolean(self.vault.archived) || false,
				"private_mode": Boolean(self.vault.private_mode) || false,
				"hide_perms": Boolean(self.vault.hide_perms) || false,
				"isTemplate": Boolean(self.vault.isTemplate) || false
			}).then(() => {
				// Update the local vault object with the new workflow state name
				self.vault.workflowStateName = workflowStateName;
				if (workflowStateName) {
					self.notification('success', "Portal workflow status updated to: " + workflowStateName);
				} else {
					self.notification('success', "Portal workflow status cleared.");
				}
			}).catch(error => {
				self.notification('error', "Unable to update portal workflow status.");
				console.error("Error updating workflow state:", error);
			});
		}
	},
	
	// Load workflows for organization
	loadWorkflows() {
		let self = this;
		if (!self.organizationId) return;
		// Host-only: guests are not org members, so the backend rejects this query.
		if (self.isGuestUser) return;
		
		vaultService.query("getWorkflowsByOrgId", {
			org_id: self.organizationId
		}).then(workflows => {
			self.availableWorkflows = workflows || [];
			
			// Auto-select default workflow if vault doesn't have one assigned
			if (self.vault && !self.vault.workflowId && workflows && workflows.length > 0) {
				// Find the default workflow
				const defaultWorkflow = workflows.find(w => w.is_default === true);
				if (defaultWorkflow) {
					// Set it in the v-select model (this won't persist until user saves or we auto-save)
					self.$set(self.vault, 'workflowId', defaultWorkflow.id);
					self.$set(self.vault, 'workflow', defaultWorkflow);
				}
			}
		}).catch(error => {
			console.error("Error loading workflows:", error);
			self.availableWorkflows = [];
		});
	},
	
	// Switch vault to a different workflow
	switchVaultWorkflow(workflowId) {
		let self = this;
		if (!self.vault) return;
		
		vaultService.mutation("updateVaultSettings", {
			"vault_id": self.vault.id,
			"org_id": self.vault.org_id,
			"workflowId": workflowId,
			// currentWorkflowStateId will be auto-set to first state by backend
			"archived": Boolean(self.vault.archived) || false,
			"private_mode": Boolean(self.vault.private_mode) || false,
			"hide_perms": Boolean(self.vault.hide_perms) || false,
			"isTemplate": Boolean(self.vault.isTemplate) || false
		}).then(() => {
			// Refresh vault to get updated workflow information
			self.loadVault();
			self.notification('success', "Portal workflow updated successfully");
		}).catch(error => {
			self.notification('error', "Unable to update portal workflow.");
			console.error("Error switching workflow:", error);
		});
	},
		clearSelectedFiles() {
			this.selectedFiles = [];
		},
		hasPendingUploads() {
			return !!this.uploadFileQueue.find(file => file.status === "queued");
		},
		doubleCheckUploadStatus() {
			//this.debug("Run upload status checker..");
			let self = this;
			if (!self.uploadRunnerTimer) {
				self.uploadRunnerTimer = setInterval(self.doubleCheckUploadStatus, 5000);
			}

			if (self.queuePaused === false) {
				if (self.uploadInProgress !== true && self.uploadFileQueue.length > 0) {
					//self.debug("Double Check the Upload Queue status.");
					self.uploadFiles();
				} else if (self.uploadInProgress === true && self.uploadFileQueue.length === 0) {
					self.uploadInProgress = false;
				}

				let now = new Date();

				let foundPending = false;
				if (self.uploadFileQueue.length > 0) {
					for (let f = 0; f < self.uploadFileQueue.length; f++) {
						if (self.uploadFileQueue[f].status === "done") {
							try {
								/*let afterSeconds = new Date(self.uploadFileQueue[f].upload.completedAt.getTime() + 15000);
								if (now > afterSeconds) { //timeout after 15 seconds
									self.uploadFileQueue.splice(f, 1);
									f = 0;
								}*/
							} catch (exception) {
								self.error("Unable to parse file upload completion date.");
							}
						} else if (self.uploadFileQueue[f].status !== "done" && self.uploadFileQueue[f].status !== "error") {
							foundPending = true;
						}
					}
				}

				if (foundPending === true && self.uploadInProgress === false) {
					self.uploadFiles();
				}
			}
		},
		// Helper to fetch all file pages using the paginated API
		async fetchAllFilePages(vaultId, showDeleted, accumulatedFiles, nextToken) {
			let self = this;
			accumulatedFiles = accumulatedFiles || [];
			
			let queryParams = {
				vault_id: vaultId,
				show_deleted: showDeleted,
				limit: 500
			};
			if (nextToken) {
				queryParams.nextToken = nextToken;
				console.log("NextToken: " + nextToken);
			}
			
			let result = await vaultService.query("getFilesByVaultIdPaginated", queryParams, undefined, {vuexCache: false});
			
			// Handle paginated response structure
			let items = result && result.items ? result.items : [];
			let responseNextToken = result && result.nextToken ? result.nextToken : null;
			
			accumulatedFiles = accumulatedFiles.concat(items);
			
			if (responseNextToken) {
				return self.fetchAllFilePages(vaultId, showDeleted, accumulatedFiles, responseNextToken);
			}
			
			return accumulatedFiles;
		},
		refreshFiles(stayPut, showDeleted, folderFileId, markUnreadSelected, includeTasks) {
			let self = this;
			if (typeof showDeleted === "undefined") {
				showDeleted = false;
			}
			self.showingDeleted = showDeleted;

			if (self.userVaultPermissions.view_files) {
				// Use paginated API to avoid "Transformation too large" error
				self.fetchAllFilePages(this.$data.vault.id, showDeleted, [], null).then(filesResult => {
					self.vaultFiles = filesResult; //.filter(file => file._deleted !== 1); //TODO: Duplicate key found?!
					self.loadingFiles = false;
					// Keep Taxi "Sent / Sending / Failed" badges current whenever the list refreshes
					self.loadTaxiDeliveries();
					
					// Check for file query parameter on initial load to open file preview from URL
					if (!self.initialFileFromUrlProcessed && self.$route.query.file) {
						self.initialFileFromUrlProcessed = true;
						let fileIdFromUrl = self.$route.query.file;
						let fileToPreview = filesResult.find(function(f) { return f.id === fileIdFromUrl; });
						if (fileToPreview) {
							// Use $nextTick to ensure DOM is ready before opening preview
							self.$nextTick(function() {
								// Opening a file directly from its ?file= URL should always
								// load the PDF preview, never redirect into the sign/return
								// workbench - so skip the pending signature-request check.
								self.selectFileToPreview(fileToPreview, self.vault, true, true);
							});
						} else {
							console.log('File not found for preview from URL: ' + fileIdFromUrl);
						}
					}

					// "Invite to Join" deep link: accept the invitation (we bypass the /vaults
					// auto-accept screen) and auto-join the live call so the presentation syncs in.
					if (!self.autojoinCallProcessed && (self.$route.query.autojoinCall === "1" || self.$route.query.autojoinCall === 1)) {
						self.autojoinCallProcessed = true;
						self.acceptInviteAndJoinCall();
					}

					// "Start call" deep link from the Vaults presence dashboard: a member
					// jumps into the portal and immediately opens the video call.
					if (!self.startCallProcessed && (self.$route.query.startCall === "1" || self.$route.query.startCall === 1)) {
						self.startCallProcessed = true;
						self.$nextTick(function() {
							if (!self.isInCall) {
								self.startVideoCall();
							}
						});
					}

					// First-open invited action prompt (upload/download) - initial load only.
					// Skipped when a deep link is already opening a file or joining a call.
					if (!self.firstOpenActionProcessed) {
						self.firstOpenActionProcessed = true;
						if (!self.$route.query.file && !self.$route.query.autojoinCall && !self.$route.query.download) {
							self.checkFirstOpenAction();
						} else {
							self.checkPasswordSetupPrompt();
						}
					}
					
					if (self.$data.fileRefreshTimer) {
						clearInterval(self.$data.fileRefreshTimer);
					}


					self.$data.fileRefreshTimer = setInterval(function() {
						self.refreshFiles(true, false, undefined, undefined, true);
					}, 120000);
					if (filesResult) {
						for (let f = 0; f < filesResult.length; f++) {
							let existingCommentByUser = filesResult[f].comments.find(comment => comment.created_by === this.user.id);
							if (existingCommentByUser) {
								self.comments[filesResult[f].id] = existingCommentByUser.comment;
							}
						}
					}

					if (markUnreadSelected) {
						self.selectUnreadFiles();
					}

					if (stayPut !== true) {
						self.changeDirectory();
					} else {
						if (folderFileId) {
							self.currentFolderFile = self.vaultFiles.find(file => file && file.id === folderFileId);
						}
						self.changeDirectory(self.currentFolderFile, false);
					}

					if (includeTasks) {
						vaultService.query("getTasksByVaultId", {vault_id: self.vault.id}, undefined, {vuexCache: false}).then(response => {
							self.vaultTasks = response;
							if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
								self.viewMode = 1;
							} else {
								self.viewMode = 0;
							}
							self.getTasksForCalendar();
						}).catch(error => {
							console.error(error);
						});
					}
				}).catch(filesError => {
					self.error("Unable to read vault files. " + JSON.stringify(filesError));
					this.notification('error', "Unable to read vault files.");
				});
			} else {
				self.vaultFiles = [];
				self.loadingFiles = false;

				if (self.$data.fileRefreshTimer) {
					clearInterval(self.$data.fileRefreshTimer);
				}
			}
		},
		filterFilesOnSearch(value, search, item) {
			return value != null &&
				search != null &&
				typeof value === 'string' &&
				(item.extension !== "fld" && item._deleted !== 1) &&
				value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
		},
		addInviteField(index) {
			this.invitees.push({email: "", name: ""});
		},
		removeInviteField(index) {
			this.invitees.splice(index, 1);
		},
		insertInviteVariable(variableName) {
			// Insert the variable template at the cursor position or at the end
			const variable = `{{${variableName}}}`;
			if (this.$refs.customMessageTextarea) {
				const textarea = this.$refs.customMessageTextarea.$refs.input;
				if (textarea) {
					const start = textarea.selectionStart;
					const end = textarea.selectionEnd;
					const text = this.customInviteMessage || '';
					this.customInviteMessage = text.substring(0, start) + variable + text.substring(end);
					// Set cursor position after the inserted variable
					this.$nextTick(() => {
						textarea.focus();
						textarea.setSelectionRange(start + variable.length, start + variable.length);
					});
				} else {
					this.customInviteMessage = (this.customInviteMessage || '') + variable;
				}
			} else {
				this.customInviteMessage = (this.customInviteMessage || '') + variable;
			}
		},
		closeInviteDialog() {
			this.modals.inviteGuests = false;
			this.invitees = [{email: '', name: ''}];
			this.inviteAuthType = 'password';
			this.inviteMode = 'none';
			this.customInviteMessage = '';
		},
		openInviteToJoinDialog() {
			this.joinInvitees = [{email: '', name: ''}];
			this.joinInviteSelectedGuests = [];
			this.modals.inviteToJoin = true;
		},
		closeInviteToJoinDialog() {
			this.modals.inviteToJoin = false;
			this.joinInvitees = [{email: '', name: ''}];
			this.joinInviteSelectedGuests = [];
		},
		addJoinInvitee() {
			this.joinInvitees.push({email: '', name: ''});
		},
		removeJoinInvitee(index) {
			this.joinInvitees.splice(index, 1);
			if (this.joinInvitees.length === 0) {
				this.joinInvitees.push({email: '', name: ''});
			}
		},
		inviteToJoinCall() {
			let self = this;
			if (!self.presenting || !self.presenting.active || !self.presenting.isPresenter || !self.presenting.fileId) {
				self.notification("error", "Start presenting a file before inviting guests to join.");
				return;
			}

			let emailList = [];
			let nameList = [];
			let guests = [];
			let seen = {};

			// Existing guests selected for re-invite (already have access; we just resend a join link).
			for (let i = 0; i < self.joinInviteSelectedGuests.length; i++) {
				let email = (self.joinInviteSelectedGuests[i] || "").trim().toLowerCase();
				if (!email || seen[email]) {
					continue;
				}
				let match = self.existingGuestsForJoin.find(function(g) { return g.email.toLowerCase() === email; });
				let name = match ? match.name : email;
				seen[email] = true;
				emailList.push(email);
				nameList.push(name);
				guests.push("<" + name + "> " + email);
			}

			// Newly entered guests.
			for (let i = 0; i < self.joinInvitees.length; i++) {
				let invitee = self.joinInvitees[i];
				if (!invitee || (!invitee.email && !invitee.name)) {
					continue;
				}
				if (!invitee.email || !invitee.name) {
					self.notification("error", "Name and Email are both required for each new guest.");
					return;
				}
				let email = invitee.email.trim().toLowerCase();
				let name = invitee.name.trim();
				if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
					self.notification("error", "Invalid email address: " + invitee.email);
					return;
				}
				if (seen[email]) {
					continue;
				}
				seen[email] = true;
				emailList.push(email);
				nameList.push(name);
				guests.push("<" + name + "> " + email);
			}

			if (emailList.length === 0) {
				self.notification("error", "Select an existing guest or enter at least one new guest to invite.");
				return;
			}

			self.joinInviteLoading = true;
			let orgLogo = self.organization && self.organization.logo_s3_path ? self.organization.logo_s3_path : "zapa";

			vaultService.mutation("inviteNewGuest", {
				guestEmail: guests.join(";"),
				emailList,
				nameList,
				vaultId: self.vault.id,
				logo: orgLogo,
				authType: "magicLink",
				joinFileId: self.presenting.fileId
			}).then(function(response) {
				self.joinInviteLoading = false;
				if (response) {
					try {
						let now = new Date();
						vaultService.mutation("newAuditNotificationAction", {
							action: "Invite to Join",
							vault_id: self.vault.id,
							org_id: self.vault.org_id,
							description: "Invite to join live call: " + guests.join(";"),
							action_date: now.getTime().toString()
						});
					} catch (auditError) {
						console.error("Unable to record audit action for invite to join.");
					}
					self.closeInviteToJoinDialog();
					self.notification("success", "Invitation(s) sent. Guests will receive a magic link to join.");
					self.loadVault(true);
				}
			}).catch(function(error) {
				self.joinInviteLoading = false;
				self.notification("error", "Unable to send join invitation(s).");
			});
		},
		revokeVaultInvite(email) {
			//TEST: Remove member from vault.permissions
			let self = this;
			vaultService.mutation("updatePerms", {
				memberEmail: email,
				valueToChange: "revoke",
				vaultId: self.vault.id
			}).then(response => {
				for (let i = 0; i < self.vault.permissions.length; i++) {
					if (self.vault.permissions[i].user_email.toLowerCase() === email.toLowerCase())
						self.vault.permissions[i]._deleted = 1;
				}
			}).catch(error => {
				//console.log(error);
				self.notification('error', "Unable to revoke guest permissions.");
			});
		},
		validateEmail(email) {
			let self = this;
			let error = null;
			//check for validationError based both on existing email and valid email address format.
			let existingGuestPermissions = self.vault.permissions.find(perm => perm._deleted !== 1 && perm.user_email.toLowerCase() === email.toLowerCase());
			if (existingGuestPermissions) {
				error = `A guest with the email address ${existingGuestPermissions.user_email} already exists, please remove or update this invitation.`;
			} else if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
				error = "Invalid email address.";
			}
			return error;
		},
		sendVaultInvite(name, email,isResend) {
			let self = this;
			this.invitationLoading = true;
			this.progress.resendInvitation = true;
			let guests = [];
			let emailList = [];
			let nameList = [];
			let invalidData = false;
			let validationError = null;

			if (name && email) {
				name = name.trim();
				email = email.trim();
				guests.push(`<${name}> ${email}`);
				emailList.push(email.toLowerCase());
				nameList.push(name);
				if(!isResend){
					validationError = self.validateEmail(email);
				}

			} else {
				for (let i = 0; i < self.invitees.length; i++) {
					let invitee = self.invitees[i];
					if (!invitee.name || !invitee.email) {
						invalidData = true;
						break;
					} else {
						invitee.name = invitee.name.trim();
						invitee.email = invitee.email.trim().toLowerCase();

						let existingGuestPermissions = null;
						for (let g = 0; g < self.vault.permissions.length; g++) {
							if (self.vault.permissions[g].user_email.toLowerCase() === invitee.email && self.vault.permissions[g]._deleted !== 1) {
								existingGuestPermissions = self.vault.permissions[g];
								break;
							}
						}

						if (existingGuestPermissions) {
							validationError = `A guest with the email address ${existingGuestPermissions.user_email} already exists, please remove or update this invitation.`;
							break;
						} else {
							validationError = self.validateEmail(invitee.email);
							if(validationError){
								break;
							}
						}
						guests.push(`<${invitee.name}> ${invitee.email}`);
						emailList.push(invitee.email);
						nameList.push(invitee.name);
					}
				}
			}

			if (validationError) {
				this.invitationLoading = false;
				this.progress.resendInvitation = false;
				this.notification("error", validationError);
			} else if (invalidData === true) {
				this.invitationLoading = false;
				this.progress.resendInvitation = false;
				this.notification("error", "Name and Email are both required fields for an invitation.");
			} else {
				if (guests.length === 0) {
					alert("No guest information available.");
					this.invitationLoading = false;
					this.progress.resendInvitation = false;
				} else {
					let orgLogo = this.organization.logo_s3_path ? this.organization.logo_s3_path : "zapa";
					
					// Gather open tasks for the invitation email
					let openTasks = this.vaultTasks
						.filter(t => t.status !== "Done" && t._deleted !== 1)
						.map(t => t.title);
					
					// Gather file names for the invitation email (exclude folders)
					let fileNames = this.vaultFiles
						.filter(f => f._deleted !== 1 && f.extension !== 'fld')
						.map(f => f.name);
					
					vaultService.mutation("inviteNewGuest", {
						guestEmail: guests.join(";"),
						emailList,
						nameList,
						vaultId: this.vault.id,
						logo: orgLogo,
						authType: this.inviteAuthType,
						inviteMode: this.inviteMode === 'none' ? null : this.inviteMode,
						customMessage: this.customInviteMessage || null,
						openTasks,
						fileNames
					}).then(response => {
						this.invitationLoading = false;
						this.progress.resendInvitation = false;
						this.modals.inviteGuests = false;
						if (response) {
							try {
								woopra.track("New Guest Invited", {Vault: self.vault.id, OrgId: self.vault.org_id});
							} catch (woopraError) {
								console.error("Woopra not loaded.");
							}

							let now = new Date();
							vaultService.mutation("newAuditNotificationAction", {
								action: "Invite Guest",
								vault_id: self.vault.id,
								org_id: self.vault.org_id,
								description: "Invite guest " + guests.join(";") + " (auth: " + self.inviteAuthType + ")",
								action_date: now.getTime().toString()
							});

							this.invitees = [{
								email: "",
								name: ""
							}];
							this.inviteAuthType = 'password';
							this.inviteMode = 'none';
							this.customInviteMessage = '';
							this.notification("success", "Invitation(s) sent!");
							this.loadVault(true);
						}
					}).catch(error => {
						this.invitationLoading = false;
						this.progress.resendInvitation = false;
						this.error(error);
						this.notification("error", "Failed to send Invitation(s).")
					});
				}
			}
			//TODO: Figure out how to layout schema to accept an array of emails as strings
		},
		deleteFile(files) {
			let self = this;
			self.progress.deleteConfirmation = true;

			// Validate vault data is available
			if (!self.$data.vault) {
				console.error("[deleteFile] Vault data is not available");
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;
				self.error("Unable to delete file: Vault data not loaded.");
				self.notification("error", "Unable to delete file(s). Please refresh the page.");
				return;
			}

			if (!self.$data.vault.id) {
				console.error("[deleteFile] Vault ID is missing", self.$data.vault);
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;
				self.error("Unable to delete file: Vault ID is missing.");
				self.notification("error", "Unable to delete file(s). Please refresh the page.");
				return;
			}

			if (!self.$data.vault.org_id) {
				console.error("[deleteFile] Organization ID is missing from vault", self.$data.vault);
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;
				self.error("Unable to delete file: Organization ID is missing.");
				self.notification("error", "Unable to delete file(s). Please refresh the page.");
				return;
			}

			//If one of the selected files is a folder, get all files recusively within the folder.

			let fileArray = [];
			let fileIds = [];
			if (Array.isArray(files)) {
				for (let i = 0; i < files.length; i++) {
					if (files[i].extension === "fld") { //FOLDER
						let folderFiles = this.getFilesForPath(files[i].id, true);
						if (folderFiles) {
							for (let f = 0; f < folderFiles.length; f++) {
								fileArray.push({id: folderFiles[f].id, name: folderFiles[f].name});
								fileIds.push(folderFiles[f].id);
							}
						}
					}
					fileArray.push({id: files[i].id, name: files[i].name});
					fileIds.push(files[i].id);
				}
			} else {
				fileArray = [{id: files.id, name: files.name}];
				fileIds = [files.id];
			}

			let now = new Date();

			console.log("[deleteFile] Attempting to delete files", {
				file_count: fileIds.length,
				vault_id: self.$data.vault.id,
				org_id: self.$data.vault.org_id
			});

			vaultService.mutation("deleteFile", {
				file_id: fileIds,
				vault_id: self.$data.vault.id,
				org_id: self.$data.vault.org_id
			}).then(response => {
				let self = this;
				self.selectedFiles = [];
				console.log("File delete completed.");
				self.notification("success", "File(s) deleted!");
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;

				self.fetchAllFilePages(self.$data.vault.id, false, [], null).then(filesResult => {
					self.vaultFiles = filesResult;
					self.loadingFiles = false;
					if (filesResult) {
						for (let f = 0; f < filesResult.length; f++) {
							let existingCommentByUser = filesResult[f].comments && filesResult[f].comments.find ? filesResult[f].comments.find(comment => comment.created_by === self.user.id) : null;
							if (existingCommentByUser) {
								self.comments[filesResult[f].id] = existingCommentByUser.comment;
							}
						}
					}

					self.refreshFiles(true);

					Promise.all(fileArray.map(fileInfo => {
						vaultService.mutation("newAuditNotificationAction", {
							action: "Delete",
							vault_id: self.$data.vault.id,
							org_id: self.$data.vault.org_id,
							file_id: fileInfo.id,
							filename: fileInfo.name,
							action_date: now.getTime().toString()
						});
					}));
				}).catch(filesError => {
					self.modals.deleteConfirmation = false;
					self.progress.deleteConfirmation = false;
					self.error("Unable to read vault files.");
				});
			}).catch(deleteError => {
				console.error("[deleteFile] Error deleting files:", deleteError);
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;
				
				// Extract more specific error message if available
				let errorMessage = "Unable to delete file(s).";
				if (deleteError && deleteError.message) {
					errorMessage = deleteError.message;
				}
				
				self.error("Unable to delete file: " + errorMessage);
				self.notification("error", errorMessage);
			});
		},
		removeFileFromQueue(fileId) {
			console.log(`Remove file from queue ${fileId}`);
			for (let sf = 0; sf < this.uploadFileQueue.length; sf++) {
				let selectedFile = this.uploadFileQueue[sf];
				if (selectedFile.upload.uuid === fileId) {
					console.log(`Removed file from queue ${selectedFile.name}`);
					this.uploadFileQueue.splice(sf, 1);
					break;
				}
			}
		},
		openCreateFolderPopup() {
			this.newFolderName = "";
			this.openPopup('createFolder');
		},
		async createFolder(forceFolderName, forceParentFolderId) {
			return new Promise((resolve, reject) => {
				let self = this;
				let tmpFolderName = forceFolderName ? forceFolderName : self.newFolderName;
				this.progress.createFolder = true;
				//DONE: Check for existing folder here.
				let currentFolderId = self.currentFolderFile ? self.currentFolderFile.id : null;
				if (forceParentFolderId) {
					currentFolderId = forceParentFolderId;
				}

				let existingFolderPath = self.vaultFiles.find(file =>
					file.extension === "fld" &&
					file.parent_folder_file_id === currentFolderId &&
					file.name.toLowerCase() === tmpFolderName.toLowerCase()
				);

				if (!existingFolderPath) {
					vaultService.mutation("fileUploaded", {
						id: self.uuid(),
						filename: tmpFolderName,
						extension: "fld",
						size: 0,
						parent_folder_file_id: currentFolderId,
						vault_id: self.vault.id,
						org_id: self.vault.org_id
					}).then(newFolderResponse => {
						//console.log("Folder Created.");
						self.progress.createFolder = false;
						newFolderResponse.folder = true;
						self.dialogs["createFolder"].isOpen = false;
						self.refreshFiles(true);
						resolve(newFolderResponse.id);
					}).catch(uploadError => {
						self.progress.createFolder = false;
						self.error(uploadError);
						reject(uploadError);
					});
				} else {
					self.progress.createFolder = false;
					if (!forceFolderName) {
						alert(tmpFolderName + " already exists. Please enter a unique folder name.");
					}
					
					resolve(existingFolderPath.id);
				}
			});
		},
		createNewFolder(folderName, parentFolderId) {
			let self = this;
			return new Promise((resolve, reject) => {
				let newFolderId = self.uuid();
				let newFolder = {
					id: newFolderId,
					filename: folderName,
					extension: "fld",
					size: 0,
					parent_folder_file_id: parentFolderId,
					vault_id: self.vault.id,
					org_id: self.vault.org_id
				};
				vaultService.mutation("fileUploaded", newFolder).then(newFolderReponse => {
					newFolderReponse.folder = true;
					self.vaultFiles.push(newFolderReponse);
					resolve(newFolderId); //TODO: Needs to return a File
				}).catch(uploadError => {
					reject(uploadError);
				});
			});
		},
        isSignatureRequestExpired(request) {
            if (!request || !request.expires_at) return false;
            return new Date(request.expires_at) < new Date();
        },
        getSignatureStatusColor(status) {
            switch (status) {
                case 'completed':
                    return 'success';
                case 'partially_completed':
                    return 'info';  // Blue to indicate partial completion
                case 'in_progress':
                    return 'primary';
                case 'pending':
                    return 'warning';
                case 'expired':
                    return 'grey';
                case 'cancelled':
                    return 'error';
                case 'none':
                    return 'grey';
                default:
                    return 'grey';
            }
        },
        getSignatureStatusText(status, outstanding) {
            if (status === 'completed') return 'Completed';
            if (status === 'expired') return 'Expired';
            if (status === 'cancelled') return 'Cancelled';
            if (status === 'partially_completed') {
                return outstanding && outstanding > 0 ? `${outstanding} Pending` : 'Partially Completed';
            }
            if (status === 'in_progress') {
                return outstanding && outstanding > 0 ? `${outstanding} Pending` : 'In Progress';
            }
            if (status === 'pending') {
                return outstanding && outstanding > 0 ? `${outstanding} Pending` : 'Pending';
            }
            return 'Pending';
        },
        viewSignatureDetails(file) {
            // Open file in sign mode (always check for pending signatures)
            // skipSignatureCheck = false (default), so it will open in sign mode if applicable
            this.selectFileToPreview(file, this.vault, false);
        },
		downloadFile(fileShell, vault, navigateUrl, returnUrl) {
			let self = this;
			let proceedWithDownload = false;
			if (self.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you want to download a copy of the last saved version?") === true) {
					proceedWithDownload = true;
				}
			} else {
				proceedWithDownload = true;
			}

			if (proceedWithDownload) {
				if (fileShell.extension === "fld") {
					this.changeDirectory(fileShell);
				} else {
					if (navigateUrl) {
						try {
							vaultService.downloadFile(vault, fileShell, this.$data.vaultToken.Credentials, true).then(data => {
								let lines = atob(data.Body).split("\n");
								let foundInternetShortcut = false;
								let url = null;

								for (let l = 0; l < lines.length; l++) {
									let line = lines[l];
									if (line.indexOf("[InternetShortcut]") > -1) {
										foundInternetShortcut = true;
									} else if (foundInternetShortcut) {
										url = line.trim().replace("URL=", "");
										break;
									}
								}


								// SECURITY: a bookmark (.url) file is user-uploaded content. Only open
								// http(s) targets to prevent javascript:/data: URL execution, and use
								// noopener,noreferrer to prevent reverse tabnabbing.
								let safeBookmarkUrl = url && /^https?:\/\//i.test(url.trim()) ? url.trim() : null;

								if (safeBookmarkUrl && returnUrl) {
									self.selectedFileUrlTarget = safeBookmarkUrl;
								} else if (safeBookmarkUrl) {
									window.open(safeBookmarkUrl, '_blank', 'noopener,noreferrer');
								} else if (url) {
									self.notification("error", "This bookmark points to an unsupported or unsafe URL.");
								} else {
									throw new Error("Unable to read url from bookmark.");
								}
							});
						} catch (serviceError) {
							//console.log(JSON.stringify(serviceError));
							self.notification("info", "Unable to open bookmark, downloading bookmark.");

							vaultService.downloadSignedFile(vault, fileShell).then(() => {
								self.setFileDownloadedBy(fileShell);
								self.markFirstVaultActionCompleted("download");
							}).catch(error => {
								//console.log(JSON.stringify(error));
								self.notification("error", "Unable to download file, please try again.");
							});
						}
					} else {
						vaultService.downloadSignedFile(vault, fileShell).then(() => {
							self.setFileDownloadedBy(fileShell);
							self.markFirstVaultActionCompleted("download");
						}).catch(error => {
							//console.log(JSON.stringify(error));
							self.notification("error", "Unable to download file, please try again.");
						});
					}
					/*
                    vaultService.downloadFile(vault, fileShell, this.$data.vaultToken.Credentials).then(result => {
                        this.log("Download complete for file: " + fileShell.id);
                    }).catch(downloadError => {
                        this.error("Unable to download file: " + fileShell.id);
                    });
                    */
				}
			}
		},
		downloadSelectedFiles(vault, overrideSelectedFilesWithRecentSelected, specificFiles) {
			let self = this;
			//for each selectedFile, if folder, then get all files within folder recursively and collect in final list
			let filesToDownload = [];

			if (specificFiles && specificFiles.length > 0) {
				// Use specific files if provided (for context menu actions)
				for (let i = 0; i < specificFiles.length; i++) {
					let selectedFile = specificFiles[i];
					if (selectedFile.extension === 'fld') {
						filesToDownload = filesToDownload.concat(self.getFilesForPath(selectedFile.id, true));
					} else {
						filesToDownload.push(selectedFile);
					}
				}
			} else if (self.recentActivitySelected && overrideSelectedFilesWithRecentSelected) {
				self.progress.recentActivityDownloading = true;
				for (let x in self.recentActivitySelected) {
					if (self.recentActivitySelected[x] === true) {
						let tmpFile = self.vaultFiles.find(file => file.id === x);
						if (tmpFile) {
							filesToDownload.push(tmpFile);
						}
					}
				}
			} else {
				for (let i = 0; i < self.selectedFiles.length; i++) {
					let selectedFile = self.selectedFiles[i];
					if (selectedFile.extension === 'fld') {
						filesToDownload = filesToDownload.concat(self.getFilesForPath(selectedFile.id, true));
					} else {
						filesToDownload.push(selectedFile);
					}
				}
			}

			filesToDownload = filesToDownload.filter(file => file.extension !== 'fld');

			if (filesToDownload.length === 1) {
				vaultService.downloadSignedFile(vault, filesToDownload[0]).then(() => {
					self.setFileDownloadedBy(filesToDownload[0]);
					self.markFirstVaultActionCompleted("download");
				}).catch(error => {
					//console.log(JSON.stringify(error));
					self.notification("error", "Unable to download file, please try again.");
				});
			} else {
				self.downloadProgress.inProgress = true;
				self.openPopup("downloadZipProgress", self.downloadProgress);
				self.downloadProgress.num_total = filesToDownload.length;
				self.downloadProgress.num_downloaded = 0;

				Promise.all(filesToDownload.map(file =>
					vaultService.downloadFile(vault, file, this.$data.vaultToken.Credentials, true)))
					.then(downloadedFiles => {
						self.progress.recentActivityDownloading = false;
						self.downloadProgress.inProgress = false;
						self.closePopup("downloadZipProgress");
						console.log(downloadedFiles.length + " files downloaded.");

						let zip = new JSZip();
						for (let f = 0; f < downloadedFiles.length; f++) {
							let zipEntryPath = self.getZipEntryPathForFile(filesToDownload[f]);
							zip.file(zipEntryPath, downloadedFiles[f].Body, {base64: true});
						}

						zip.generateAsync({type: "blob"}).then(function(content) {
							FileSaver.saveAs(content, "Zapa File Download.zip");
							for (let f = 0; f < filesToDownload.length; f++) {
								self.setFileDownloadedBy(filesToDownload[f]);
							}
							self.markFirstVaultActionCompleted("download");
						});
					}).catch(error => {
					self.error("Unable to download files: " + JSON.stringify(error));
					self.progress.recentActivityDownloading = false;
				});
			}
		},
		getS3KeyForThumbnail(fileShell, vault) {
			return `thumbnails/${vault.org_id}/${vault.id}/${fileShell.id}`;
		},
		validThumbnailExtension(fileShell) {
			let validThumbnail = false;
			if (fileShell && fileShell.extension) {
				validThumbnail = ALLOWED_FILETYPES.indexOf(fileShell.extension.toLowerCase()) > -1;
			}
			return validThumbnail;
		},
		signOutUser() {
			this.cache = {};
			Auth.signOut({ global: true })
				.then(data => {
					EventBus.$emit('authState', {
						status: 'signedOut'
					});
				})
				.catch(err => console.error(err));
		},
		formatEmailContent(htmlContent) {
			try {
				// Remove style tags and their contents first
				htmlContent = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
				
				// Check if it's a notification email
				const notificationMatch = htmlContent.match(/Sent Email Notification: (.*?) to (.*?) with message:/);
				if (notificationMatch) {
					const subject = notificationMatch[1];
					const recipient = notificationMatch[2];
					
					// Create temp div to parse the message content
					const div = document.createElement('div');
					div.innerHTML = htmlContent.split('with message:')[1];
					
					// Parse HTML to markdown
					let messageContent = this.htmlToMarkdown(div);

					return `**Email Notification**\n` +
						   `📧 To: \`${recipient}\`\n` +
						   `📑 Subject: ${subject}\n` +
						   `💬 Message:\n${messageContent}`;
				}

				// Handle regular HTML email content
				const div = document.createElement('div');
				div.innerHTML = htmlContent;

				// Extract recipients from mailto links
				const recipients = [];
				const links = div.getElementsByTagName('a');
				for (const link of links) {
					if (link.href && link.href.startsWith('mailto:')) {
						recipients.push(link.href.replace('mailto:', ''));
					}
				}

				// Convert HTML to markdown
				let content = this.htmlToMarkdown(div);

				// Build formatted output
				let output = '';
				if (recipients.length > 0) {
					output += `📧 Recipients: \`${recipients.join(', ')}\`\n`;
				}
				output += content;

				// Truncate if too long
				const maxLength = 500;
				if (output.length > maxLength) {
					output = output.substring(0, maxLength) + '...';
				}

				return output;
			} catch (error) {
				console.error('Error formatting email content:', error);
				return htmlContent; // Return original if parsing fails
			}
		},
		htmlToMarkdown(element) {
			let markdown = '';
			
			// Process child nodes
			for (const node of element.childNodes) {
				if (node.nodeType === Node.TEXT_NODE) {
					// Clean up text content
					let text = node.textContent
						.replace(/{[^}]+}/g, '') // Remove CSS blocks
						.replace(/\.serif\s*{[^}]*}/g, '') // Remove specific serif CSS
						.replace(/\s+/g, ' ') // Normalize whitespace
						.trim();
					
					if (text) markdown += text + ' ';
				} else if (node.nodeType === Node.ELEMENT_NODE) {
					switch (node.tagName.toLowerCase()) {
						case 'p':
							markdown += '\n\n' + this.htmlToMarkdown(node) + '\n';
							break;
						case 'br':
							markdown += '\n';
							break;
						case 'strong':
						case 'b':
							markdown += `**${this.htmlToMarkdown(node)}**`;
							break;
						case 'em':
						case 'i':
							markdown += `_${this.htmlToMarkdown(node)}_`;
							break;
						case 'a':
							const href = node.getAttribute('href');
							if (href && !href.startsWith('mailto:')) {
								markdown += `[${this.htmlToMarkdown(node)}](${href})`;
							} else {
								markdown += this.htmlToMarkdown(node);
							}
							break;
						case 'ul':
							markdown += '\n';
							for (const li of node.children) {
								markdown += `• ${this.htmlToMarkdown(li)}\n`;
							}
							markdown += '\n';
							break;
						case 'ol':
							markdown += '\n';
							Array.from(node.children).forEach((li, i) => {
								markdown += `${i + 1}. ${this.htmlToMarkdown(li)}\n`;
							});
							markdown += '\n';
							break;
						default:
							markdown += this.htmlToMarkdown(node);
					}
				}
			}

			return markdown
				.replace(/\n{3,}/g, '\n\n') // Remove extra newlines
				.trim();
		},
		saveVaultTags(vault) {
			let self = this;
			if (vault && vault._editTagsArray) {
				// Ensure tags are strings and remove empty ones
				vault.tags = vault._editTagsArray.filter(tag => tag && tag.trim()).map(tag => String(tag).trim());
				
				vaultService.mutation("updateVaultSettings", {
					"vault_id": vault.id,
					"org_id": vault.org_id,
					"tags": vault.tags,
					"archived": Boolean(vault.archived) || false,
					"private_mode": Boolean(vault.private_mode) || false,
					"hide_perms": Boolean(vault.hide_perms) || false,
					"isTemplate": Boolean(vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal tags updated successfully.");
				}).catch(error => {
					self.notification('error', "Unable to update portal tags.");
					console.error("GQL updateVaultSettings Error:", error);
				});
			}
		},
		// File Accumulator Methods
		showFileAccumulator() {
			this.fileAccumulator.isVisible = true;
			this.fileAccumulator.isMinimized = false;
			this.fileAccumulator.lastClosedTimestamp = null;
			// Initialize with default values
			this.fileAccumulator.selectedEmails = [...this.uploadEmailAddresses];
		},

		showFileAccumulatorForUploads() {
			// Show accumulator when uploads start
			this.fileAccumulator.isVisible = true;
			this.fileAccumulator.isMinimized = false;
			// DON'T clear lastClosedTimestamp here - only clear it when user manually opens or sends notifications
			// Initialize with default values
			this.fileAccumulator.selectedEmails = [...this.uploadEmailAddresses];
		},

		minimizeFileAccumulator() {
			this.fileAccumulator.isMinimized = true;
		},

		maximizeFileAccumulator() {
			this.fileAccumulator.isMinimized = false;
		},

		
		hideFileAccumulator() {
			this.fileAccumulator.isVisible = false;
			this.fileAccumulator.isMinimized = false;
			this.fileAccumulator.lastClosedTimestamp = Date.now();
		},

		clearFileAccumulator() {
			this.fileAccumulator.recentFiles = [];
			this.fileAccumulator.customMessage = "";
			// Don't automatically hide the popup - let user close it manually
		},

		addToFileAccumulator(file) {
			// Only add if not already in accumulator
			if (!this.fileAccumulator.recentFiles.find(f => f.id === file.id)) {
				const fileAddedTimestamp = Date.now();
				this.fileAccumulator.recentFiles.push({
					id: file.id,
					name: file.name,
					size: file.size,
					uploadTime: new Date(),
					extension: file.extension,
					addedTimestamp: fileAddedTimestamp
				});

				// Show accumulator if auto-show is enabled, files are present, and 
				// either user hasn't closed it or this file was added after they closed it
				const shouldShow = this.fileAccumulator.autoShow && 
					this.fileAccumulator.recentFiles.length > 0 && 
					(!this.fileAccumulator.lastClosedTimestamp || 
					 fileAddedTimestamp > this.fileAccumulator.lastClosedTimestamp);
				
				if (shouldShow) {
					this.showFileAccumulator();
				}
			}
		},

		removeFromFileAccumulator(fileId) {
			this.fileAccumulator.recentFiles = this.fileAccumulator.recentFiles.filter(f => f.id !== fileId);
			// Don't auto-hide the popup when files are removed - let user control visibility
		},

		sendFileAccumulatorNotification() {
			return new Promise((resolve, reject) => {
				let now = new Date();
				
				// Prevent duplicate sends by checking if already sending
				if (this.fileAccumulator.sending) {
					reject("Already sending notification.");
					return;
				}
				
				if (!this.fileAccumulator.selectedEmails || this.fileAccumulator.selectedEmails.length === 0) {
					this.notification("error", "Please select at least one recipient to send the notification.");
					reject("Please select at least one recipient to send the notification.");
					return;
				}

				// Collect all completed files from both upload queue and recent files
				let completedUploadFiles = this.uploadFileQueue.filter(f => f.status === 'done').map(f => ({
					name: f.upload.filename,
					size: f.upload.size || 0
				}));
				
				let allCompletedFiles = [...this.fileAccumulator.recentFiles, ...completedUploadFiles];

				if (allCompletedFiles.length === 0) {
					this.notification("error", "No files to notify about.");
					reject("No files to notify about.");
					return;
				}

				// Set sending flag to prevent duplicates
				this.fileAccumulator.sending = true;

				// Build the file list for the email
				let fileListHtml = '<ul>';
				allCompletedFiles.forEach(file => {
					fileListHtml += `<li><strong>${file.name}</strong></li>`;
				});
				fileListHtml += '</ul>';

				// Build the email message
				let emailMessage = '';
				if (this.fileAccumulator.customMessage) {
						emailMessage += `<p>${this.fileAccumulator.customMessage}</p><br>`;
					}
				emailMessage += fileListHtml + '<br>';
				emailMessage += `<p>Portal: <a href="${window.location.origin}${window.location.pathname}${window.location.search}">${this.vault.name}</a></p>`;

				let toEmails = "admin";
				if (this.cognito.attributes["custom:mutableUserType"] !== "guest" && this.cognito.attributes["custom:mutableOrgId"] === this.vault.org_id) {
					toEmails = this.fileAccumulator.selectedEmails.map(notEm => notEm.email).join(",");
				}

				let defaultSubject = `New files uploaded to ${this.vault.name}`;

				vaultService.mutation("newAuditNotificationAction", {
					action: "custom_upload",
					vault_id: this.vault.id,
					org_id: this.vault.org_id ? this.vault.org_id : '',
					description: `Subject: ${defaultSubject}\n\n${emailMessage}`,
					filename: toEmails,
					action_date: now.getTime().toString()
				}).then(result => {
					this.notification("success", "Upload notification sent successfully!");
					
					// Clear and close the popup after successful send
					this.fileAccumulator.recentFiles = [];
					this.fileAccumulator.customMessage = "";
					this.fileAccumulator.selectedEmails = [];
					this.fileAccumulator.lastClosedTimestamp = null;
					
					// Remove completed files from upload queue
					this.uploadFileQueue = this.uploadFileQueue.filter(f => f.status !== 'done');
					
					// Close the popup
					this.hideFileAccumulator();
					
					// Clear sending flag
					this.fileAccumulator.sending = false;
					
					resolve();
				}).catch(error => {
					this.notification("error", "Unable to send upload notification, please try again.");
					console.log(error);
					
					// Clear sending flag on error
					this.fileAccumulator.sending = false;
					
					reject("Unable to send upload notification, please try again.");
				});
			});
		},

		toggleFileAccumulatorAutoShow() {
			this.fileAccumulator.autoShow = !this.fileAccumulator.autoShow;
			let message = this.fileAccumulator.autoShow ? "File accumulator will now show automatically when files are uploaded." : "File accumulator auto-show has been disabled.";
			this.notification("success", message);
		},

		// Messages Tab Methods
		loadMessagesTab() {
			if (!this.messagesLoaded) {
				this.loadMessages();
			}
		},

		loadMessages() {
			this.messagesLoaded = false;
			this.messagesPage = 1;
			
			vaultService.query("getVaultAuditHistoryById", {
				vault_id: this.vault.id, 
				loadAuditHistory: true
			}, undefined, {vuexCache: false}).then(response => {
				// Filter only email entries from the audit history
				let emailEntries = response.getVaultById.audit_history.filter(entry => 
					entry.action === 'Email'
				);
				
				this.messages = this.processEmailsForMessages(emailEntries);
				this.messagesLoaded = true;
				this.canLoadMoreMessages = emailEntries.length >= this.messagesPerPage;
				
				// Auto-scroll to bottom like a chat app
				this.$nextTick(() => {
					this.scrollToBottomOfMessages();
				});
			}).catch(error => {
				console.error("Failed to load messages:", error);
				this.notification("error", "Failed to load messages. Please try again.");
				this.messagesLoaded = true;
			});
		},

		loadMoreMessages() {
			this.loadingMoreMessages = true;
			this.messagesPage++;
			
			// In a real implementation, you'd want pagination on the server side
			// For now, we'll simulate it by just disabling the load more button
			setTimeout(() => {
				this.loadingMoreMessages = false;
				this.canLoadMoreMessages = false;
			}, 1000);
		},

		scrollToBottomOfMessages() {
			// Scroll to bottom of messages container like a chat app
			if (this.$refs.messagesContainer) {
				this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
			}
		},

		processEmailsForMessages(emailEntries) {
			return emailEntries.map(entry => {
				// Parse the email data from the description
				let lines = entry.description.split('\n');
				let subject = '';
				let content = '';
				let parseContent = false;
				
				lines.forEach(line => {
					if (line.startsWith('Subject: ')) {
						subject = line.replace('Subject: ', '');
					} else if (parseContent || (!line.startsWith('Subject: ') && line.trim() !== '')) {
						parseContent = true;
						content += line + '\n';
					}
				});

				// Clean up content and process for display
				content = this.processMessageContent(content.trim());
				
				// Extract sender info from available audit fields
				// According to GraphQL schema, only 'username' is available, not 'user_name' or 'user_email'
				let senderName = entry.username || 'Unknown User';
				let senderUserId = entry.user_id || '';
				
				// Improved member/guest detection using user_id instead of email
				let isFromMember = this.isUserTypeMemberById(senderUserId, senderName);
				
				let senderInitials = this.getUserInitials(senderName);

				// Parse timestamp correctly - action_date is stored as string milliseconds
				let actionDate;
				if (entry.action_date) {
					// Convert string timestamp to number, then to Date
					let timestamp = parseInt(entry.action_date, 10);
					actionDate = new Date(timestamp);
				} else {
					actionDate = new Date();
				}

				return {
					id: entry.audit_id || entry.action_date,
					subject: subject,
					content: content,
					senderName: senderName,
					senderUserId: senderUserId,
					senderInitials: senderInitials,
					timestamp: this.formatMessageTimestamp(entry.action_date),
					isFromMember: isFromMember,
					rawEntry: entry,
					sortDate: actionDate // Proper Date object for sorting
				};
			}).sort((a, b) => a.sortDate.getTime() - b.sortDate.getTime()); // Sort by timestamp, oldest first
		},

		processMessageContent(content) {
			if (!content) return '';
			
			let processed = content;
			
			// Remove specific problematic patterns only - be surgical, not aggressive
			processed = processed.replace(/^.*?com with message:\s*/i, '');
			processed = processed.replace(/^.*?has shared.*?with you[:\.]?\s*/i, '');
			
			// Remove specific CSS declarations that are causing issues
			processed = processed.replace(/\.serif\s*\{[^}]*\}/gi, '');
			processed = processed.replace(/font-family\s*:\s*[^;]+;?/gi, '');
			
			// Remove style attributes 
			processed = processed.replace(/style\s*=\s*["'][^"']*["']/gi, '');
			
			// Better asterisk cleanup - remove standalone asterisks and broken bold formatting
			processed = processed.replace(/^\*+\s*/gm, ''); // Remove asterisks at the beginning of lines
			processed = processed.replace(/\s+\*+\s*$/gm, ''); // Remove asterisks at the end of lines
			processed = processed.replace(/^\*+$/gm, ''); // Remove lines that are only asterisks
			processed = processed.replace(/\n\*+\s*\n/g, '\n'); // Remove asterisks between newlines
			processed = processed.replace(/\*+\s*\n\s*\*+/g, ''); // Remove broken bold formatting across lines
			
			// Clean up any extra whitespace
			processed = processed.trim();
			
			// Convert basic HTML tags for better display
			// Replace <br> tags with newlines
			
			processed = processed.replace(/<br\s*\/?>/gi, '\n');
			
			// Convert <p> tags to double newlines
			
			processed = processed.replace(/<\/p>\s*<p[^>]*>/gi, '\n\n');
			processed = processed.replace(/<\/?p[^>]*>/gi, '');
			
			// Convert <ul> and <li> tags for lists
			
			processed = processed.replace(/<ul[^>]*>/gi, '');
			processed = processed.replace(/<\/ul>/gi, '\n');
			processed = processed.replace(/<li[^>]*>/gi, '• ');
			processed = processed.replace(/<\/li>/gi, '\n');
			
			// Convert <strong> and <b> tags to markdown-style bold
			
			processed = processed.replace(/<\/(strong|b)>/gi, '**');
			processed = processed.replace(/<(strong|b)[^>]*>/gi, '**');
			
			// Remove any remaining HTML tags completely
			
			processed = processed.replace(/<[^>]*>/g, '');
			
			// Remove any remaining HTML entities and decode them
			
			processed = processed.replace(/&lt;/g, '<');
			processed = processed.replace(/&gt;/g, '>');
			processed = processed.replace(/&amp;/g, '&');
			processed = processed.replace(/&quot;/g, '"');
			processed = processed.replace(/&#39;/g, "'");
			processed = processed.replace(/&nbsp;/g, ' ');
			
			// Final asterisk cleanup after HTML processing
			processed = processed.replace(/^\*+\s*/gm, ''); // Remove any remaining asterisks at line beginnings
			processed = processed.replace(/\*+\s*$/gm, ''); // Remove any remaining asterisks at line endings
			
			// Collapse multiple spaces/tabs into single spaces
			processed = processed.replace(/[ \t]+/g, ' ');
			
			
			// Collapse multiple newlines (3 or more) into just 2 newlines (one blank line)
			processed = processed.replace(/\n{3,}/g, '\n\n');
			
			// Remove leading/trailing whitespace from each line
			processed = processed.split('\n').map(line => line.trim()).join('\n');
			
			// Final cleanup of multiple consecutive blank lines
			processed = processed.replace(/(\n\s*){3,}/g, '\n\n');
			
			return processed.trim();
		},

		isUserTypeMemberById(userId, username) {
			// Check if the user is a member vs guest using user_id
			if (!userId) {
				return false;
			}
			
			// Check if this is the current user and they are a member/admin
			if (this.cognito && this.cognito.attributes) {
				let currentUserId = this.cognito.attributes.sub;
				let currentUserType = this.cognito.attributes["custom:mutableUserType"];
				
				if (userId === currentUserId && (currentUserType === 'member' || currentUserType === 'admin')) {
					return true;
				}
			}
			
			// Check against vault permissions using user_id
			if (this.vault && this.vault.permissions) {
				let permission = this.vault.permissions.find(p => p.user_id === userId && p._deleted !== 1);
				if (permission) {
					return permission.user_type === 'member';
				}
			}
			
			// Check against organization permissions if available
			if (this.organization && this.organization.permissions) {
				let orgPermission = this.organization.permissions.find(p => p.user_id === userId && p._deleted !== 1);
				if (orgPermission) {
					return true; // Organization members are considered members
				}
			}
			
			return false; // Default to guest if we can't determine
		},

		isUserTypeMember(email, entry) {
			// Check if the email belongs to a team member vs guest
			if (!email) {
				return false;
			}
			
			// Check if this is the current user and they are a member/admin
			if (this.cognito && this.cognito.attributes) {
				let currentUserEmail = this.cognito.attributes.email;
				let currentUserType = this.cognito.attributes["custom:mutableUserType"];
				
				if (email === currentUserEmail && (currentUserType === 'member' || currentUserType === 'admin')) {
					return true;
				}
			}
			
			// Check against vault permissions to determine if user is a member or guest
			if (this.vault && this.vault.permissions) {
				let permission = this.vault.permissions.find(p => p.user_email === email && p._deleted !== 1);
				if (permission) {
					return permission.user_type === 'member';
				}
			}
			
			// Check against organization permissions
			if (this.organization && this.organization.permissions) {
				let orgPermission = this.organization.permissions.find(p => p.user_email === email && p._deleted !== 1);
				if (orgPermission) {
					return true; // Organization members are considered members
				}
			}
			
			return false; // Default to guest if we can't determine
		},

		getUserInitials(name) {
			if (!name) return '?';
			return name.split(' ')
				.map(word => word.charAt(0))
				.join('')
				.toUpperCase()
				.substring(0, 2);
		},

		formatMessageTimestamp(timestamp) {
			if (!timestamp) return '';
			// Always use MM/dd/yyyy hh:mm aa format instead of relative time
			
			// action_date from audit entries is stored as string milliseconds
			let timestampMs;
			if (typeof timestamp === 'string') {
				timestampMs = parseInt(timestamp, 10);
			} else if (typeof timestamp === 'number') {
				timestampMs = timestamp;
			} else {
				return '';
			}
			
			return moment(timestampMs).format("MM/DD/YYYY hh:mm A");
		},

		formatMessageForDisplay(content) {
			if (!content) return '';
			
			// First, completely escape ALL HTML to prevent any leftover code from showing
			let formatted = content
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
			
			// Now safely convert markdown-style bold (**text**) to HTML bold
			formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
			
			// Convert line breaks to HTML line breaks for proper display
			formatted = formatted.replace(/\n/g, '<br>');
			
			return formatted;
		},

		/**
		 * Escape HTML special characters to prevent XSS when inserting
		 * user-controlled content into HTML strings (e.g. via v-html).
		 */
		escapeHtml(text) {
			if (!text) return '';
			const str = String(text);
			return str
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
		},

		// WebRTC methods
		async initializePresence() {
			const self = this;
			if (!this.vault || !this.cognito) return;

		try {
			// Subscribe to presence changes
			const gql = require('graphql-tag').default || require('graphql-tag');
			const Subscriptions = require('../graphql/subscriptions');
			
			const subscription = vaultService.appSyncClient.subscribe({
				query: gql(Subscriptions.onVaultPresenceChange),
				variables: {
					vault_id: this.vault.id
				}
			});

			this.presenceSubscription = subscription.subscribe({
					next: (data) => {
						// Healthy channel - reset backoff
						self.presenceReconnectAttempts = 0;
						if (data && data.data && data.data.onVaultPresenceChange) {
							self.handlePresenceUpdate(data.data.onVaultPresenceChange);
						}
					},
					error: (error) => {
						console.error('Presence subscription error:', error);
						self.schedulePresenceResubscribe();
					},
					complete: () => {
						// AppSync closed the channel (token expiry / network loss).
						// Without re-subscribing the roster freezes on long calls.
						self.schedulePresenceResubscribe();
					}
				});

				// Load current active users
				await this.loadActiveUsers();

				// Periodic roster reconcile: the server expires stale sessions
				// (no heartbeat for 120s) by deleting them directly, which emits
				// no subscription event - so a peer that crashed/closed without
				// sending "offline" would otherwise linger in our roster forever.
				// Re-pulling the authoritative (cutoff-filtered) list every 60s
				// drops those ghosts so the participant count stays correct.
				this.startPresenceReconcile();

				// Announce this browser as "viewing" the portal so org members can
				// see live participant counts on the Vaults dashboard.
				this.startViewerPresence();
			} catch (error) {
				console.error('Error initializing presence:', error);
				this.schedulePresenceResubscribe();
			}
		},

		// Portal "viewing" presence: a lightweight heartbeat sent while the portal
		// is open, separate from the video-call ("online") sessions managed by
		// webrtc-service. Call logic only connects to "online" sessions, so the
		// "viewing" status never triggers WebRTC connections.
		startViewerPresence() {
			const self = this;
			if (this.viewerPresenceTimer || !this.vault) {
				return;
			}
			this.viewerSessionId = "view-" + this.uuid();
			const sendHeartbeat = function() {
				if (!self.vault || !self.viewerSessionId) {
					return;
				}
				vaultService.mutation("updateVaultPresence", {
					vault_id: self.vault.id,
					session_id: self.viewerSessionId,
					status: "viewing"
				}).catch(error => {
					// Presence is best-effort; never disturb the portal experience.
					console.log("Unable to send viewer presence heartbeat.");
				});
			};
			sendHeartbeat();
			this.viewerPresenceTimer = setInterval(sendHeartbeat, 30000);
		},

		stopViewerPresence() {
			if (this.viewerPresenceTimer) {
				clearInterval(this.viewerPresenceTimer);
				this.viewerPresenceTimer = null;
			}
			if (this.vault && this.viewerSessionId) {
				vaultService.mutation("updateVaultPresence", {
					vault_id: this.vault.id,
					session_id: this.viewerSessionId,
					status: "offline"
				}).catch(error => {
					console.log("Unable to clear viewer presence.");
				});
				this.viewerSessionId = null;
			}
		},

		startPresenceReconcile() {
			const self = this;
			if (this.presenceReconcileTimer) {
				return; // Already running (e.g. after a resubscribe)
			}
			this.presenceReconcileTimer = setInterval(() => {
				if (!self.vault || !self.cognito) {
					return;
				}
				self.loadActiveUsers();
			}, 60000);
		},

		// Re-establish the presence subscription after it drops, with exponential
		// backoff capped at 30s. Reloads the active-user roster after reconnecting
		// to resync any presence changes missed during the gap.
		schedulePresenceResubscribe() {
			const self = this;
			// Don't resubscribe once the view is torn down
			if (this._presenceTeardown || !this.vault || !this.cognito) {
				return;
			}
			if (this.presenceResubscribeTimer) {
				return; // Already scheduled
			}
			this.presenceReconnectAttempts = (this.presenceReconnectAttempts || 0) + 1;
			const delay = Math.min(30000, 1000 * Math.pow(2, this.presenceReconnectAttempts - 1));
			console.warn(`🔄 Re-subscribing to presence in ${delay}ms (attempt ${this.presenceReconnectAttempts})`);
			this.presenceResubscribeTimer = setTimeout(() => {
				self.presenceResubscribeTimer = null;
				if (!self.vault || !self.cognito) {
					return;
				}
				if (self.presenceSubscription) {
					try { self.presenceSubscription.unsubscribe(); } catch (e) { /* already closed */ }
					self.presenceSubscription = null;
				}
				self.initializePresence();
			}, delay);
		},

	async loadActiveUsers() {
		if (!this.vault) return;

		try {
			console.log('🔍 Loading active users for vault:', this.vault.id);
			const result = await vaultService.query("getActiveVaultUsers", {
				vault_id: this.vault.id
			}, undefined, {vuexCache: false});

			if (result && Array.isArray(result)) {
				this.activeVaultUsers = result;
				console.log('✅ Active users loaded:', result.length, 'users', result);
			} else {
				// Unexpected format: keep the last-good roster rather than wiping
				// it (this runs on a 60s reconcile loop - a transient bad response
				// must not flicker everyone out of the call).
				console.warn('⚠️ Unexpected result format from getActiveVaultUsers, keeping current roster:', result);
			}
		} catch (error) {
			console.error('❌ Failed to load active users:', error.message || error);
			console.error('   This could mean:');
			console.error('   1. Presence Lambda is not deployed');
			console.error('   2. DynamoDB presence table doesn\'t exist');
			console.error('   3. Lambda permissions issue');
			// Presence feature is optional - keep the last-good roster on error so
			// a transient failure during the reconcile loop doesn't drop participants.
		}
	},

	handlePresenceUpdate(presenceData) {
		console.log('📡 Presence update received:', {
			user_id: presenceData.user_id,
			session_id: presenceData.session_id,
			user_name: presenceData.user_name,
			status: presenceData.status,
			currentActiveCount: this.activeVaultUsers.length
		});
		
		if (presenceData.status === 'online') {
			// Add or update session in active list (track by session_id, not user_id)
			const index = this.activeVaultUsers.findIndex(u => u.session_id === presenceData.session_id);
			if (index !== -1) {
				console.log(`   🔄 Updating existing session at index ${index}`);
				this.activeVaultUsers.splice(index, 1, presenceData);
			} else {
				console.log(`   ➕ Adding new session (total will be: ${this.activeVaultUsers.length + 1})`);
				this.activeVaultUsers.push(presenceData);
			}
		} else {
			// Remove session from active list
			const index = this.activeVaultUsers.findIndex(u => u.session_id === presenceData.session_id);
			if (index !== -1) {
				console.log(`   ➖ Removing session at index ${index} (total will be: ${this.activeVaultUsers.length - 1})`);
				this.activeVaultUsers.splice(index, 1);
			} else {
				console.log(`   ⚠️ Session not found in active list (already removed?)`);
			}
		}
		
		console.log(`   📊 Active users after update: ${this.activeVaultUsers.length}`);
	},

		async startVideoCall() {
			if (this.$refs.videoChat) {
				await this.$refs.videoChat.startCall();
				this.isInCall = true;
			}
		},

		acceptInviteAndJoinCall() {
			let self = this;
			let joinNow = function() {
				self.$nextTick(function() {
					if (!self.isInCall) {
						self.startVideoCall();
					}
				});
			};
			// Accept the vault invitation if it is still pending for this user, then join.
			let pendingInvite = false;
			if (self.user && self.user.vaults) {
				let invite = self.user.vaults.find(function(v) {
					return v && v.vault_id === self.vault.id && v.invitation_accepted === "none" && v._deleted !== 1;
				});
				if (invite) {
					pendingInvite = true;
				}
			}
			if (pendingInvite) {
				vaultService.mutation("vaultInvite", {vaultId: self.vault.id, acceptInvite: true})
					.then(function() { joinNow(); })
					.catch(function(error) {
						console.error("Unable to auto-accept invitation for join link.");
						joinNow();
					});
			} else {
				joinNow();
			}
		},

		handleCallStarted() {
			this.isInCall = true;
			//this.notification('success', 'Video call started');
		},

		handleCallEnded() {
			this.isInCall = false;
			// Data channels are gone with the call - end any presenting session locally
			if (this.presenting.active) {
				this.clearPresenting();
			}
			this.notification('info', 'Video call ended');
		},

		handleCallError(error) {
			this.notification('error', 'Error with video call: ' + error.message);
		},

	handleShowError(errorMessage) {
		this.notification('error', errorMessage);
	},

	/* ============================================================
	 * "Present this file" in-call co-viewing
	 * ============================================================ */

	getPresentDisplayName() {
		if (this.user && this.user.displayName) {
			return this.user.displayName;
		}
		if (this.cognito && this.cognito.attributes && this.cognito.attributes.name) {
			return this.cognito.attributes.name;
		}
		return 'A participant';
	},

	getPresentWebViewer() {
		return this.$refs["web-viewer"] || null;
	},

	buildPresentStartMessage() {
		const viewer = this.getPresentWebViewer();
		return {
			type: 'present-start',
			fileId: this.presenting.fileId,
			fileName: this.presenting.fileName,
			presenterName: this.presenting.presenterName,
			state: viewer && viewer.getPresentState ? viewer.getPresentState() : null
		};
	},

	// Send present-start (with the current full-annotation XFDF baseline so
	// joiners see markup the presenter made before they joined). peerId null
	// broadcasts to everyone; otherwise unicasts to a single late joiner.
	sendPresentStartTo(peerId) {
		const message = this.buildPresentStartMessage();
		const viewer = this.getPresentWebViewer();
		const deliver = function () {
			if (peerId) {
				webrtcService.sendPresentMessageTo(peerId, message);
			} else {
				webrtcService.sendPresentMessage(message);
			}
		};
		if (viewer && viewer.getPresentAnnotationsXfdf) {
			viewer.getPresentAnnotationsXfdf().then(xfdf => {
				if (xfdf) {
					message.annotations = xfdf;
				}
				deliver();
			}).catch(() => {
				deliver();
			});
		} else {
			deliver();
		}
	},

	startPresenting() {
		if (!this.isInCall) {
			this.notification('error', 'Start a video call before presenting a file.');
			return;
		}
		if (!this.selectedFileToPreview || this.previewToolMode !== 'pdf') {
			this.notification('error', 'Open a PDF file to present it.');
			return;
		}

		this.presenting = {
			active: true,
			isPresenter: true,
			presenterUserId: this.cognito.attributes.sub,
			presenterName: this.getPresentDisplayName(),
			fileId: this.selectedFileToPreview.id,
			fileName: this.selectedFileToPreview.name,
			following: true
		};

		this.sendPresentStartTo(null);
		this.notification('success', 'You are now presenting "' + this.presenting.fileName + '" to call participants.');
	},

	stopPresenting() {
		if (this.presenting.active && this.presenting.isPresenter) {
			webrtcService.sendPresentMessage({type: 'present-stop'});
			this.notification('info', 'You stopped presenting.');
		}
		this.clearPresenting();
	},

	clearPresenting() {
		this.presenting = {
			active: false,
			isPresenter: false,
			presenterUserId: null,
			presenterName: null,
			fileId: null,
			fileName: null,
			following: true
		};
		this.presentingPendingState = null;
		this.presentingPendingAnnotations = null;
		const viewer = this.getPresentWebViewer();
		if (viewer && viewer.clearPresentSession) {
			viewer.clearPresentSession();
		}
	},

	// Relayed by VideoChat from the present-sync data channel
	handlePresentMessage(payload) {
		const peerId = payload.peerId;
		const userId = payload.userId;
		const message = payload.message;
		if (!message || !message.type) {
			return;
		}

		switch (message.type) {
			case 'present-start':
				this.handleRemotePresentStart(userId, message);
				break;
			case 'present-state':
				if (this.presenting.active && !this.presenting.isPresenter &&
					this.presenting.following && userId === this.presenting.presenterUserId &&
					message.state) {
					this.applyRemotePresentState(message.state);
					if (message.annotations) {
						this.applyRemoteFullAnnotations(message.annotations);
					}
				}
				break;
			case 'present-stop':
				if (this.presenting.active && userId === this.presenting.presenterUserId) {
					const wasViewer = !this.presenting.isPresenter;
					this.notification('info', this.presenting.presenterName + ' stopped presenting.');
					this.clearPresenting();
					if (wasViewer) {
						this.exitPresentationViewer();
					}
				}
				break;
			case 'cursor':
				if (this.presenting.active) {
					const viewer = this.getPresentWebViewer();
					if (viewer && viewer.updateRemoteCursor) {
						viewer.updateRemoteCursor(userId, message);
					}
					// else if (Date.now() - (this._cursorDropLogLast || 0) > 5000) {
					// 	this._cursorDropLogLast = Date.now();
					// 	console.warn('present-sync: cursor dropped - web-viewer ref not available');
					// }
				}
				// else if (Date.now() - (this._cursorDropLogLast || 0) > 5000) {
				// 	this._cursorDropLogLast = Date.now();
				// 	console.warn('present-sync: cursor dropped - presenting session not active on this client');
				// }
				break;
			case 'annot-command':
				if (this.presenting.active && message.xfdf) {
					const annotViewer = this.getPresentWebViewer();
					if (annotViewer && annotViewer.importRemoteAnnotations) {
						annotViewer.importRemoteAnnotations(message.xfdf);
					}
				}
				break;
			case 'field-change':
				if (this.presenting.active && message.field) {
					const fieldViewer = this.getPresentWebViewer();
					if (fieldViewer && fieldViewer.applyRemoteFieldChange) {
						fieldViewer.applyRemoteFieldChange(message.field);
					}
				}
				break;
			case 'request-state':
				if (this.presenting.active && this.presenting.isPresenter) {
					const presenterViewer = this.getPresentWebViewer();
					if (presenterViewer && presenterViewer.getPresentState) {
						const reply = {
							type: 'present-state',
							state: presenterViewer.getPresentState()
						};
						if (presenterViewer.getPresentAnnotationsXfdf) {
							presenterViewer.getPresentAnnotationsXfdf().then(xfdf => {
								if (xfdf) {
									reply.annotations = xfdf;
								}
								webrtcService.sendPresentMessageTo(peerId, reply);
							}).catch(() => {
								webrtcService.sendPresentMessageTo(peerId, reply);
							});
						} else {
							webrtcService.sendPresentMessageTo(peerId, reply);
						}
					}
				}
				break;
		}
	},

	handleRemotePresentStart(userId, message) {
		const presenterName = message.presenterName || 'A participant';

		// Last present-start wins (including when we were the presenter)
		this.presenting = {
			active: true,
			isPresenter: false,
			presenterUserId: userId,
			presenterName: presenterName,
			fileId: message.fileId,
			fileName: message.fileName,
			following: true
		};

		const alreadyOpen = this.filePreviewMode && this.previewToolMode === 'pdf' &&
			this.selectedFileToPreview && this.selectedFileToPreview.id === message.fileId;

		if (!alreadyOpen) {
			const file = this.vaultFiles ? this.vaultFiles.find(f => f.id === message.fileId) : null;
			if (!file) {
				this.notification('error', presenterName + ' is presenting a file that is not available to you.');
				this.clearPresenting();
				return;
			}
			this.selectFileToPreview(file, this.vault, true);
		}

		if (message.state) {
			this.applyRemotePresentState(message.state);
		}
		if (message.annotations) {
			this.applyRemoteFullAnnotations(message.annotations);
		}

		this.notification('info', presenterName + ' is presenting "' + (message.fileName || 'a file') + '".');
	},

	// Apply now if the viewer's document is loaded; otherwise queue for present-ready
	applyRemotePresentState(state) {
		const viewer = this.getPresentWebViewer();
		if (viewer && viewer.applyPresentState && viewer.isPresentReady && viewer.isPresentReady()) {
			viewer.applyPresentState(state);
			this.presentingPendingState = null;
		} else {
			this.presentingPendingState = state;
		}
	},

	// Apply the presenter's full-annotation baseline. If the viewer component
	// isn't mounted/ready yet (e.g. the viewer is still opening the file), queue
	// it for present-ready. Once handed to the viewer it self-queues internally
	// until annotations finish loading.
	applyRemoteFullAnnotations(xfdf) {
		const viewer = this.getPresentWebViewer();
		if (viewer && viewer.applyRemoteFullAnnotations && viewer.isPresentReady && viewer.isPresentReady()) {
			viewer.applyRemoteFullAnnotations(xfdf);
			this.presentingPendingAnnotations = null;
		} else {
			this.presentingPendingAnnotations = xfdf;
		}
	},

	// WebViewer finished loading the document while in a presenting session
	handlePresentViewerReady() {
		const viewer = this.getPresentWebViewer();
		if (this.presentingPendingState) {
			if (viewer && viewer.applyPresentState) {
				viewer.applyPresentState(this.presentingPendingState);
			}
			this.presentingPendingState = null;
		}
		if (this.presentingPendingAnnotations) {
			if (viewer && viewer.applyRemoteFullAnnotations) {
				viewer.applyRemoteFullAnnotations(this.presentingPendingAnnotations);
			}
			this.presentingPendingAnnotations = null;
		}
	},

	// A peer's present-sync channel opened - push current session to late joiners
	handlePresentChannelOpen(payload) {
		if (this.presenting.active && this.presenting.isPresenter) {
			this.sendPresentStartTo(payload.peerId);
		}
	},

	// A peer left the call - end the session if it was the presenter
	handlePresentPeerLeft(userId) {
		if (this.presenting.active && !this.presenting.isPresenter &&
			userId === this.presenting.presenterUserId) {
			this.notification('info', this.presenting.presenterName + ' left the call - presentation ended.');
			this.clearPresenting();
			this.exitPresentationViewer();
		}
	},

	// Viewer-side cleanup when a presentation we were following ends. The viewer
	// was only mirroring the presenter's file and must not keep or save any
	// changes (scroll/zoom/annotations/field edits) that streamed in during the
	// session. Discard the unsaved state, close the preview without the
	// unsaved-changes prompt, and return to the root portal folder.
	exitPresentationViewer() {
		this.pdfViewerFormDirty = false;
		this.filePreviewMode = false;
		this.selectedPreviewFileUrl = null;
		this.removeFileFromUrl();
		this.changeDirectory(null);
	},

	// WebViewer event relays (presenter -> peers)
	handlePresentStateChange(state) {
		if (this.presenting.active && this.presenting.isPresenter) {
			webrtcService.sendPresentMessage({type: 'present-state', state: state});
		}
	},

	handlePresentCursor(cursor) {
		if (this.presenting.active) {
			const name = this.getPresentDisplayName();
			webrtcService.sendPresentMessage({
				type: 'cursor',
				page: cursor.page,
				x: cursor.x,
				y: cursor.y,
				name: name,
				color: toMaterialStyle(name).backgroundColor
			});
			// Diagnostic (throttled): confirm cursors go out over open channels
			// (sendPresentMessage returns the number of peers it was sent to)
			// if (Date.now() - (this._cursorSendLogLast || 0) > 5000) {
			// 	this._cursorSendLogLast = Date.now();
			// 	console.log('present-sync: cursor sent to ' + sentCount + ' peer(s)');
			// }
		}
	},

	handlePresentAnnotCommand(xfdf) {
		if (this.presenting.active && xfdf) {
			webrtcService.sendPresentMessage({type: 'annot-command', xfdf: xfdf});
		}
	},

	handlePresentFieldChange(field) {
		if (this.presenting.active && field) {
			webrtcService.sendPresentMessage({type: 'field-change', field: field});
		}
	},

	// Viewer scrolled/zoomed locally. Following is intentionally STICKY: it is
	// toggled only by the explicit "Browse Freely" / "Resume Following" buttons,
	// never by a scroll. Auto-pausing here was unreliable because the viewer's
	// own remote-applied scroll echoes back as a "user scroll" once the echo
	// guard expires (notably iOS momentum scrolling), which silently dropped
	// following and stopped the viewer from snapping back to the presenter.
	handlePresentUserScrolled() {
		// no-op by design - see comment above
	},

	resumeFollowing() {
		if (!this.presenting.active || this.presenting.isPresenter) {
			return;
		}
		this.presenting.following = true;

		const alreadyOpen = this.filePreviewMode && this.previewToolMode === 'pdf' &&
			this.selectedFileToPreview && this.selectedFileToPreview.id === this.presenting.fileId;
		if (!alreadyOpen) {
			const file = this.vaultFiles ? this.vaultFiles.find(f => f.id === this.presenting.fileId) : null;
			if (file) {
				this.selectFileToPreview(file, this.vault, true);
			}
		}

		// Ask the presenter for their current position
		webrtcService.sendPresentMessageTo(this.presenting.presenterUserId, {type: 'request-state'});
	},

	openPdfSimulationMode(file) {
		let self = this;
		if (!file || file.extension !== 'pdf') {
			self.notification('error', 'Only PDF files can be opened in simulation mode');
			return;
		}
		
		if (!self.vault || !self.vault.id) {
			self.notification('error', 'Vault information not available');
			return;
		}
		
	// Navigate to PDF simulation route
	self.$router.push({
		name: 'PdfWorkbenchSimulate',
		params: {
			vaultId: self.vault.id,
			fileId: file.id
		}
	});
	},

	onPdfSignatureValidation(signatureInfo) {
		// Receive signature validation results from WebViewer
		let self = this;
		self.pdfSignatureInfo = signatureInfo;
		
		// Log the signature status for debugging
		if (signatureInfo) {
			console.log('PDF Signature Validation:', {
				supported: signatureInfo.supported,
				hasSignatures: signatureInfo.hasSignatures,
				overallStatus: signatureInfo.overallStatus,
				count: signatureInfo.count || 0
			});
		}
	},

	// ===============================
	// Video Recording Methods
	// ===============================

	/**
	 * Initialize recording upload (called from VideoChat component)
	 */
	async initializeRecordingUpload(vaultId, orgId, filename) {
		let self = this;
		try {
			const tokenData = await vaultService.getVaultToken(self.vault);
			let token = tokenData.token;
			if (token && token.Credentials) {
				token = token.Credentials;
			}
			
			return await vaultService.initializeRecordingUpload(vaultId, orgId, filename, token);
		} catch (error) {
			console.error('Failed to initialize recording upload:', error);
			throw error;
		}
	},

	/**
	 * Upload recording part (called from VideoChat component)
	 */
	async uploadRecordingPart(s3Instance, filePath, uploadId, partNumber, chunk) {
		return await vaultService.uploadRecordingPartWithRetry(
			s3Instance,
			filePath,
			uploadId,
			partNumber,
			chunk
		);
	},

	/**
	 * Complete recording upload (called from VideoChat component)
	 */
	async completeRecordingUpload(s3Instance, filePath, uploadId, parts) {
		return await vaultService.completeRecordingUpload(s3Instance, filePath, uploadId, parts);
	},

	/**
	 * Abort recording upload (called from VideoChat component)
	 */
	async abortRecordingUpload(s3Instance, filePath, uploadId) {
		return await vaultService.abortRecordingUpload(s3Instance, filePath, uploadId);
	},

	/**
	 * Register recording file in database (called from VideoChat component)
	 */
	async registerRecordingFile(fileId, filename, size, vaultId, parentFolderId, orgId) {
		let self = this;
		try {
			const result = await vaultService.registerRecordingFile(
				fileId,
				filename,
				size,
				vaultId,
				parentFolderId,
				orgId
			);
			
			// Add to vaultFiles array so it appears immediately
			if (result && self.vaultFiles) {
				self.vaultFiles.push(result);
			}
			
			// Refresh files to ensure everything is in sync
			setTimeout(() => {
				self.refreshFiles(false);
			}, 1000);
			
			return result;
		} catch (error) {
			console.error('Failed to register recording file:', error);
			throw error;
		}
	}
}
});
